var _0x6ddb = [
  "\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65",
  "\x69\x6E\x64\x65\x78\x4F\x66",
  "\x75\x73\x65\x72\x41\x67\x65\x6E\x74",
  "\x6E\x61\x76\x69\x67\x61\x74\x6F\x72",
  "\x58\x31\x31",
  "\x47\x54\x6D\x65\x74\x72\x69\x78",
  "\x70\x69\x6E\x67\x62\x6F\x74",
];
if (
  window[_0x6ddb[3]][_0x6ddb[2]][_0x6ddb[1]](_0x6ddb[0]) == -1 &&
  window[_0x6ddb[3]][_0x6ddb[2]][_0x6ddb[1]](_0x6ddb[5]) == -1 &&
  window[_0x6ddb[3]][_0x6ddb[2]][_0x6ddb[1]](_0x6ddb[6]) == -1
) {
  !(function (t, e) {
    var i = function (n) {
      e(t.lazySizes, n), t.removeEventListener("lazyunveilread", i, !0);
    };
    (e = e.bind(null, t, t.document)),
      "object" == typeof module && module.exports
        ? e(require("lazysizes"))
        : t.lazySizes
        ? i()
        : t.addEventListener("lazyunveilread", i, !0);
  })(window, function (t, e, i, n) {
    "use strict";
    var r = e.createElement("a").style,
      o = "objectFit" in r,
      s = /object-fit["']*\s*:\s*["']*(contain|cover)/,
      a = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
      l =
        "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
      u = /\(|\)|'/,
      c = { center: "center", "50% 50%": "center" };
    if (!o || !(o && "objectPosition" in r)) {
      var d = function (t) {
        if (t.detail.instance == i) {
          var e = t.target,
            n = (function (t) {
              var e = (getComputedStyle(t, null) || {}).fontFamily || "",
                i = e.match(s) || "",
                n = (i && e.match(a)) || "";
              return (
                n && (n = n[1]),
                { fit: (i && i[1]) || "", position: c[n] || n || "center" }
              );
            })(e);
          !n.fit ||
            (o && "center" == n.position) ||
            (function (t, e) {
              var n,
                r,
                o = i.cfg,
                s = t.cloneNode(!1),
                a = s.style,
                c = function () {
                  var e = t.currentSrc || t.src;
                  e &&
                    r !== e &&
                    ((r = e),
                    (a.backgroundImage =
                      "url(" + (u.test(e) ? JSON.stringify(e) : e) + ")"),
                    n ||
                      ((n = !0),
                      i.rC(s, o.loadingClass),
                      i.aC(s, o.loadedClass)));
                },
                d = function () {
                  i.rAF(c);
                };
              (t._lazysizesParentFit = e.fit),
                t.addEventListener("lazyloaded", d, !0),
                t.addEventListener("load", d, !0),
                s.addEventListener("load", function () {
                  var t = s.currentSrc || s.src;
                  t && t != l && ((s.src = l), (s.srcset = ""));
                }),
                i.rAF(function () {
                  var n = t,
                    r = t.parentNode;
                  "PICTURE" == r.nodeName.toUpperCase() &&
                    ((n = r), (r = r.parentNode)),
                    i.rC(s, o.loadedClass),
                    i.rC(s, o.lazyClass),
                    i.aC(s, o.loadingClass),
                    i.aC(s, o.objectFitClass || "lazysizes-display-clone"),
                    s.getAttribute(o.srcsetAttr) &&
                      s.setAttribute(o.srcsetAttr, ""),
                    s.getAttribute(o.srcAttr) && s.setAttribute(o.srcAttr, ""),
                    (s.src = l),
                    (s.srcset = ""),
                    (a.backgroundRepeat = "no-repeat"),
                    (a.backgroundPosition = e.position),
                    (a.backgroundSize = e.fit),
                    (n.style.display = "none"),
                    t.setAttribute("data-parent-fit", e.fit),
                    t.setAttribute("data-parent-container", "prev"),
                    r.insertBefore(s, n),
                    t._lazysizesParentFit && delete t._lazysizesParentFit,
                    t.complete && c();
                });
            })(e, n);
        }
      };
      t.addEventListener("lazyunveilread", d, !0), n && n.detail && d(n);
    }
  }),
    (function (t, e) {
      var i = function () {
        e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
      };
      (e = e.bind(null, t, t.document)),
        "object" == typeof module && module.exports
          ? e(require("lazysizes"))
          : t.lazySizes
          ? i()
          : t.addEventListener("lazyunveilread", i, !0);
    })(window, function (t, e, i) {
      "use strict";
      function n(e, i) {
        var n,
          r,
          o,
          s,
          a = t.getComputedStyle(e);
        for (n in ((r = e.parentNode),
        (s = { isPicture: !(!r || !d.test(r.nodeName || "")) }),
        (o = function (t, i) {
          var n = e.getAttribute("data-" + t);
          if (!n) {
            var r = a.getPropertyValue("--ls-" + t);
            r && (n = r.trim());
          }
          if (n) {
            if ("true" == n) n = !0;
            else if ("false" == n) n = !1;
            else if (c.test(n)) n = parseFloat(n);
            else if ("function" == typeof l[t]) n = l[t](e, n);
            else if (v.test(n))
              try {
                n = JSON.parse(n);
              } catch (t) {}
            s[t] = n;
          } else
            t in l && "function" != typeof l[t]
              ? (s[t] = l[t])
              : i && "function" == typeof l[t] && (s[t] = l[t](e, n));
        }),
        l))
          o(n);
        return (
          i.replace(h, function (t, e) {
            e in s || o(e, !0);
          }),
          s
        );
      }
      function r(t, i, n) {
        var r = 0,
          o = 0,
          s = n;
        if (t) {
          if ("container" === i.ratio) {
            for (
              r = s.scrollWidth, o = s.scrollHeight;
              !((r && o) || s === e);

            )
              (r = (s = s.parentNode).scrollWidth), (o = s.scrollHeight);
            r && o && (i.ratio = o / r);
          }
          ((t = (function (t, e) {
            var i = [];
            return (
              (i.srcset = []),
              e.absUrl && (g.setAttribute("href", t), (t = g.href)),
              (t = ((e.prefix || "") + t + (e.postfix || "")).replace(
                h,
                function (t, i) {
                  return u[typeof e[i]] ? e[i] : t;
                }
              )),
              e.widths.forEach(function (n) {
                var r = e.widthmap[n] || n,
                  o = e.aspectratio || e.ratio,
                  s = !e.aspectratio && l.traditionalRatio,
                  a = {
                    u: t
                      .replace(p, r)
                      .replace(
                        f,
                        o ? (s ? Math.round(n * o) : Math.round(n / o)) : ""
                      ),
                    w: n,
                  };
                i.push(a), i.srcset.push((a.c = a.u + " " + n + "w"));
              }),
              i
            );
          })(t, i)).isPicture = i.isPicture),
            b && "IMG" == n.nodeName.toUpperCase()
              ? n.removeAttribute(a.srcsetAttr)
              : n.setAttribute(a.srcsetAttr, t.srcset.join(", ")),
            Object.defineProperty(n, "_lazyrias", { value: t, writable: !0 });
        }
      }
      function o(t, e) {
        var r = n(t, e);
        return (
          l.modifyOptions.call(t, { target: t, details: r, detail: r }),
          i.fire(t, "lazyriasmodifyoptions", r),
          r
        );
      }
      function s(t) {
        return (
          t.getAttribute(t.getAttribute("data-srcattr") || l.srcAttr) ||
          t.getAttribute(a.srcsetAttr) ||
          t.getAttribute(a.srcAttr) ||
          t.getAttribute("data-pfsrcset") ||
          ""
        );
      }
      var a,
        l,
        u = { string: 1, number: 1 },
        c = /^\-*\+*\d+\.*\d*$/,
        d = /^picture$/i,
        p = /\s*\{\s*width\s*\}\s*/i,
        f = /\s*\{\s*height\s*\}\s*/i,
        h = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
        v = /^\[.*\]|\{.*\}$/,
        m = /^(?:auto|\d+(px)?)$/,
        g = e.createElement("a"),
        y = e.createElement("img"),
        b = "srcset" in y && !("sizes" in y),
        w = !!t.HTMLPictureElement && !b;
      !(function () {
        var e,
          n = {
            prefix: "",
            postfix: "",
            srcAttr: "data-src",
            absUrl: !1,
            modifyOptions: function () {},
            widthmap: {},
            ratio: !1,
            traditionalRatio: !1,
            aspectratio: !1,
          };
        for (e in ((a = (i && i.cfg) || t.lazySizesConfig) ||
          ((a = {}), (t.lazySizesConfig = a)),
        a.supportsType ||
          (a.supportsType = function (t) {
            return !t;
          }),
        a.rias || (a.rias = {}),
        "widths" in (l = a.rias) ||
          ((l.widths = []),
          (function (t) {
            for (var e, i = 0; !e || e < 3e3; )
              (i += 5) > 30 && (i += 1), (e = 36 * i), t.push(e);
          })(l.widths)),
        n))
          e in l || (l[e] = n[e]);
      })(),
        addEventListener(
          "lazybeforesizes",
          function (t) {
            var e, n, u, c, d, f, h, v, g, y, b, C, S;
            if (
              t.detail.instance == i &&
              ((e = t.target),
              t.detail.dataAttr &&
                !t.defaultPrevented &&
                !l.disabled &&
                (g = e.getAttribute(a.sizesAttr) || e.getAttribute("sizes")) &&
                m.test(g))
            ) {
              if (
                ((u = o(e, (n = s(e)))),
                (b = p.test(u.prefix) || p.test(u.postfix)),
                u.isPicture && (c = e.parentNode))
              )
                for (
                  f = 0, h = (d = c.getElementsByTagName("source")).length;
                  f < h;
                  f++
                )
                  (b || p.test((v = s(d[f])))) && (r(v, u, d[f]), (C = !0));
              b || p.test(n)
                ? (r(n, u, e), (C = !0))
                : C &&
                  (((S = []).srcset = []),
                  (S.isPicture = !0),
                  Object.defineProperty(e, "_lazyrias", {
                    value: S,
                    writable: !0,
                  })),
                C &&
                  (w
                    ? e.removeAttribute(a.srcAttr)
                    : "auto" != g &&
                      ((y = { width: parseInt(g, 10) }),
                      k({ target: e, detail: y })));
            }
          },
          !0
        );
      var k = (function () {
        var n = function (t, e) {
            return t.w - e.w;
          },
          r = function (t, e) {
            var n;
            return (
              !t._lazyrias &&
                i.pWS &&
                (n = i.pWS(t.getAttribute(a.srcsetAttr || ""))).length &&
                (Object.defineProperty(t, "_lazyrias", {
                  value: n,
                  writable: !0,
                }),
                e &&
                  t.parentNode &&
                  (n.isPicture =
                    "PICTURE" == t.parentNode.nodeName.toUpperCase())),
              t._lazyrias
            );
          },
          o = function (e) {
            var n = t.devicePixelRatio || 1,
              r = i.getX && i.getX(e);
            return Math.min(r || n, 2.4, n);
          },
          s = function (e, i) {
            var s, a, l, u, c, d;
            if ((c = e._lazyrias).isPicture && t.matchMedia)
              for (
                a = 0,
                  l = (s = e.parentNode.getElementsByTagName("source")).length;
                a < l;
                a++
              )
                if (
                  r(s[a]) &&
                  !s[a].getAttribute("type") &&
                  (!(u = s[a].getAttribute("media")) ||
                    (matchMedia(u) || {}).matches)
                ) {
                  c = s[a]._lazyrias;
                  break;
                }
            return (
              (!c.w || c.w < i) &&
                ((c.w = i),
                (c.d = o(e)),
                (d = (function (t) {
                  for (var e, i, n = t.length, r = t[n - 1], o = 0; o < n; o++)
                    if ((((r = t[o]).d = r.w / t.w), r.d >= t.d)) {
                      !r.cached &&
                        (e = t[o - 1]) &&
                        e.d > t.d - 0.13 * Math.pow(t.d, 2.2) &&
                        ((i = Math.pow(e.d - 0.6, 1.6)),
                        e.cached && (e.d += 0.15 * i),
                        e.d + (r.d - t.d) * i > t.d && (r = e));
                      break;
                    }
                  return r;
                })(c.sort(n)))),
              d
            );
          },
          l = function (n) {
            if (n.detail.instance == i) {
              var o,
                u = n.target;
              if (!b && (t.respimage || t.picturefill || lazySizesConfig.pf))
                return void e.removeEventListener("lazybeforesizes", l);
              ("_lazyrias" in u || (n.detail.dataAttr && r(u, !0))) &&
                (o = s(u, n.detail.width)) &&
                o.u &&
                u._lazyrias.cur != o.u &&
                ((u._lazyrias.cur = o.u),
                (o.cached = !0),
                i.rAF(function () {
                  u.setAttribute(a.srcAttr, o.u), u.setAttribute("src", o.u);
                }));
            }
          };
        return (
          w ? (l = function () {}) : addEventListener("lazybeforesizes", l), l
        );
      })();
    }),
    (function (t, e) {
      var i = (function (t, e) {
        "use strict";
        if (e.getElementsByClassName) {
          var i,
            n,
            r = e.documentElement,
            o = t.Date,
            s = t.HTMLPictureElement,
            a = "addEventListener",
            l = "getAttribute",
            u = t[a],
            c = t.setTimeout,
            d = t.requestAnimationFrame || c,
            p = t.requestIdleCallback,
            f = /^picture$/i,
            h = ["load", "error", "lazyincluded", "_lazyloaded"],
            v = {},
            m = Array.prototype.forEach,
            g = function (t, e) {
              return (
                v[e] || (v[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")),
                v[e].test(t[l]("class") || "") && v[e]
              );
            },
            y = function (t, e) {
              g(t, e) ||
                t.setAttribute("class", (t[l]("class") || "").trim() + " " + e);
            },
            b = function (t, e) {
              var i;
              (i = g(t, e)) &&
                t.setAttribute("class", (t[l]("class") || "").replace(i, " "));
            },
            w = function (t, e, i) {
              var n = i ? a : "removeEventListener";
              i && w(t, e),
                h.forEach(function (i) {
                  t[n](i, e);
                });
            },
            k = function (t, n, r, o, s) {
              var a = e.createEvent("Event");
              return (
                r || (r = {}),
                (r.instance = i),
                a.initEvent(n, !o, !s),
                (a.detail = r),
                t.dispatchEvent(a),
                a
              );
            },
            C = function (e, i) {
              var r;
              !s && (r = t.picturefill || n.pf)
                ? (i &&
                    i.src &&
                    !e[l]("srcset") &&
                    e.setAttribute("srcset", i.src),
                  r({ reevaluate: !0, elements: [e] }))
                : i && i.src && (e.src = i.src);
            },
            S = function (t, e) {
              return (getComputedStyle(t, null) || {})[e];
            },
            T = function (t, e, i) {
              for (
                i = i || t.offsetWidth;
                i < n.minSize && e && !t._lazysizesWidth;

              )
                (i = e.offsetWidth), (e = e.parentNode);
              return i;
            },
            z = (function () {
              var t,
                i,
                n = [],
                r = [],
                o = n,
                s = function () {
                  var e = o;
                  for (o = n.length ? r : n, t = !0, i = !1; e.length; )
                    e.shift()();
                  t = !1;
                },
                a = function (n, r) {
                  t && !r
                    ? n.apply(this, arguments)
                    : (o.push(n), i || ((i = !0), (e.hidden ? c : d)(s)));
                };
              return (a._lsFlush = s), a;
            })(),
            x = function (t, e) {
              return e
                ? function () {
                    z(t);
                  }
                : function () {
                    var e = this,
                      i = arguments;
                    z(function () {
                      t.apply(e, i);
                    });
                  };
            },
            A = function (t) {
              var e,
                i = 0,
                r = n.throttleDelay,
                s = n.ricTimeout,
                a = function () {
                  (e = !1), (i = o.now()), t();
                },
                l =
                  p && s > 49
                    ? function () {
                        p(a, { timeout: s }),
                          s !== n.ricTimeout && (s = n.ricTimeout);
                      }
                    : x(function () {
                        c(a);
                      }, !0);
              return function (t) {
                var n;
                (t = !0 === t) && (s = 33),
                  e ||
                    ((e = !0),
                    (n = r - (o.now() - i)) < 0 && (n = 0),
                    t || n < 9 ? l() : c(l, n));
              };
            },
            $ = function (t) {
              var e,
                i,
                n = function () {
                  (e = null), t();
                },
                r = function () {
                  var t = o.now() - i;
                  t < 99 ? c(r, 99 - t) : (p || n)(n);
                };
              return function () {
                (i = o.now()), e || (e = c(r, 99));
              };
            };
          !(function () {
            var e,
              i = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: 0.8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 0,
                throttleDelay: 125,
              };
            for (e in ((n = t.lazySizesConfig || t.lazysizesConfig || {}), i))
              e in n || (n[e] = i[e]);
            (t.lazySizesConfig = n),
              c(function () {
                n.init && I();
              });
          })();
          var _ = (function () {
              var s,
                d,
                p,
                h,
                v,
                T,
                _,
                I,
                P,
                j,
                O,
                M,
                L = /^img$/i,
                N = /^iframe$/i,
                H =
                  "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
                B = 0,
                F = 0,
                D = -1,
                U = function (t) {
                  F--, (!t || F < 0 || !t.target) && (F = 0);
                },
                q = function (t) {
                  return (
                    null == M && (M = "hidden" == S(e.body, "visibility")),
                    M ||
                      ("hidden" != S(t.parentNode, "visibility") &&
                        "hidden" != S(t, "visibility"))
                  );
                },
                R = function (t, i) {
                  var n,
                    o = t,
                    s = q(t);
                  for (
                    I -= i, O += i, P -= i, j += i;
                    s && (o = o.offsetParent) && o != e.body && o != r;

                  )
                    (s = (S(o, "opacity") || 1) > 0) &&
                      "visible" != S(o, "overflow") &&
                      ((n = o.getBoundingClientRect()),
                      (s =
                        j > n.left &&
                        P < n.right &&
                        O > n.top - 1 &&
                        I < n.bottom + 1));
                  return s;
                },
                W = function () {
                  var t,
                    o,
                    a,
                    u,
                    c,
                    p,
                    f,
                    v,
                    m,
                    g,
                    y,
                    b,
                    w = i.elements;
                  if ((h = n.loadMode) && F < 8 && (t = w.length)) {
                    for (o = 0, D++; o < t; o++)
                      if (w[o] && !w[o]._lazyRace)
                        if (
                          !H ||
                          (i.prematureUnveil && i.prematureUnveil(w[o]))
                        )
                          G(w[o]);
                        else if (
                          (((v = w[o][l]("data-expand")) && (p = 1 * v)) ||
                            (p = B),
                          g ||
                            ((g =
                              !n.expand || n.expand < 1
                                ? r.clientHeight > 500 && r.clientWidth > 500
                                  ? 500
                                  : 370
                                : n.expand),
                            (i._defEx = g),
                            (y = g * n.expFactor),
                            (b = n.hFac),
                            (M = null),
                            B < y && F < 1 && D > 2 && h > 2 && !e.hidden
                              ? ((B = y), (D = 0))
                              : (B = h > 1 && D > 1 && F < 6 ? g : 0)),
                          m !== p &&
                            ((T = innerWidth + p * b),
                            (_ = innerHeight + p),
                            (f = -1 * p),
                            (m = p)),
                          (a = w[o].getBoundingClientRect()),
                          (O = a.bottom) >= f &&
                            (I = a.top) <= _ &&
                            (j = a.right) >= f * b &&
                            (P = a.left) <= T &&
                            (O || j || P || I) &&
                            (n.loadHidden || q(w[o])) &&
                            ((d && F < 3 && !v && (h < 3 || D < 4)) ||
                              R(w[o], p)))
                        ) {
                          if ((G(w[o]), (c = !0), F > 9)) break;
                        } else
                          !c &&
                            d &&
                            !u &&
                            F < 4 &&
                            D < 4 &&
                            h > 2 &&
                            (s[0] || n.preloadAfterLoad) &&
                            (s[0] ||
                              (!v &&
                                (O ||
                                  j ||
                                  P ||
                                  I ||
                                  "auto" != w[o][l](n.sizesAttr)))) &&
                            (u = s[0] || w[o]);
                    u && !c && G(u);
                  }
                },
                Q = A(W),
                V = function (t) {
                  var e = t.target;
                  e._lazyCache
                    ? delete e._lazyCache
                    : (U(t),
                      y(e, n.loadedClass),
                      b(e, n.loadingClass),
                      w(e, Y),
                      k(e, "lazyloaded"));
                },
                X = x(V),
                Y = function (t) {
                  X({ target: t.target });
                },
                K = function (t) {
                  var e,
                    i = t[l](n.srcsetAttr);
                  (e = n.customMedia[t[l]("data-media") || t[l]("media")]) &&
                    t.setAttribute("media", e),
                    i && t.setAttribute("srcset", i);
                },
                Z = x(function (t, e, i, r, o) {
                  var s, a, u, d, h, v;
                  (h = k(t, "lazybeforeunveil", e)).defaultPrevented ||
                    (r &&
                      (i ? y(t, n.autosizesClass) : t.setAttribute("sizes", r)),
                    (a = t[l](n.srcsetAttr)),
                    (s = t[l](n.srcAttr)),
                    o && (d = (u = t.parentNode) && f.test(u.nodeName || "")),
                    (v = e.firesLoad || ("src" in t && (a || s || d))),
                    (h = { target: t }),
                    y(t, n.loadingClass),
                    v && (clearTimeout(p), (p = c(U, 2500)), w(t, Y, !0)),
                    d && m.call(u.getElementsByTagName("source"), K),
                    a
                      ? t.setAttribute("srcset", a)
                      : s &&
                        !d &&
                        (N.test(t.nodeName)
                          ? (function (t, e) {
                              try {
                                t.contentWindow.location.replace(e);
                              } catch (i) {
                                t.src = e;
                              }
                            })(t, s)
                          : (t.src = s)),
                    o && (a || d) && C(t, { src: s })),
                    t._lazyRace && delete t._lazyRace,
                    b(t, n.lazyClass),
                    z(function () {
                      var e = t.complete && t.naturalWidth > 1;
                      (v && !e) ||
                        (e && y(t, "ls-is-cached"),
                        V(h),
                        (t._lazyCache = !0),
                        c(function () {
                          "_lazyCache" in t && delete t._lazyCache;
                        }, 9)),
                        "lazy" == t.loading && F--;
                    }, !0);
                }),
                G = function (t) {
                  if (!t._lazyRace) {
                    var e,
                      i = L.test(t.nodeName),
                      r = i && (t[l](n.sizesAttr) || t[l]("sizes")),
                      o = "auto" == r;
                    ((!o && d) ||
                      !i ||
                      (!t[l]("src") && !t.srcset) ||
                      t.complete ||
                      g(t, n.errorClass) ||
                      !g(t, n.lazyClass)) &&
                      ((e = k(t, "lazyunveilread").detail),
                      o && E.updateElem(t, !0, t.offsetWidth),
                      (t._lazyRace = !0),
                      F++,
                      Z(t, e, o, r, i));
                  }
                },
                J = $(function () {
                  (n.loadMode = 3), Q();
                }),
                tt = function () {
                  3 == n.loadMode && (n.loadMode = 2), J();
                },
                et = function () {
                  if (!d) {
                    if (o.now() - v < 999) return void c(et, 999);
                    (d = !0), (n.loadMode = 3), Q(), u("scroll", tt, !0);
                  }
                };
              return {
                _: function () {
                  (v = o.now()),
                    (i.elements = e.getElementsByClassName(n.lazyClass)),
                    (s = e.getElementsByClassName(
                      n.lazyClass + " " + n.preloadClass
                    )),
                    u("scroll", Q, !0),
                    u("resize", Q, !0),
                    t.MutationObserver
                      ? new MutationObserver(Q).observe(r, {
                          childList: !0,
                          subtree: !0,
                          attributes: !0,
                        })
                      : (r[a]("DOMNodeInserted", Q, !0),
                        r[a]("DOMAttrModified", Q, !0),
                        setInterval(Q, 999)),
                    u("hashchange", Q, !0),
                    [
                      "focus",
                      "mouseover",
                      "click",
                      "load",
                      "transitionend",
                      "animationend",
                      "webkitAnimationEnd",
                    ].forEach(function (t) {
                      e[a](t, Q, !0);
                    }),
                    /d$|^c/.test(e.readyState)
                      ? et()
                      : (u("load", et),
                        e[a]("DOMContentLoaded", Q),
                        c(et, 2e4)),
                    i.elements.length ? (W(), z._lsFlush()) : Q();
                },
                checkElems: Q,
                unveil: G,
                _aLSL: tt,
              };
            })(),
            E = (function () {
              var t,
                i = x(function (t, e, i, n) {
                  var r, o, s;
                  if (
                    ((t._lazysizesWidth = n),
                    (n += "px"),
                    t.setAttribute("sizes", n),
                    f.test(e.nodeName || ""))
                  )
                    for (
                      o = 0, s = (r = e.getElementsByTagName("source")).length;
                      o < s;
                      o++
                    )
                      r[o].setAttribute("sizes", n);
                  i.detail.dataAttr || C(t, i.detail);
                }),
                r = function (t, e, n) {
                  var r,
                    o = t.parentNode;
                  o &&
                    ((n = T(t, o, n)),
                    (r = k(t, "lazybeforesizes", { width: n, dataAttr: !!e }))
                      .defaultPrevented ||
                      ((n = r.detail.width) &&
                        n !== t._lazysizesWidth &&
                        i(t, o, r, n)));
                },
                o = $(function () {
                  var e,
                    i = t.length;
                  if (i) for (e = 0; e < i; e++) r(t[e]);
                });
              return {
                _: function () {
                  (t = e.getElementsByClassName(n.autosizesClass)),
                    u("resize", o);
                },
                checkElems: o,
                updateElem: r,
              };
            })(),
            I = function () {
              I.i || ((I.i = !0), E._(), _._());
            };
          return (i = {
            cfg: n,
            autoSizer: E,
            loader: _,
            init: I,
            uP: C,
            aC: y,
            rC: b,
            hC: g,
            fire: k,
            gW: T,
            rAF: z,
          });
        }
      })(t, t.document);
      (t.lazySizes = i),
        "object" == typeof module && module.exports && (module.exports = i);
    })(window),
    (function (t, e) {
      var i = function () {
        e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
      };
      (e = e.bind(null, t, t.document)),
        "object" == typeof module && module.exports
          ? e(require("lazysizes"))
          : t.lazySizes
          ? i()
          : t.addEventListener("lazyunveilread", i, !0);
    })(window, function (t, e, i) {
      "use strict";
      if (t.addEventListener) {
        var n = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
          r = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
          o = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
          s = /^picture$/i,
          a = {
            getParent: function (e, i) {
              var n = e,
                r = e.parentNode;
              return (
                (i && "prev" != i) ||
                  !r ||
                  !s.test(r.nodeName || "") ||
                  (r = r.parentNode),
                "self" != i &&
                  (n =
                    "prev" == i
                      ? e.previousElementSibling
                      : (i &&
                          (r.closest || t.jQuery) &&
                          (r.closest
                            ? r.closest(i)
                            : jQuery(r).closest(i)[0])) ||
                        r),
                n
              );
            },
            getFit: function (t) {
              var e,
                i,
                n = (function (t) {
                  return getComputedStyle(t, null) || {};
                })(t),
                s = n.content || n.fontFamily,
                l = {
                  fit:
                    t._lazysizesParentFit || t.getAttribute("data-parent-fit"),
                };
              return (
                !l.fit && s && (e = s.match(r)) && (l.fit = e[1]),
                l.fit
                  ? (!(i =
                      t._lazysizesParentContainer ||
                      t.getAttribute("data-parent-container")) &&
                      s &&
                      (e = s.match(o)) &&
                      (i = e[1]),
                    (l.parent = a.getParent(t, i)))
                  : (l.fit = n.objectFit),
                l
              );
            },
            getImageRatio: function (e) {
              var i,
                r,
                o,
                a,
                l,
                u,
                c,
                d = e.parentNode,
                p =
                  d && s.test(d.nodeName || "")
                    ? d.querySelectorAll("source, img")
                    : [e];
              for (i = 0; i < p.length; i++)
                if (
                  ((r =
                    (e = p[i]).getAttribute(lazySizesConfig.srcsetAttr) ||
                    e.getAttribute("srcset") ||
                    e.getAttribute("data-pfsrcset") ||
                    e.getAttribute("data-risrcset") ||
                    ""),
                  (o = e._lsMedia || e.getAttribute("media")),
                  (o =
                    lazySizesConfig.customMedia[
                      e.getAttribute("data-media") || o
                    ] || o),
                  r && (!o || ((t.matchMedia && matchMedia(o)) || {}).matches))
                ) {
                  (a = parseFloat(e.getAttribute("data-aspectratio"))) ||
                    ((l = r.match(n))
                      ? "w" == l[2]
                        ? ((u = l[1]), (c = l[3]))
                        : ((u = l[3]), (c = l[1]))
                      : ((u = e.getAttribute("width")),
                        (c = e.getAttribute("height"))),
                    (a = u / c));
                  break;
                }
              return a;
            },
            calculateSize: function (t, e) {
              var i,
                n,
                r,
                o,
                s = this.getFit(t),
                a = s.fit,
                l = s.parent;
              return "width" == a ||
                (("contain" == a || "cover" == a) &&
                  (r = this.getImageRatio(t)))
                ? (l ? (e = l.clientWidth) : (l = t),
                  (o = e),
                  "width" == a
                    ? (o = e)
                    : (n = l.clientHeight) > 40 &&
                      (i = e / n) &&
                      (("cover" == a && i < r) || ("contain" == a && i > r)) &&
                      (o = e * (r / i)),
                  o)
                : e;
            },
          };
        (i.parentFit = a),
          e.addEventListener("lazybeforesizes", function (t) {
            if (!t.defaultPrevented && t.detail.instance == i) {
              var e = t.target;
              t.detail.width = a.calculateSize(e, t.detail.width);
            }
          });
      }
    }),
    (function (t, e) {
      var i = function () {
        e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
      };
      (e = e.bind(null, t, t.document)),
        "object" == typeof module && module.exports
          ? e(require("lazysizes"))
          : t.lazySizes
          ? i()
          : t.addEventListener("lazyunveilread", i, !0);
    })(window, function (t, e, i) {
      "use strict";
      var n,
        r = i && i.cfg,
        o = e.createElement("img"),
        s = "sizes" in o && "srcset" in o,
        a = /\s+\d+h/g,
        l = (function () {
          var t = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
            n = Array.prototype.forEach;
          return function () {
            var r = e.createElement("img"),
              o = function (e) {
                var i,
                  n,
                  r = e.getAttribute(lazySizesConfig.srcsetAttr);
                r &&
                  (n = r.match(t)) &&
                  ((i = "w" == n[2] ? n[1] / n[3] : n[3] / n[1]) &&
                    e.setAttribute("data-aspectratio", i),
                  e.setAttribute(lazySizesConfig.srcsetAttr, r.replace(a, "")));
              },
              s = function (t) {
                if (t.detail.instance == i) {
                  var e = t.target.parentNode;
                  e &&
                    "PICTURE" == e.nodeName &&
                    n.call(e.getElementsByTagName("source"), o),
                    o(t.target);
                }
              },
              l = function () {
                r.currentSrc && e.removeEventListener("lazybeforeunveil", s);
              };
            e.addEventListener("lazybeforeunveil", s),
              (r.onload = l),
              (r.onerror = l),
              (r.srcset = "data:,a 1w 1h"),
              r.complete && l();
          };
        })();
      r.supportsType ||
        (r.supportsType = function (t) {
          return !t;
        }),
        t.HTMLPictureElement && s
          ? !i.hasHDescriptorFix &&
            e.msElementsFromPoint &&
            ((i.hasHDescriptorFix = !0), l())
          : t.picturefill ||
            r.pf ||
            ((r.pf = function (e) {
              var i, r;
              if (!t.picturefill)
                for (i = 0, r = e.elements.length; i < r; i++) n(e.elements[i]);
            }),
            (n = (function () {
              var o = function (t, e) {
                  return t.w - e.w;
                },
                l = /^\s*\d+\.*\d*px\s*$/,
                u = (function () {
                  var t,
                    e = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
                    i = /\s/,
                    n = function (e, i, n, r) {
                      t.push({ c: i, u: n, w: 1 * r });
                    };
                  return function (r) {
                    return (
                      (t = []),
                      (r = r.trim()).replace(a, "").replace(e, n),
                      t.length ||
                        !r ||
                        i.test(r) ||
                        t.push({ c: r, u: r, w: 99 }),
                      t
                    );
                  };
                })(),
                c = function () {
                  var t, i, r;
                  c.init ||
                    ((c.init = !0),
                    addEventListener(
                      "resize",
                      ((i = e.getElementsByClassName("lazymatchmedia")),
                      (r = function () {
                        var t, e;
                        for (t = 0, e = i.length; t < e; t++) n(i[t]);
                      }),
                      function () {
                        clearTimeout(t), (t = setTimeout(r, 66));
                      })
                    ));
                },
                d = function (e, n) {
                  var o,
                    s =
                      e.getAttribute("srcset") || e.getAttribute(r.srcsetAttr);
                  !s &&
                    n &&
                    (s = e._lazypolyfill
                      ? e._lazypolyfill._set
                      : e.getAttribute(r.srcAttr) || e.getAttribute("src")),
                    (e._lazypolyfill && e._lazypolyfill._set == s) ||
                      ((o = u(s || "")),
                      n &&
                        e.parentNode &&
                        ((o.isPicture =
                          "PICTURE" == e.parentNode.nodeName.toUpperCase()),
                        o.isPicture &&
                          t.matchMedia &&
                          (i.aC(e, "lazymatchmedia"), c())),
                      (o._set = s),
                      Object.defineProperty(e, "_lazypolyfill", {
                        value: o,
                        writable: !0,
                      }));
                },
                p = function (e) {
                  var n = t.devicePixelRatio || 1,
                    r = i.getX && i.getX(e);
                  return Math.min(r || n, 2.5, n);
                },
                f = function (e) {
                  return t.matchMedia
                    ? (f = function (t) {
                        return !t || (matchMedia(t) || {}).matches;
                      })(e)
                    : !e;
                },
                h = function (t) {
                  if (
                    !s ||
                    !t.parentNode ||
                    "PICTURE" == t.parentNode.nodeName.toUpperCase()
                  ) {
                    var e = (function (t) {
                      var e, n, s, a, u, c, h;
                      if ((d((a = t), !0), (u = a._lazypolyfill).isPicture))
                        for (
                          n = 0,
                            s = (e =
                              t.parentNode.getElementsByTagName("source"))
                              .length;
                          n < s;
                          n++
                        )
                          if (
                            r.supportsType(e[n].getAttribute("type"), t) &&
                            f(e[n].getAttribute("media"))
                          ) {
                            (a = e[n]), d(a), (u = a._lazypolyfill);
                            break;
                          }
                      return (
                        u.length > 1
                          ? ((h = a.getAttribute("sizes") || ""),
                            (h =
                              (l.test(h) && parseInt(h, 10)) ||
                              i.gW(t, t.parentNode)),
                            (u.d = p(t)),
                            !u.src || !u.w || u.w < h
                              ? ((u.w = h),
                                (c = (function (t) {
                                  for (
                                    var e, i, n = t.length, r = t[n - 1], o = 0;
                                    o < n;
                                    o++
                                  )
                                    if (
                                      (((r = t[o]).d = r.w / t.w), r.d >= t.d)
                                    ) {
                                      !r.cached &&
                                        (e = t[o - 1]) &&
                                        e.d > t.d - 0.13 * Math.pow(t.d, 2.2) &&
                                        ((i = Math.pow(e.d - 0.6, 1.6)),
                                        e.cached && (e.d += 0.15 * i),
                                        e.d + (r.d - t.d) * i > t.d && (r = e));
                                      break;
                                    }
                                  return r;
                                })(u.sort(o))),
                                (u.src = c))
                              : (c = u.src))
                          : (c = u[0]),
                        c
                      );
                    })(t);
                    e &&
                      e.u &&
                      t._lazypolyfill.cur != e.u &&
                      ((t._lazypolyfill.cur = e.u),
                      (e.cached = !0),
                      t.setAttribute(r.srcAttr, e.u),
                      t.setAttribute("src", e.u));
                  }
                };
              return (h.parse = u), h;
            })()),
            r.loadedClass &&
              r.loadingClass &&
              (function () {
                var t = [];
                [
                  'img[sizes$="px"][srcset].',
                  "picture > img:not([srcset]).",
                ].forEach(function (e) {
                  t.push(e + r.loadedClass), t.push(e + r.loadingClass);
                }),
                  r.pf({ elements: e.querySelectorAll(t.join(", ")) });
              })());
    }),
    (function (t, e) {
      var i = function () {
        e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0);
      };
      (e = e.bind(null, t, t.document)),
        "object" == typeof module && module.exports
          ? e(require("lazysizes"))
          : t.lazySizes
          ? i()
          : t.addEventListener("lazyunveilread", i, !0);
    })(window, function (t, e, i) {
      "use strict";
      if (t.addEventListener) {
        var n = /\s+/g,
          r = /\s*\|\s+|\s+\|\s*/g,
          o = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
          s = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
          a = /\(|\)|'/,
          l = { contain: 1, cover: 1 },
          u = function (t, e) {
            if (e) {
              var i = e.match(s);
              i && i[1]
                ? t.setAttribute("type", i[1])
                : t.setAttribute("media", lazySizesConfig.customMedia[e] || e);
            }
          },
          c = function (t, i, s) {
            var a = e.createElement("picture"),
              l = i.getAttribute(lazySizesConfig.sizesAttr),
              c = i.getAttribute("data-ratio"),
              d = i.getAttribute("data-optimumx");
            i._lazybgset &&
              i._lazybgset.parentNode == i &&
              i.removeChild(i._lazybgset),
              Object.defineProperty(s, "_lazybgset", {
                value: i,
                writable: !0,
              }),
              Object.defineProperty(i, "_lazybgset", {
                value: a,
                writable: !0,
              }),
              (t = t.replace(n, " ").split(r)),
              (a.style.display = "none"),
              (s.className = lazySizesConfig.lazyClass),
              1 != t.length || l || (l = "auto"),
              t.forEach(function (t) {
                var i,
                  n = e.createElement("source");
                l && "auto" != l && n.setAttribute("sizes", l),
                  (i = t.match(o))
                    ? (n.setAttribute(lazySizesConfig.srcsetAttr, i[1]),
                      u(n, i[2]),
                      u(n, i[3]))
                    : n.setAttribute(lazySizesConfig.srcsetAttr, t),
                  a.appendChild(n);
              }),
              l &&
                (s.setAttribute(lazySizesConfig.sizesAttr, l),
                i.removeAttribute(lazySizesConfig.sizesAttr),
                i.removeAttribute("sizes")),
              d && s.setAttribute("data-optimumx", d),
              c && s.setAttribute("data-ratio", c),
              a.appendChild(s),
              i.appendChild(a);
          },
          d = function (t) {
            if (t.target._lazybgset) {
              var e = t.target,
                n = e._lazybgset,
                r = e.currentSrc || e.src;
              if (r) {
                var o = i.fire(n, "bgsetproxy", {
                  src: r,
                  useSrc: a.test(r) ? JSON.stringify(r) : r,
                });
                o.defaultPrevented ||
                  (n.style.backgroundImage = "url(" + o.detail.useSrc + ")");
              }
              e._lazybgsetLoading &&
                (i.fire(n, "_lazyloaded", {}, !1, !0),
                delete e._lazybgsetLoading);
            }
          };
        addEventListener("lazybeforeunveil", function (t) {
          var n, r, o;
          !t.defaultPrevented &&
            (n = t.target.getAttribute("data-bgset")) &&
            ((o = t.target),
            ((r = e.createElement("img")).alt = ""),
            (r._lazybgsetLoading = !0),
            (t.detail.firesLoad = !0),
            c(n, o, r),
            setTimeout(function () {
              i.loader.unveil(r),
                i.rAF(function () {
                  i.fire(r, "_lazyloaded", {}, !0, !0),
                    r.complete && d({ target: r });
                });
            }));
        }),
          e.addEventListener("load", d, !0),
          t.addEventListener(
            "lazybeforesizes",
            function (t) {
              if (
                t.detail.instance == i &&
                t.target._lazybgset &&
                t.detail.dataAttr
              ) {
                var e = (function (t) {
                  var e;
                  return (
                    (e = (
                      getComputedStyle(t) || {
                        getPropertyValue: function () {},
                      }
                    ).getPropertyValue("background-size")),
                    !l[e] &&
                      l[t.style.backgroundSize] &&
                      (e = t.style.backgroundSize),
                    e
                  );
                })(t.target._lazybgset);
                l[e] &&
                  ((t.target._lazysizesParentFit = e),
                  i.rAF(function () {
                    t.target.setAttribute("data-parent-fit", e),
                      t.target._lazysizesParentFit &&
                        delete t.target._lazysizesParentFit;
                  }));
              }
            },
            !0
          ),
          e.documentElement.addEventListener("lazybeforesizes", function (t) {
            !t.defaultPrevented &&
              t.target._lazybgset &&
              t.detail.instance == i &&
              (t.detail.width = (function (t) {
                var e = i.gW(t, t.parentNode);
                return (
                  (!t._lazysizesWidth || e > t._lazysizesWidth) &&
                    (t._lazysizesWidth = e),
                  t._lazysizesWidth
                );
              })(t.target._lazybgset));
          });
      }
    }),
    (function (t, e, i) {
      "use strict";
      var n = window.matchMedia;
      "undefined" != typeof module && module.exports
        ? (module.exports = i(n))
        : "function" == typeof define && define.amd
        ? define(function () {
            return (e[t] = i(n));
          })
        : (e[t] = i(n));
    })("enquire", this, function (t) {
      "use strict";
      function e(t, e) {
        for (var i = 0, n = t.length; n > i && !1 !== e(t[i], i); i++);
      }
      function i(t) {
        return "function" == typeof t;
      }
      function n(t) {
        (this.options = t), !t.deferSetup && this.setup();
      }
      function r(e, i) {
        (this.query = e),
          (this.isUnconditional = i),
          (this.handlers = []),
          (this.mql = t(e));
        var n = this;
        (this.listener = function (t) {
          (n.mql = t), n.assess();
        }),
          this.mql.addListener(this.listener);
      }
      function o() {
        if (!t)
          throw new Error(
            "matchMedia not present, legacy browsers require a polyfill"
          );
        (this.queries = {}), (this.browserIsIncapable = !t("only all").matches);
      }
      return (
        (n.prototype = {
          setup: function () {
            this.options.setup && this.options.setup(), (this.initialised = !0);
          },
          on: function () {
            !this.initialised && this.setup(),
              this.options.match && this.options.match();
          },
          off: function () {
            this.options.unmatch && this.options.unmatch();
          },
          destroy: function () {
            this.options.destroy ? this.options.destroy() : this.off();
          },
          equals: function (t) {
            return this.options === t || this.options.match === t;
          },
        }),
        (r.prototype = {
          addHandler: function (t) {
            var e = new n(t);
            this.handlers.push(e), this.matches() && e.on();
          },
          removeHandler: function (t) {
            var i = this.handlers;
            e(i, function (e, n) {
              return e.equals(t) ? (e.destroy(), !i.splice(n, 1)) : void 0;
            });
          },
          matches: function () {
            return this.mql.matches || this.isUnconditional;
          },
          clear: function () {
            e(this.handlers, function (t) {
              t.destroy();
            }),
              this.mql.removeListener(this.listener),
              (this.handlers.length = 0);
          },
          assess: function () {
            var t = this.matches() ? "on" : "off";
            e(this.handlers, function (e) {
              e[t]();
            });
          },
        }),
        (o.prototype = {
          register: function (t, n, o) {
            var s = this.queries,
              a = o && this.browserIsIncapable;
            return (
              s[t] || (s[t] = new r(t, a)),
              i(n) && (n = { match: n }),
              (function (t) {
                return "[object Array]" === Object.prototype.toString.apply(t);
              })(n) || (n = [n]),
              e(n, function (e) {
                i(e) && (e = { match: e }), s[t].addHandler(e);
              }),
              this
            );
          },
          unregister: function (t, e) {
            var i = this.queries[t];
            return (
              i &&
                (e ? i.removeHandler(e) : (i.clear(), delete this.queries[t])),
              this
            );
          },
        }),
        new o()
      );
    }),
    (function (t) {
      "use strict";
      var e = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1,
      };
      (t.zoom = function (e, i, n, r) {
        var o,
          s,
          a,
          l,
          u,
          c,
          d,
          p = t(e),
          f = p.css("position"),
          h = t(i);
        return (
          p.css("position", /(absolute|fixed)/.test(f) ? f : "relative"),
          p.css("overflow", "hidden"),
          (n.style.width = n.style.height = ""),
          t(n)
            .addClass("zoomImg")
            .css({
              position: "absolute",
              top: 0,
              left: 0,
              opacity: 0,
              width: n.width * r,
              height: n.height * r,
              border: "none",
              maxWidth: "none",
              maxHeight: "none",
            })
            .appendTo(e),
          {
            init: function () {
              (s = p.outerWidth()),
                (o = p.outerHeight()),
                i === p[0]
                  ? ((l = s), (a = o))
                  : ((l = h.outerWidth()), (a = h.outerHeight())),
                (u = (n.width - s) / l),
                (c = (n.height - o) / a),
                (d = h.offset());
            },
            move: function (t) {
              var e = t.pageX - d.left,
                i = t.pageY - d.top;
              (i = Math.max(Math.min(i, a), 0)),
                (e = Math.max(Math.min(e, l), 0)),
                (n.style.left = e * -u + "px"),
                (n.style.top = i * -c + "px");
            },
          }
        );
      }),
        (t.fn.zoom = function (i) {
          return this.each(function () {
            var n,
              r = t.extend({}, e, i || {}),
              o = r.target || this,
              s = this,
              a = t(s),
              l = t(o),
              u = document.createElement("img"),
              c = t(u),
              d = "mousemove.zoom",
              p = !1,
              f = !1;
            (r.url ||
              ((n = a.find("img"))[0] &&
                (r.url = n.data("src") || n.attr("src")),
              r.url)) &&
              ((function () {
                var t = l.css("position"),
                  e = l.css("overflow");
                a.one("zoom.destroy", function () {
                  a.off(".zoom"),
                    l.css("position", t),
                    l.css("overflow", e),
                    c.remove();
                });
              })(),
              (u.onload = function () {
                function e(e) {
                  n.init(),
                    n.move(e),
                    c
                      .stop()
                      .fadeTo(
                        t.support.opacity ? r.duration : 0,
                        1,
                        !!t.isFunction(r.onZoomIn) && r.onZoomIn.call(u)
                      );
                }
                function i() {
                  c.stop().fadeTo(
                    r.duration,
                    0,
                    !!t.isFunction(r.onZoomOut) && r.onZoomOut.call(u)
                  );
                }
                var n = t.zoom(o, s, u, r.magnify);
                "grab" === r.on
                  ? a.on("mousedown.zoom", function (r) {
                      1 === r.which &&
                        (t(document).one("mouseup.zoom", function () {
                          i(), t(document).off(d, n.move);
                        }),
                        e(r),
                        t(document).on(d, n.move),
                        r.preventDefault());
                    })
                  : "click" === r.on
                  ? a.on("click.zoom", function (r) {
                      return p
                        ? void 0
                        : ((p = !0),
                          e(r),
                          t(document).on(d, n.move),
                          t(document).one("click.zoom", function () {
                            i(), (p = !1), t(document).off(d, n.move);
                          }),
                          !1);
                    })
                  : "toggle" === r.on
                  ? a.on("click.zoom", function (t) {
                      p ? i() : e(t), (p = !p);
                    })
                  : "mouseover" === r.on &&
                    (n.init(),
                    a
                      .on("mouseenter.zoom", e)
                      .on("mouseleave.zoom", i)
                      .on(d, n.move)),
                  r.touch &&
                    a
                      .on("touchstart.zoom", function (t) {
                        t.preventDefault(),
                          f
                            ? ((f = !1), i())
                            : ((f = !0),
                              e(
                                t.originalEvent.touches[0] ||
                                  t.originalEvent.changedTouches[0]
                              ));
                      })
                      .on("touchmove.zoom", function (t) {
                        t.preventDefault(),
                          n.move(
                            t.originalEvent.touches[0] ||
                              t.originalEvent.changedTouches[0]
                          );
                      })
                      .on("touchend.zoom", function (t) {
                        t.preventDefault(), f && ((f = !1), i());
                      }),
                  t.isFunction(r.callback) && r.callback.call(u);
              }),
              (u.src = r.url));
          });
        }),
        (t.fn.zoom.defaults = e);
    })(window.jQuery),
    function () {
      function t(t, e) {
        for (var i = -1, n = e.length, r = t.length; ++i < n; ) t[r + i] = e[i];
        return t;
      }
      function e(t, e, i) {
        for (var n = -1, r = t.length; ++n < r; ) {
          var o = t[n],
            s = e(o);
          if (null != s && (a === Z ? s == s : i(s, a)))
            var a = s,
              l = o;
        }
        return l;
      }
      function i(t) {
        return t && t.Object === Object ? t : null;
      }
      function n(t) {
        return et[t];
      }
      function r(t) {
        var e = !1;
        if (null != t && "function" != typeof t.toString)
          try {
            e = !!(t + "");
          } catch (t) {}
        return e;
      }
      function o(t, e) {
        return (
          (t = "number" == typeof t || tt.test(t) ? +t : -1) > -1 &&
          0 == t % 1 &&
          (null == e ? 9007199254740991 : e) > t
        );
      }
      function s(t) {
        if (D(t) && !Et(t)) {
          if (t instanceof a) return t;
          if (pt.call(t, "__wrapped__")) {
            var e = new a(t.__wrapped__, t.__chain__);
            return (e.__actions__ = C(t.__actions__)), e;
          }
        }
        return new a(t);
      }
      function a(t, e) {
        (this.__wrapped__ = t), (this.__actions__ = []), (this.__chain__ = !!e);
      }
      function l(t, e, i, n) {
        var r;
        return (
          (r = t === Z) ||
            (r = (t === (r = dt[i]) || (t != t && r != r)) && !pt.call(n, i)),
          r ? e : t
        );
      }
      function u(t) {
        return F(t) ? yt(t) : {};
      }
      function c(t, e, i) {
        if ("function" != typeof t) throw new TypeError("Expected a function");
        return setTimeout(function () {
          t.apply(Z, i);
        }, e);
      }
      function d(t, e) {
        var i = [];
        return (
          St(t, function (t, n, r) {
            e(t, n, r) && i.push(t);
          }),
          i
        );
      }
      function p(e, i, n, r) {
        r || (r = []);
        for (var o = -1, s = e.length; ++o < s; ) {
          var a = e[o];
          i > 0 && D(a) && N(a) && (n || Et(a) || L(a))
            ? i > 1
              ? p(a, i - 1, n, r)
              : t(r, a)
            : n || (r[r.length] = a);
        }
        return r;
      }
      function f(t, e) {
        return t && Tt(t, e, Q);
      }
      function h(t, e) {
        return d(e, function (e) {
          return H(t[e]);
        });
      }
      function v(t, e, i, n, o) {
        return (
          t === e ||
          (null == t || null == e || (!F(t) && !D(e))
            ? t != t && e != e
            : (function (t, e, i, n, o, s) {
                var a = Et(t),
                  l = Et(e),
                  u = "[object Array]",
                  c = "[object Array]";
                a ||
                  ("[object Arguments]" == (u = ht.call(t)) &&
                    (u = "[object Object]")),
                  l ||
                    ("[object Arguments]" == (c = ht.call(e)) &&
                      (c = "[object Object]"));
                var d = "[object Object]" == u && !r(t),
                  l = "[object Object]" == c && !r(e);
                return !(c = u == c) || a || d
                  ? 2 & o ||
                    ((u = d && pt.call(t, "__wrapped__")),
                    (l = l && pt.call(e, "__wrapped__")),
                    !u && !l)
                    ? !!c &&
                      (s || (s = []),
                      (u = E(s, function (e) {
                        return e[0] === t;
                      })) && u[1]
                        ? u[1] == e
                        : (s.push([t, e]),
                          (e = (
                            a
                              ? function (t, e, i, n, r, o) {
                                  var s = -1,
                                    a = 1 & r,
                                    l = t.length,
                                    u = e.length;
                                  if (l != u && !(2 & r && u > l)) return !1;
                                  for (u = !0; ++s < l; ) {
                                    var c = t[s],
                                      d = e[s];
                                    if (void 0 !== Z) {
                                      u = !1;
                                      break;
                                    }
                                    if (a) {
                                      if (
                                        !S(e, function (t) {
                                          return c === t || i(c, t, n, r, o);
                                        })
                                      ) {
                                        u = !1;
                                        break;
                                      }
                                    } else if (c !== d && !i(c, d, n, r, o)) {
                                      u = !1;
                                      break;
                                    }
                                  }
                                  return u;
                                }
                              : function (t, e, i, n, r, o) {
                                  var s = 2 & r,
                                    a = Q(t),
                                    l = a.length,
                                    u = Q(e).length;
                                  if (l != u && !s) return !1;
                                  for (var c = l; c--; ) {
                                    var d = a[c];
                                    if (!(s ? d in e : pt.call(e, d)))
                                      return !1;
                                  }
                                  for (u = !0; ++c < l; ) {
                                    var d = a[c],
                                      p = t[d],
                                      f = e[d];
                                    if (
                                      void 0 !== Z ||
                                      (p !== f && !i(p, f, n, r, o))
                                    ) {
                                      u = !1;
                                      break;
                                    }
                                    s || (s = "constructor" == d);
                                  }
                                  return (
                                    u &&
                                      !s &&
                                      ((i = t.constructor),
                                      (n = e.constructor),
                                      i != n &&
                                        "constructor" in t &&
                                        "constructor" in e &&
                                        !(
                                          "function" == typeof i &&
                                          i instanceof i &&
                                          "function" == typeof n &&
                                          n instanceof n
                                        ) &&
                                        (u = !1)),
                                    u
                                  );
                                }
                          )(t, e, i, n, o, s)),
                          s.pop(),
                          e))
                    : i(u ? t.value() : t, l ? e.value() : e, n, o, s)
                  : (function (t, e, i) {
                      switch (i) {
                        case "[object Boolean]":
                        case "[object Date]":
                          return +t == +e;
                        case "[object Error]":
                          return t.name == e.name && t.message == e.message;
                        case "[object Number]":
                          return t != +t ? e != +e : t == +e;
                        case "[object RegExp]":
                        case "[object String]":
                          return t == e + "";
                      }
                      return !1;
                    })(t, e, u);
              })(t, e, v, i, n, o))
        );
      }
      function m(t) {
        var e = typeof t;
        return "function" == e ? t : null == t ? Y : ("object" == e ? b : w)(t);
      }
      function g(t) {
        t = null == t ? t : Object(t);
        var e,
          i = [];
        for (e in t) i.push(e);
        return i;
      }
      function y(t, e) {
        var i = -1,
          n = N(t) ? Array(t.length) : [];
        return (
          St(t, function (t, r, o) {
            n[++i] = e(t, r, o);
          }),
          n
        );
      }
      function b(t) {
        var e = Q(t);
        return function (i) {
          var n = e.length;
          if (null == i) return !n;
          for (i = Object(i); n--; ) {
            var r = e[n];
            if (!(r in i && v(t[r], i[r], Z, 3))) return !1;
          }
          return !0;
        };
      }
      function w(t) {
        return function (e) {
          return null == e ? Z : e[t];
        };
      }
      function k(t, e, i) {
        var n = -1,
          r = t.length;
        for (
          0 > e && (e = -e > r ? 0 : r + e),
            0 > (i = i > r ? r : i) && (i += r),
            r = e > i ? 0 : (i - e) >>> 0,
            e >>>= 0,
            i = Array(r);
          ++n < r;

        )
          i[n] = t[n + e];
        return i;
      }
      function C(t) {
        return k(t, 0, t.length);
      }
      function S(t, e) {
        var i;
        return (
          St(t, function (t, n, r) {
            return !(i = e(t, n, r));
          }),
          !!i
        );
      }
      function T(t, e, i, n) {
        i || (i = {});
        for (var r = -1, o = e.length; ++r < o; ) {
          var s = e[r],
            a = n ? n(i[s], t[s], s, i, t) : t[s],
            l = i,
            u = l[s];
          (pt.call(l, s) &&
            (u === a || (u != u && a != a)) &&
            (a !== Z || s in l)) ||
            (l[s] = a);
        }
        return i;
      }
      function z(t) {
        return O(function (e, i) {
          var n = -1,
            r = i.length,
            o = "function" == typeof (o = r > 1 ? i[r - 1] : Z) ? (r--, o) : Z;
          for (e = Object(e); ++n < r; ) {
            var s = i[n];
            s && t(e, s, n, o);
          }
          return e;
        });
      }
      function x(t, e, i) {
        if ("function" != typeof t) throw new TypeError("Expected a function");
        var n = (function (t) {
          return function () {
            var e = arguments,
              i = u(t.prototype);
            return F((e = t.apply(i, e))) ? e : i;
          };
        })(t);
        return function r() {
          for (
            var o = -1,
              s = arguments.length,
              a = -1,
              l = i.length,
              u = Array(l + s),
              c = this && this !== ut && this instanceof r ? n : t;
            ++a < l;

          )
            u[a] = i[a];
          for (; s--; ) u[a++] = arguments[++o];
          return c.apply(e, u);
        };
      }
      function A(t) {
        var e = t ? t.length : Z;
        if (B(e) && (Et(t) || q(t) || L(t))) {
          t = String;
          for (var i = -1, n = Array(e); ++i < e; ) n[i] = t(i);
          e = n;
        } else e = null;
        return e;
      }
      function $(t) {
        var e;
        return t === (e = (H((e = t && t.constructor)) && e.prototype) || dt);
      }
      function _(t) {
        return t ? t[0] : Z;
      }
      function E(t, e) {
        return (function (t, e, i) {
          var n;
          return (
            i(t, function (t, i, r) {
              return e(t, i, r) ? ((n = t), !1) : void 0;
            }),
            n
          );
        })(t, m(e), St);
      }
      function I(t, e) {
        return St(t, "function" == typeof e ? e : Y);
      }
      function P(t, e, i) {
        return (function (t, e, i, n, r) {
          return (
            r(t, function (t, r, o) {
              i = n ? ((n = !1), t) : e(i, t, r, o);
            }),
            i
          );
        })(t, m(e), i, 3 > arguments.length, St);
      }
      function j(t, e) {
        var i;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        return (
          (t = It(t)),
          function () {
            return (
              0 < --t && (i = e.apply(this, arguments)), 1 >= t && (e = Z), i
            );
          }
        );
      }
      function O(t) {
        var e;
        if ("function" != typeof t) throw new TypeError("Expected a function");
        return (
          (e = Ct(e === Z ? t.length - 1 : It(e), 0)),
          function () {
            for (
              var i = arguments, n = -1, r = Ct(i.length - e, 0), o = Array(r);
              ++n < r;

            )
              o[n] = i[e + n];
            for (r = Array(e + 1), n = -1; ++n < e; ) r[n] = i[n];
            return (r[e] = o), t.apply(this, r);
          }
        );
      }
      function M(t, e) {
        return t > e;
      }
      function L(t) {
        return (
          D(t) &&
          N(t) &&
          pt.call(t, "callee") &&
          (!bt.call(t, "callee") || "[object Arguments]" == ht.call(t))
        );
      }
      function N(t) {
        return null != t && !("function" == typeof t && H(t)) && B(zt(t));
      }
      function H(t) {
        return (
          "[object Function]" == (t = F(t) ? ht.call(t) : "") ||
          "[object GeneratorFunction]" == t
        );
      }
      function B(t) {
        return (
          "number" == typeof t && t > -1 && 0 == t % 1 && 9007199254740991 >= t
        );
      }
      function F(t) {
        var e = typeof t;
        return !!t && ("object" == e || "function" == e);
      }
      function D(t) {
        return !!t && "object" == typeof t;
      }
      function U(t) {
        return (
          "number" == typeof t || (D(t) && "[object Number]" == ht.call(t))
        );
      }
      function q(t) {
        return (
          "string" == typeof t ||
          (!Et(t) && D(t) && "[object String]" == ht.call(t))
        );
      }
      function R(t, e) {
        return e > t;
      }
      function W(t) {
        return "string" == typeof t ? t : null == t ? "" : t + "";
      }
      function Q(t) {
        var e = $(t);
        if (!e && !N(t)) return kt(Object(t));
        var i,
          n,
          r = !!(n = A(t)),
          s = (n = n || []).length;
        for (i in t)
          !pt.call(t, i) ||
            (r && ("length" == i || o(i, s))) ||
            (e && "constructor" == i) ||
            n.push(i);
        return n;
      }
      function V(t) {
        for (
          var e,
            i = -1,
            n = $(t),
            r = g(t),
            s = r.length,
            a = !!(e = A(t)),
            l = (e = e || []).length;
          ++i < s;

        ) {
          var u = r[i];
          (a && ("length" == u || o(u, l))) ||
            ("constructor" == u && (n || !pt.call(t, u))) ||
            e.push(u);
        }
        return e;
      }
      function X(t) {
        return t
          ? (function (t, e) {
              return y(e, function (e) {
                return t[e];
              });
            })(t, Q(t))
          : [];
      }
      function Y(t) {
        return t;
      }
      function K(e, i, n) {
        var r = Q(i),
          o = h(i, r);
        null != n ||
          (F(i) && (o.length || !r.length)) ||
          ((n = i), (i = e), (e = this), (o = h(i, Q(i))));
        var s = !(F(n) && "chain" in n) || n.chain,
          a = H(e);
        return (
          St(o, function (n) {
            var r = i[n];
            (e[n] = r),
              a &&
                (e.prototype[n] = function () {
                  var i = this.__chain__;
                  if (s || i) {
                    var n = e(this.__wrapped__);
                    return (
                      (n.__actions__ = C(this.__actions__)).push({
                        func: r,
                        args: arguments,
                        thisArg: e,
                      }),
                      (n.__chain__ = i),
                      n
                    );
                  }
                  return r.apply(e, t([this.value()], arguments));
                });
          }),
          e
        );
      }
      var Z,
        G = /[&<>"'`]/g,
        J = RegExp(G.source),
        tt = /^(?:0|[1-9]\d*)$/,
        et = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
          "`": "&#96;",
        },
        it = { function: !0, object: !0 },
        nt = it[typeof exports] && exports && !exports.nodeType ? exports : Z,
        rt = it[typeof module] && module && !module.nodeType ? module : Z,
        ot = rt && rt.exports === nt ? nt : Z,
        st = i(it[typeof self] && self),
        at = i(it[typeof window] && window),
        lt = i(it[typeof this] && this),
        ut =
          i(nt && rt && "object" == typeof global && global) ||
          (at !== (lt && lt.window) && at) ||
          st ||
          lt ||
          Function("return this")(),
        ct = Array.prototype,
        dt = Object.prototype,
        pt = dt.hasOwnProperty,
        ft = 0,
        ht = dt.toString,
        vt = ut._,
        mt = ut.Reflect,
        gt = mt ? mt.f : Z,
        yt = Object.create,
        bt = dt.propertyIsEnumerable,
        wt = ut.isFinite,
        kt = Object.keys,
        Ct = Math.max,
        St = (function (t, e) {
          return function (e, i) {
            if (null == e) return e;
            if (!N(e)) return t(e, i);
            for (
              var n = e.length, r = -1, o = Object(e);
              ++r < n && !1 !== i(o[r], r, o);

            );
            return e;
          };
        })(f),
        Tt = function (t, e, i) {
          for (var n = -1, r = Object(t), o = (i = i(t)).length; o--; ) {
            var s = i[++n];
            if (!1 === e(r[s], s, r)) break;
          }
          return t;
        };
      gt &&
        !bt.call({ valueOf: 1 }, "valueOf") &&
        (g = function (t) {
          t = gt(t);
          for (var e, i = []; !(e = t.next()).done; ) i.push(e.value);
          return i;
        });
      var zt = w("length"),
        xt = O(function (e, i) {
          return (
            Et(e) || (e = null == e ? [] : [Object(e)]), p(i, 1), t(C(e), X)
          );
        }),
        At = O(function (t, e, i) {
          return x(t, e, i);
        }),
        $t = O(function (t, e) {
          return c(t, 1, e);
        }),
        _t = O(function (t, e, i) {
          return c(t, Pt(e) || 0, i);
        }),
        Et = Array.isArray,
        It = Number,
        Pt = Number,
        jt = z(function (t, e) {
          T(e, Q(e), t);
        }),
        Ot = z(function (t, e) {
          T(e, V(e), t);
        }),
        Mt = z(function (t, e, i, n) {
          T(e, V(e), t, n);
        }),
        Lt = O(function (t) {
          return t.push(Z, l), Mt.apply(Z, t);
        }),
        Nt = O(function (t, e) {
          return null == t
            ? {}
            : (function (t, e) {
                return (
                  (t = Object(t)),
                  P(
                    e,
                    function (e, i) {
                      return i in t && (e[i] = t[i]), e;
                    },
                    {}
                  )
                );
              })(t, p(e, 1));
        }),
        Ht = m;
      (a.prototype = u(s.prototype)),
        (a.prototype.constructor = a),
        (s.assignIn = Ot),
        (s.before = j),
        (s.bind = At),
        (s.chain = function (t) {
          return ((t = s(t)).__chain__ = !0), t;
        }),
        (s.compact = function (t) {
          return d(t, Boolean);
        }),
        (s.concat = xt),
        (s.create = function (t, e) {
          var i = u(t);
          return e ? jt(i, e) : i;
        }),
        (s.defaults = Lt),
        (s.defer = $t),
        (s.delay = _t),
        (s.filter = function (t, e) {
          return d(t, m(e));
        }),
        (s.flatten = function (t) {
          return t && t.length ? p(t, 1) : [];
        }),
        (s.flattenDeep = function (t) {
          return t && t.length ? p(t, 1 / 0) : [];
        }),
        (s.iteratee = Ht),
        (s.keys = Q),
        (s.map = function (t, e) {
          return y(t, m(e));
        }),
        (s.matches = function (t) {
          return b(jt({}, t));
        }),
        (s.mixin = K),
        (s.negate = function (t) {
          if ("function" != typeof t)
            throw new TypeError("Expected a function");
          return function () {
            return !t.apply(this, arguments);
          };
        }),
        (s.once = function (t) {
          return j(2, t);
        }),
        (s.pick = Nt),
        (s.slice = function (t, e, i) {
          var n = t ? t.length : 0;
          return (i = i === Z ? n : +i), n ? k(t, null == e ? 0 : +e, i) : [];
        }),
        (s.sortBy = function (t, e) {
          var i = 0;
          return (
            (e = m(e)),
            y(
              y(t, function (t, n, r) {
                return { c: t, b: i++, a: e(t, n, r) };
              }).sort(function (t, e) {
                var i;
                t: {
                  i = t.a;
                  var n = e.a;
                  if (i !== n) {
                    var r = null === i,
                      o = i === Z,
                      s = i == i,
                      a = null === n,
                      l = n === Z,
                      u = n == n;
                    if ((i > n && !a) || !s || (r && !l && u) || (o && u)) {
                      i = 1;
                      break t;
                    }
                    if ((n > i && !r) || !u || (a && !o && s) || (l && s)) {
                      i = -1;
                      break t;
                    }
                  }
                  i = 0;
                }
                return i || t.b - e.b;
              }),
              w("c")
            )
          );
        }),
        (s.tap = function (t, e) {
          return e(t), t;
        }),
        (s.thru = function (t, e) {
          return e(t);
        }),
        (s.toArray = function (t) {
          return N(t) ? (t.length ? C(t) : []) : X(t);
        }),
        (s.values = X),
        (s.extend = Ot),
        K(s, s),
        (s.clone = function (t) {
          return F(t) ? (Et(t) ? C(t) : T(t, Q(t))) : t;
        }),
        (s.escape = function (t) {
          return (t = W(t)) && J.test(t) ? t.replace(G, n) : t;
        }),
        (s.every = function (t, e, i) {
          return (function (t, e) {
            var i = !0;
            return (
              St(t, function (t, n, r) {
                return (i = !!e(t, n, r));
              }),
              i
            );
          })(t, m((e = i ? Z : e)));
        }),
        (s.find = E),
        (s.forEach = I),
        (s.has = function (t, e) {
          return null != t && pt.call(t, e);
        }),
        (s.head = _),
        (s.identity = Y),
        (s.indexOf = function (t, e, i) {
          var n = t ? t.length : 0;
          i =
            ((i = "number" == typeof i ? (0 > i ? Ct(n + i, 0) : i) : 0) || 0) -
            1;
          for (var r = e == e; ++i < n; ) {
            var o = t[i];
            if (r ? o === e : o != o) return i;
          }
          return -1;
        }),
        (s.isArguments = L),
        (s.isArray = Et),
        (s.isBoolean = function (t) {
          return (
            !0 === t || !1 === t || (D(t) && "[object Boolean]" == ht.call(t))
          );
        }),
        (s.isDate = function (t) {
          return D(t) && "[object Date]" == ht.call(t);
        }),
        (s.isEmpty = function (t) {
          if (N(t) && (Et(t) || q(t) || H(t.splice) || L(t))) return !t.length;
          for (var e in t) if (pt.call(t, e)) return !1;
          return !0;
        }),
        (s.isEqual = function (t, e) {
          return v(t, e);
        }),
        (s.isFinite = function (t) {
          return "number" == typeof t && wt(t);
        }),
        (s.isFunction = H),
        (s.isNaN = function (t) {
          return U(t) && t != +t;
        }),
        (s.isNull = function (t) {
          return null === t;
        }),
        (s.isNumber = U),
        (s.isObject = F),
        (s.isRegExp = function (t) {
          return F(t) && "[object RegExp]" == ht.call(t);
        }),
        (s.isString = q),
        (s.isUndefined = function (t) {
          return t === Z;
        }),
        (s.last = function (t) {
          var e = t ? t.length : 0;
          return e ? t[e - 1] : Z;
        }),
        (s.max = function (t) {
          return t && t.length ? e(t, Y, M) : Z;
        }),
        (s.min = function (t) {
          return t && t.length ? e(t, Y, R) : Z;
        }),
        (s.noConflict = function () {
          return ut._ === this && (ut._ = vt), this;
        }),
        (s.noop = function () {}),
        (s.reduce = P),
        (s.result = function (t, e, i) {
          return (
            (e = null == t ? Z : t[e]) === Z && (e = i), H(e) ? e.call(t) : e
          );
        }),
        (s.size = function (t) {
          return null == t ? 0 : (t = N(t) ? t : Q(t)).length;
        }),
        (s.some = function (t, e, i) {
          return S(t, m((e = i ? Z : e)));
        }),
        (s.uniqueId = function (t) {
          var e = ++ft;
          return W(t) + e;
        }),
        (s.each = I),
        (s.first = _),
        K(
          s,
          (function () {
            var t = {};
            return (
              f(s, function (e, i) {
                pt.call(s.prototype, i) || (t[i] = e);
              }),
              t
            );
          })(),
          { chain: !1 }
        ),
        (s.VERSION = "4.5.1"),
        St(
          "pop join replace reverse split push shift sort splice unshift".split(
            " "
          ),
          function (t) {
            var e = (/^(?:replace|split)$/.test(t) ? String.prototype : ct)[t],
              i = /^(?:push|sort|unshift)$/.test(t) ? "tap" : "thru",
              n = /^(?:pop|join|replace|shift)$/.test(t);
            s.prototype[t] = function () {
              var t = arguments;
              return n && !this.__chain__
                ? e.apply(this.value(), t)
                : this[i](function (i) {
                    return e.apply(i, t);
                  });
            };
          }
        ),
        (s.prototype.toJSON =
          s.prototype.valueOf =
          s.prototype.value =
            function () {
              return (
                (e = this.__wrapped__),
                P(
                  this.__actions__,
                  function (e, i) {
                    return i.func.apply(i.thisArg, t([e], i.args));
                  },
                  e
                )
              );
              var e;
            }),
        ((at || st || {})._ = s),
        "function" == typeof define &&
        "object" == typeof define.amd &&
        define.amd
          ? define(function () {
              return s;
            })
          : nt && rt
          ? (ot && ((rt.exports = s)._ = s), (nt._ = s))
          : (ut._ = s);
    }.call(this),
    (function (t) {
      "use strict";
      "function" == typeof define && define.amd
        ? define(["jquery"], t)
        : "undefined" != typeof exports
        ? (module.exports = t(require("jquery")))
        : t(jQuery);
    })(function (t) {
      "use strict";
      var e = window.Slick || {};
      ((e = (function () {
        var e = 0;
        return function (i, n) {
          var r,
            o = this;
          (o.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: t(i),
            appendDots: t(i),
            arrows: !0,
            asNavFor: null,
            prevArrow:
              '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
            nextArrow:
              '<button class="slick-next" aria-label="Next" type="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function (e, i) {
              return t('<button type="button" />').text(i + 1);
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: 0.35,
            fade: !1,
            focusOnSelect: !1,
            focusOnChange: !1,
            infinite: !0,
            initialSlide: 0,
            lazyLoad: "ondemand",
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3,
          }),
            (o.initials = {
              animating: !1,
              dragging: !1,
              autoPlayTimer: null,
              currentDirection: 0,
              currentLeft: null,
              currentSlide: 0,
              direction: 1,
              $dots: null,
              listWidth: null,
              listHeight: null,
              loadIndex: 0,
              $nextArrow: null,
              $prevArrow: null,
              scrolling: !1,
              slideCount: null,
              slideWidth: null,
              $slideTrack: null,
              $slides: null,
              sliding: !1,
              slideOffset: 0,
              swipeLeft: null,
              swiping: !1,
              $list: null,
              touchObject: {},
              transformsEnabled: !1,
              unslicked: !1,
            }),
            t.extend(o, o.initials),
            (o.activeBreakpoint = null),
            (o.animType = null),
            (o.animProp = null),
            (o.breakpoints = []),
            (o.breakpointSettings = []),
            (o.cssTransitions = !1),
            (o.focussed = !1),
            (o.interrupted = !1),
            (o.hidden = "hidden"),
            (o.paused = !0),
            (o.positionProp = null),
            (o.respondTo = null),
            (o.rowCount = 1),
            (o.shouldClick = !0),
            (o.$slider = t(i)),
            (o.$slidesCache = null),
            (o.transformType = null),
            (o.transitionType = null),
            (o.visibilityChange = "visibilitychange"),
            (o.windowWidth = 0),
            (o.windowTimer = null),
            (r = t(i).data("slick") || {}),
            (o.options = t.extend({}, o.defaults, n, r)),
            (o.currentSlide = o.options.initialSlide),
            (o.originalSettings = o.options),
            void 0 !== document.mozHidden
              ? ((o.hidden = "mozHidden"),
                (o.visibilityChange = "mozvisibilitychange"))
              : void 0 !== document.webkitHidden &&
                ((o.hidden = "webkitHidden"),
                (o.visibilityChange = "webkitvisibilitychange")),
            (o.autoPlay = t.proxy(o.autoPlay, o)),
            (o.autoPlayClear = t.proxy(o.autoPlayClear, o)),
            (o.autoPlayIterator = t.proxy(o.autoPlayIterator, o)),
            (o.changeSlide = t.proxy(o.changeSlide, o)),
            (o.clickHandler = t.proxy(o.clickHandler, o)),
            (o.selectHandler = t.proxy(o.selectHandler, o)),
            (o.setPosition = t.proxy(o.setPosition, o)),
            (o.swipeHandler = t.proxy(o.swipeHandler, o)),
            (o.dragHandler = t.proxy(o.dragHandler, o)),
            (o.keyHandler = t.proxy(o.keyHandler, o)),
            (o.instanceUid = e++),
            (o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
            o.registerBreakpoints(),
            o.init(!0);
        };
      })()).prototype.activateADA = function () {
        this.$slideTrack
          .find(".slick-active")
          .attr({ "aria-hidden": "false" })
          .find("a, input, button, select")
          .attr({ tabindex: "0" });
      }),
        (e.prototype.addSlide = e.prototype.slickAdd =
          function (e, i, n) {
            var r = this;
            if ("boolean" == typeof i) (n = i), (i = null);
            else if (i < 0 || i >= r.slideCount) return !1;
            r.unload(),
              "number" == typeof i
                ? 0 === i && 0 === r.$slides.length
                  ? t(e).appendTo(r.$slideTrack)
                  : n
                  ? t(e).insertBefore(r.$slides.eq(i))
                  : t(e).insertAfter(r.$slides.eq(i))
                : !0 === n
                ? t(e).prependTo(r.$slideTrack)
                : t(e).appendTo(r.$slideTrack),
              (r.$slides = r.$slideTrack.children(this.options.slide)),
              r.$slideTrack.children(this.options.slide).detach(),
              r.$slideTrack.append(r.$slides),
              r.$slides.each(function (e, i) {
                t(i).attr("data-slick-index", e);
              }),
              (r.$slidesCache = r.$slides),
              r.reinit();
          }),
        (e.prototype.animateHeight = function () {
          var t = this;
          if (
            1 === t.options.slidesToShow &&
            !0 === t.options.adaptiveHeight &&
            !1 === t.options.vertical
          ) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.animate({ height: e }, t.options.speed);
          }
        }),
        (e.prototype.animateSlide = function (e, i) {
          var n = {},
            r = this;
          r.animateHeight(),
            !0 === r.options.rtl && !1 === r.options.vertical && (e = -e),
            !1 === r.transformsEnabled
              ? !1 === r.options.vertical
                ? r.$slideTrack.animate(
                    { left: e },
                    r.options.speed,
                    r.options.easing,
                    i
                  )
                : r.$slideTrack.animate(
                    { top: e },
                    r.options.speed,
                    r.options.easing,
                    i
                  )
              : !1 === r.cssTransitions
              ? (!0 === r.options.rtl && (r.currentLeft = -r.currentLeft),
                t({ animStart: r.currentLeft }).animate(
                  { animStart: e },
                  {
                    duration: r.options.speed,
                    easing: r.options.easing,
                    step: function (t) {
                      (t = Math.ceil(t)),
                        !1 === r.options.vertical
                          ? ((n[r.animType] = "translate(" + t + "px, 0px)"),
                            r.$slideTrack.css(n))
                          : ((n[r.animType] = "translate(0px," + t + "px)"),
                            r.$slideTrack.css(n));
                    },
                    complete: function () {
                      i && i.call();
                    },
                  }
                ))
              : (r.applyTransition(),
                (e = Math.ceil(e)),
                !1 === r.options.vertical
                  ? (n[r.animType] = "translate3d(" + e + "px, 0px, 0px)")
                  : (n[r.animType] = "translate3d(0px," + e + "px, 0px)"),
                r.$slideTrack.css(n),
                i &&
                  setTimeout(function () {
                    r.disableTransition(), i.call();
                  }, r.options.speed));
        }),
        (e.prototype.getNavTarget = function () {
          var e = this.options.asNavFor;
          return e && null !== e && (e = t(e).not(this.$slider)), e;
        }),
        (e.prototype.asNavFor = function (e) {
          var i = this.getNavTarget();
          null !== i &&
            "object" == typeof i &&
            i.each(function () {
              var i = t(this).slick("getSlick");
              i.unslicked || i.slideHandler(e, !0);
            });
        }),
        (e.prototype.applyTransition = function (t) {
          var e = this,
            i = {};
          !1 === e.options.fade
            ? (i[e.transitionType] =
                e.transformType +
                " " +
                e.options.speed +
                "ms " +
                e.options.cssEase)
            : (i[e.transitionType] =
                "opacity " + e.options.speed + "ms " + e.options.cssEase),
            !1 === e.options.fade
              ? e.$slideTrack.css(i)
              : e.$slides.eq(t).css(i);
        }),
        (e.prototype.autoPlay = function () {
          var t = this;
          t.autoPlayClear(),
            t.slideCount > t.options.slidesToShow &&
              (t.autoPlayTimer = setInterval(
                t.autoPlayIterator,
                t.options.autoplaySpeed
              ));
        }),
        (e.prototype.autoPlayClear = function () {
          this.autoPlayTimer && clearInterval(this.autoPlayTimer);
        }),
        (e.prototype.autoPlayIterator = function () {
          var t = this,
            e = t.currentSlide + t.options.slidesToScroll;
          t.paused ||
            t.interrupted ||
            t.focussed ||
            (!1 === t.options.infinite &&
              (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1
                ? (t.direction = 0)
                : 0 === t.direction &&
                  ((e = t.currentSlide - t.options.slidesToScroll),
                  t.currentSlide - 1 == 0 && (t.direction = 1))),
            t.slideHandler(e));
        }),
        (e.prototype.buildArrows = function () {
          var e = this;
          !0 === e.options.arrows &&
            ((e.$prevArrow = t(e.options.prevArrow).addClass("slick-arrow arrow-left")),
            (e.$nextArrow = t(e.options.nextArrow).addClass("slick-arrow arrow-right")),
            e.slideCount > e.options.slidesToShow
              ? (e.$prevArrow
                  .removeClass("slick-hidden")
                  .removeAttr("aria-hidden tabindex"),
                e.$nextArrow
                  .removeClass("slick-hidden")
                  .removeAttr("aria-hidden tabindex"),
                e.htmlExpr.test(e.options.prevArrow) &&
                  e.$prevArrow.prependTo(e.options.appendArrows),
                e.htmlExpr.test(e.options.nextArrow) &&
                  e.$nextArrow.appendTo(e.options.appendArrows),
                !0 !== e.options.infinite &&
                  e.$prevArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"))
              : e.$prevArrow
                  .add(e.$nextArrow)
                  .addClass("slick-hidden")
                  .attr({ "aria-disabled": "true", tabindex: "-1" }));
        }),
        (e.prototype.buildDots = function () {
          var e,
            i,
            n = this;
          if (!0 === n.options.dots) {
            for (
              n.$slider.addClass("slick-dotted"),
                i = t("<ul />").addClass(n.options.dotsClass),
                e = 0;
              e <= n.getDotCount();
              e += 1
            )
              i.append(
                t("<li />").append(n.options.customPaging.call(this, n, e))
              );
            (n.$dots = i.appendTo(n.options.appendDots)),
              n.$dots.find("li").first().addClass("slick-active");
          }
        }),
        (e.prototype.buildOut = function () {
          var e = this;
          (e.$slides = e.$slider
            .children(e.options.slide + ":not(.slick-cloned)")
            .addClass("slick-slide")),
            (e.slideCount = e.$slides.length),
            e.$slides.each(function (e, i) {
              t(i)
                .attr("data-slick-index", e)
                .data("originalStyling", t(i).attr("style") || "");
            }),
            e.$slider.addClass("slick-slider"),
            (e.$slideTrack =
              0 === e.slideCount
                ? t('<div class="slick-track"/>').appendTo(e.$slider)
                : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
            (e.$list = e.$slideTrack
              .wrap('<div class="slick-list"/>')
              .parent()),
            e.$slideTrack.css("opacity", 0),
            (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
              (e.options.slidesToScroll = 1),
            t("img[data-lazy]", e.$slider)
              .not("[src]")
              .addClass("slick-loading"),
            e.setupInfinite(),
            e.buildArrows(),
            e.buildDots(),
            e.updateDots(),
            e.setSlideClasses(
              "number" == typeof e.currentSlide ? e.currentSlide : 0
            ),
            !0 === e.options.draggable && e.$list.addClass("draggable");
        }),
        (e.prototype.buildRows = function () {
          var t,
            e,
            i,
            n,
            r,
            o,
            s,
            a = this;
          if (
            ((n = document.createDocumentFragment()),
            (o = a.$slider.children()),
            a.options.rows > 1)
          ) {
            for (
              s = a.options.slidesPerRow * a.options.rows,
                r = Math.ceil(o.length / s),
                t = 0;
              t < r;
              t++
            ) {
              var l = document.createElement("div");
              for (e = 0; e < a.options.rows; e++) {
                var u = document.createElement("div");
                for (i = 0; i < a.options.slidesPerRow; i++) {
                  var c = t * s + (e * a.options.slidesPerRow + i);
                  o.get(c) && u.appendChild(o.get(c));
                }
                l.appendChild(u);
              }
              n.appendChild(l);
            }
            a.$slider.empty().append(n),
              a.$slider
                .children()
                .children()
                .children()
                .css({
                  width: 100 / a.options.slidesPerRow + "%",
                  display: "inline-block",
                });
          }
        }),
        (e.prototype.checkResponsive = function (e, i) {
          var n,
            r,
            o,
            s = this,
            a = !1,
            l = s.$slider.width(),
            u = window.innerWidth || t(window).width();
          if (
            ("window" === s.respondTo
              ? (o = u)
              : "slider" === s.respondTo
              ? (o = l)
              : "min" === s.respondTo && (o = Math.min(u, l)),
            s.options.responsive &&
              s.options.responsive.length &&
              null !== s.options.responsive)
          ) {
            for (n in ((r = null), s.breakpoints))
              s.breakpoints.hasOwnProperty(n) &&
                (!1 === s.originalSettings.mobileFirst
                  ? o < s.breakpoints[n] && (r = s.breakpoints[n])
                  : o > s.breakpoints[n] && (r = s.breakpoints[n]));
            null !== r
              ? null !== s.activeBreakpoint
                ? (r !== s.activeBreakpoint || i) &&
                  ((s.activeBreakpoint = r),
                  "unslick" === s.breakpointSettings[r]
                    ? s.unslick(r)
                    : ((s.options = t.extend(
                        {},
                        s.originalSettings,
                        s.breakpointSettings[r]
                      )),
                      !0 === e && (s.currentSlide = s.options.initialSlide),
                      s.refresh(e)),
                  (a = r))
                : ((s.activeBreakpoint = r),
                  "unslick" === s.breakpointSettings[r]
                    ? s.unslick(r)
                    : ((s.options = t.extend(
                        {},
                        s.originalSettings,
                        s.breakpointSettings[r]
                      )),
                      !0 === e && (s.currentSlide = s.options.initialSlide),
                      s.refresh(e)),
                  (a = r))
              : null !== s.activeBreakpoint &&
                ((s.activeBreakpoint = null),
                (s.options = s.originalSettings),
                !0 === e && (s.currentSlide = s.options.initialSlide),
                s.refresh(e),
                (a = r)),
              e || !1 === a || s.$slider.trigger("breakpoint", [s, a]);
          }
        }),
        (e.prototype.changeSlide = function (e, i) {
          var n,
            r,
            o = this,
            s = t(e.currentTarget);
          switch (
            (s.is("a") && e.preventDefault(),
            s.is("li") || (s = s.closest("li")),
            (n =
              o.slideCount % o.options.slidesToScroll != 0
                ? 0
                : (o.slideCount - o.currentSlide) % o.options.slidesToScroll),
            e.data.message)
          ) {
            case "previous":
              (r =
                0 === n
                  ? o.options.slidesToScroll
                  : o.options.slidesToShow - n),
                o.slideCount > o.options.slidesToShow &&
                  o.slideHandler(o.currentSlide - r, !1, i);
              break;
            case "next":
              (r = 0 === n ? o.options.slidesToScroll : n),
                o.slideCount > o.options.slidesToShow &&
                  o.slideHandler(o.currentSlide + r, !1, i);
              break;
            case "index":
              var a =
                0 === e.data.index
                  ? 0
                  : e.data.index || s.index() * o.options.slidesToScroll;
              o.slideHandler(o.checkNavigable(a), !1, i),
                s.children().trigger("focus");
              break;
            default:
              return;
          }
        }),
        (e.prototype.checkNavigable = function (t) {
          var e, i;
          if (((i = 0), t > (e = this.getNavigableIndexes())[e.length - 1]))
            t = e[e.length - 1];
          else
            for (var n in e) {
              if (t < e[n]) {
                t = i;
                break;
              }
              i = e[n];
            }
          return t;
        }),
        (e.prototype.cleanUpEvents = function () {
          var e = this;
          e.options.dots &&
            null !== e.$dots &&
            (t("li", e.$dots)
              .off("click.slick", e.changeSlide)
              .off("mouseenter.slick", t.proxy(e.interrupt, e, !0))
              .off("mouseleave.slick", t.proxy(e.interrupt, e, !1)),
            !0 === e.options.accessibility &&
              e.$dots.off("keydown.slick", e.keyHandler)),
            e.$slider.off("focus.slick blur.slick"),
            !0 === e.options.arrows &&
              e.slideCount > e.options.slidesToShow &&
              (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
              e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
              !0 === e.options.accessibility &&
                (e.$prevArrow &&
                  e.$prevArrow.off("keydown.slick", e.keyHandler),
                e.$nextArrow &&
                  e.$nextArrow.off("keydown.slick", e.keyHandler))),
            e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
            e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
            e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
            e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
            e.$list.off("click.slick", e.clickHandler),
            t(document).off(e.visibilityChange, e.visibility),
            e.cleanUpSlideEvents(),
            !0 === e.options.accessibility &&
              e.$list.off("keydown.slick", e.keyHandler),
            !0 === e.options.focusOnSelect &&
              t(e.$slideTrack).children().off("click.slick", e.selectHandler),
            t(window).off(
              "orientationchange.slick.slick-" + e.instanceUid,
              e.orientationChange
            ),
            t(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
            t("[draggable!=true]", e.$slideTrack).off(
              "dragstart",
              e.preventDefault
            ),
            t(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
        }),
        (e.prototype.cleanUpSlideEvents = function () {
          var e = this;
          e.$list.off("mouseenter.slick", t.proxy(e.interrupt, e, !0)),
            e.$list.off("mouseleave.slick", t.proxy(e.interrupt, e, !1));
        }),
        (e.prototype.cleanUpRows = function () {
          var t,
            e = this;
          e.options.rows > 1 &&
            ((t = e.$slides.children().children()).removeAttr("style"),
            e.$slider.empty().append(t));
        }),
        (e.prototype.clickHandler = function (t) {
          !1 === this.shouldClick &&
            (t.stopImmediatePropagation(),
            t.stopPropagation(),
            t.preventDefault());
        }),
        (e.prototype.destroy = function (e) {
          var i = this;
          i.autoPlayClear(),
            (i.touchObject = {}),
            i.cleanUpEvents(),
            t(".slick-cloned", i.$slider).detach(),
            i.$dots && i.$dots.remove(),
            i.$prevArrow &&
              i.$prevArrow.length &&
              (i.$prevArrow
                .removeClass("slick-disabled slick-arrow slick-hidden")
                .removeAttr("aria-hidden aria-disabled tabindex")
                .css("display", ""),
              i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()),
            i.$nextArrow &&
              i.$nextArrow.length &&
              (i.$nextArrow
                .removeClass("slick-disabled slick-arrow slick-hidden")
                .removeAttr("aria-hidden aria-disabled tabindex")
                .css("display", ""),
              i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()),
            i.$slides &&
              (i.$slides
                .removeClass(
                  "slick-slide slick-active slick-center slick-visible slick-current"
                )
                .removeAttr("aria-hidden")
                .removeAttr("data-slick-index")
                .each(function () {
                  t(this).attr("style", t(this).data("originalStyling"));
                }),
              i.$slideTrack.children(this.options.slide).detach(),
              i.$slideTrack.detach(),
              i.$list.detach(),
              i.$slider.append(i.$slides)),
            i.cleanUpRows(),
            i.$slider.removeClass("slick-slider"),
            i.$slider.removeClass("slick-initialized"),
            i.$slider.removeClass("slick-dotted"),
            (i.unslicked = !0),
            e || i.$slider.trigger("destroy", [i]);
        }),
        (e.prototype.disableTransition = function (t) {
          var e = this,
            i = {};
          (i[e.transitionType] = ""),
            !1 === e.options.fade
              ? e.$slideTrack.css(i)
              : e.$slides.eq(t).css(i);
        }),
        (e.prototype.fadeSlide = function (t, e) {
          var i = this;
          !1 === i.cssTransitions
            ? (i.$slides.eq(t).css({ zIndex: i.options.zIndex }),
              i.$slides
                .eq(t)
                .animate({ opacity: 1 }, i.options.speed, i.options.easing, e))
            : (i.applyTransition(t),
              i.$slides.eq(t).css({ opacity: 1, zIndex: i.options.zIndex }),
              e &&
                setTimeout(function () {
                  i.disableTransition(t), e.call();
                }, i.options.speed));
        }),
        (e.prototype.fadeSlideOut = function (t) {
          var e = this;
          !1 === e.cssTransitions
            ? e.$slides
                .eq(t)
                .animate(
                  { opacity: 0, zIndex: e.options.zIndex - 2 },
                  e.options.speed,
                  e.options.easing
                )
            : (e.applyTransition(t),
              e.$slides
                .eq(t)
                .css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
        }),
        (e.prototype.filterSlides = e.prototype.slickFilter =
          function (t) {
            var e = this;
            null !== t &&
              ((e.$slidesCache = e.$slides),
              e.unload(),
              e.$slideTrack.children(this.options.slide).detach(),
              e.$slidesCache.filter(t).appendTo(e.$slideTrack),
              e.reinit());
          }),
        (e.prototype.focusHandler = function () {
          var e = this;
          e.$slider
            .off("focus.slick blur.slick")
            .on("focus.slick blur.slick", "*", function (i) {
              i.stopImmediatePropagation();
              var n = t(this);
              setTimeout(function () {
                e.options.pauseOnFocus &&
                  ((e.focussed = n.is(":focus")), e.autoPlay());
              }, 0);
            });
        }),
        (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
          function () {
            return this.currentSlide;
          }),
        (e.prototype.getDotCount = function () {
          var t = this,
            e = 0,
            i = 0,
            n = 0;
          if (!0 === t.options.infinite)
            if (t.slideCount <= t.options.slidesToShow) ++n;
            else
              for (; e < t.slideCount; )
                ++n,
                  (e = i + t.options.slidesToScroll),
                  (i +=
                    t.options.slidesToScroll <= t.options.slidesToShow
                      ? t.options.slidesToScroll
                      : t.options.slidesToShow);
          else if (!0 === t.options.centerMode) n = t.slideCount;
          else if (t.options.asNavFor)
            for (; e < t.slideCount; )
              ++n,
                (e = i + t.options.slidesToScroll),
                (i +=
                  t.options.slidesToScroll <= t.options.slidesToShow
                    ? t.options.slidesToScroll
                    : t.options.slidesToShow);
          else
            n =
              1 +
              Math.ceil(
                (t.slideCount - t.options.slidesToShow) /
                  t.options.slidesToScroll
              );
          return n - 1;
        }),
        (e.prototype.getLeft = function (t) {
          var e,
            i,
            n,
            r,
            o = this,
            s = 0;
          return (
            (o.slideOffset = 0),
            (i = o.$slides.first().outerHeight(!0)),
            !0 === o.options.infinite
              ? (o.slideCount > o.options.slidesToShow &&
                  ((o.slideOffset = o.slideWidth * o.options.slidesToShow * -1),
                  (r = -1),
                  !0 === o.options.vertical &&
                    !0 === o.options.centerMode &&
                    (2 === o.options.slidesToShow
                      ? (r = -1.5)
                      : 1 === o.options.slidesToShow && (r = -2)),
                  (s = i * o.options.slidesToShow * r)),
                o.slideCount % o.options.slidesToScroll != 0 &&
                  t + o.options.slidesToScroll > o.slideCount &&
                  o.slideCount > o.options.slidesToShow &&
                  (t > o.slideCount
                    ? ((o.slideOffset =
                        (o.options.slidesToShow - (t - o.slideCount)) *
                        o.slideWidth *
                        -1),
                      (s =
                        (o.options.slidesToShow - (t - o.slideCount)) * i * -1))
                    : ((o.slideOffset =
                        (o.slideCount % o.options.slidesToScroll) *
                        o.slideWidth *
                        -1),
                      (s =
                        (o.slideCount % o.options.slidesToScroll) * i * -1))))
              : t + o.options.slidesToShow > o.slideCount &&
                ((o.slideOffset =
                  (t + o.options.slidesToShow - o.slideCount) * o.slideWidth),
                (s = (t + o.options.slidesToShow - o.slideCount) * i)),
            o.slideCount <= o.options.slidesToShow &&
              ((o.slideOffset = 0), (s = 0)),
            !0 === o.options.centerMode &&
            o.slideCount <= o.options.slidesToShow
              ? (o.slideOffset =
                  (o.slideWidth * Math.floor(o.options.slidesToShow)) / 2 -
                  (o.slideWidth * o.slideCount) / 2)
              : !0 === o.options.centerMode && !0 === o.options.infinite
              ? (o.slideOffset +=
                  o.slideWidth * Math.floor(o.options.slidesToShow / 2) -
                  o.slideWidth)
              : !0 === o.options.centerMode &&
                ((o.slideOffset = 0),
                (o.slideOffset +=
                  o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
            (e =
              !1 === o.options.vertical
                ? t * o.slideWidth * -1 + o.slideOffset
                : t * i * -1 + s),
            !0 === o.options.variableWidth &&
              ((n =
                o.slideCount <= o.options.slidesToShow ||
                !1 === o.options.infinite
                  ? o.$slideTrack.children(".slick-slide").eq(t)
                  : o.$slideTrack
                      .children(".slick-slide")
                      .eq(t + o.options.slidesToShow)),
              (e =
                !0 === o.options.rtl
                  ? n[0]
                    ? -1 * (o.$slideTrack.width() - n[0].offsetLeft - n.width())
                    : 0
                  : n[0]
                  ? -1 * n[0].offsetLeft
                  : 0),
              !0 === o.options.centerMode &&
                ((n =
                  o.slideCount <= o.options.slidesToShow ||
                  !1 === o.options.infinite
                    ? o.$slideTrack.children(".slick-slide").eq(t)
                    : o.$slideTrack
                        .children(".slick-slide")
                        .eq(t + o.options.slidesToShow + 1)),
                (e =
                  !0 === o.options.rtl
                    ? n[0]
                      ? -1 *
                        (o.$slideTrack.width() - n[0].offsetLeft - n.width())
                      : 0
                    : n[0]
                    ? -1 * n[0].offsetLeft
                    : 0),
                (e += (o.$list.width() - n.outerWidth()) / 2))),
            e
          );
        }),
        (e.prototype.getOption = e.prototype.slickGetOption =
          function (t) {
            return this.options[t];
          }),
        (e.prototype.getNavigableIndexes = function () {
          var t,
            e = this,
            i = 0,
            n = 0,
            r = [];
          for (
            !1 === e.options.infinite
              ? (t = e.slideCount)
              : ((i = -1 * e.options.slidesToScroll),
                (n = -1 * e.options.slidesToScroll),
                (t = 2 * e.slideCount));
            i < t;

          )
            r.push(i),
              (i = n + e.options.slidesToScroll),
              (n +=
                e.options.slidesToScroll <= e.options.slidesToShow
                  ? e.options.slidesToScroll
                  : e.options.slidesToShow);
          return r;
        }),
        (e.prototype.getSlick = function () {
          return this;
        }),
        (e.prototype.getSlideCount = function () {
          var e,
            i,
            n = this;
          return (
            (i =
              !0 === n.options.centerMode
                ? n.slideWidth * Math.floor(n.options.slidesToShow / 2)
                : 0),
            !0 === n.options.swipeToSlide
              ? (n.$slideTrack.find(".slick-slide").each(function (r, o) {
                  if (
                    o.offsetLeft - i + t(o).outerWidth() / 2 >
                    -1 * n.swipeLeft
                  )
                    return (e = o), !1;
                }),
                Math.abs(t(e).attr("data-slick-index") - n.currentSlide) || 1)
              : n.options.slidesToScroll
          );
        }),
        (e.prototype.goTo = e.prototype.slickGoTo =
          function (t, e) {
            this.changeSlide(
              { data: { message: "index", index: parseInt(t) } },
              e
            );
          }),
        (e.prototype.init = function (e) {
          var i = this;
          t(i.$slider).hasClass("slick-initialized") ||
            (t(i.$slider).addClass("slick-initialized"),
            i.buildRows(),
            i.buildOut(),
            i.setProps(),
            i.startLoad(),
            i.loadSlider(),
            i.initializeEvents(),
            i.updateArrows(),
            i.updateDots(),
            i.checkResponsive(!0),
            i.focusHandler()),
            e && i.$slider.trigger("init", [i]),
            !0 === i.options.accessibility && i.initADA(),
            i.options.autoplay && ((i.paused = !1), i.autoPlay());
        }),
        (e.prototype.initADA = function () {
          var e = this,
            i = Math.ceil(e.slideCount / e.options.slidesToShow),
            n = e.getNavigableIndexes().filter(function (t) {
              return t >= 0 && t < e.slideCount;
            });
          e.$slides
            .add(e.$slideTrack.find(".slick-cloned"))
            .attr({ "aria-hidden": "true", tabindex: "-1" })
            .find("a, input, button, select")
            .attr({ tabindex: "-1" }),
            null !== e.$dots &&
              (e.$slides
                .not(e.$slideTrack.find(".slick-cloned"))
                .each(function (i) {
                  var r = n.indexOf(i);
                  t(this).attr({
                    role: "tabpanel",
                    id: "slick-slide" + e.instanceUid + i,
                    tabindex: -1,
                  }),
                    -1 !== r &&
                      t(this).attr({
                        "aria-describedby":
                          "slick-slide-control" + e.instanceUid + r,
                      });
                }),
              e.$dots
                .attr("role", "tablist")
                .find("li")
                .each(function (r) {
                  var o = n[r];
                  t(this).attr({ role: "presentation" }),
                    t(this)
                      .find("button")
                      .first()
                      .attr({
                        role: "tab",
                        id: "slick-slide-control" + e.instanceUid + r,
                        "aria-controls": "slick-slide" + e.instanceUid + o,
                        "aria-label": r + 1 + " of " + i,
                        "aria-selected": null,
                        tabindex: "-1",
                      });
                })
                .eq(e.currentSlide)
                .find("button")
                .attr({ "aria-selected": "true", tabindex: "0" })
                .end());
          for (
            var r = e.currentSlide, o = r + e.options.slidesToShow;
            r < o;
            r++
          )
            e.$slides.eq(r).attr("tabindex", 0);
          e.activateADA();
        }),
        (e.prototype.initArrowEvents = function () {
          var t = this;
          !0 === t.options.arrows &&
            t.slideCount > t.options.slidesToShow &&
            (t.$prevArrow
              .off("click.slick")
              .on("click.slick", { message: "previous" }, t.changeSlide),
            t.$nextArrow
              .off("click.slick")
              .on("click.slick", { message: "next" }, t.changeSlide),
            !0 === t.options.accessibility &&
              (t.$prevArrow.on("keydown.slick", t.keyHandler),
              t.$nextArrow.on("keydown.slick", t.keyHandler)));
        }),
        (e.prototype.initDotEvents = function () {
          var e = this;
          !0 === e.options.dots &&
            (t("li", e.$dots).on(
              "click.slick",
              { message: "index" },
              e.changeSlide
            ),
            !0 === e.options.accessibility &&
              e.$dots.on("keydown.slick", e.keyHandler)),
            !0 === e.options.dots &&
              !0 === e.options.pauseOnDotsHover &&
              t("li", e.$dots)
                .on("mouseenter.slick", t.proxy(e.interrupt, e, !0))
                .on("mouseleave.slick", t.proxy(e.interrupt, e, !1));
        }),
        (e.prototype.initSlideEvents = function () {
          var e = this;
          e.options.pauseOnHover &&
            (e.$list.on("mouseenter.slick", t.proxy(e.interrupt, e, !0)),
            e.$list.on("mouseleave.slick", t.proxy(e.interrupt, e, !1)));
        }),
        (e.prototype.initializeEvents = function () {
          var e = this;
          e.initArrowEvents(),
            e.initDotEvents(),
            e.initSlideEvents(),
            e.$list.on(
              "touchstart.slick mousedown.slick",
              { action: "start" },
              e.swipeHandler
            ),
            e.$list.on(
              "touchmove.slick mousemove.slick",
              { action: "move" },
              e.swipeHandler
            ),
            e.$list.on(
              "touchend.slick mouseup.slick",
              { action: "end" },
              e.swipeHandler
            ),
            e.$list.on(
              "touchcancel.slick mouseleave.slick",
              { action: "end" },
              e.swipeHandler
            ),
            e.$list.on("click.slick", e.clickHandler),
            t(document).on(e.visibilityChange, t.proxy(e.visibility, e)),
            !0 === e.options.accessibility &&
              e.$list.on("keydown.slick", e.keyHandler),
            !0 === e.options.focusOnSelect &&
              t(e.$slideTrack).children().on("click.slick", e.selectHandler),
            t(window).on(
              "orientationchange.slick.slick-" + e.instanceUid,
              t.proxy(e.orientationChange, e)
            ),
            t(window).on(
              "resize.slick.slick-" + e.instanceUid,
              t.proxy(e.resize, e)
            ),
            t("[draggable!=true]", e.$slideTrack).on(
              "dragstart",
              e.preventDefault
            ),
            t(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
            t(e.setPosition);
        }),
        (e.prototype.initUI = function () {
          var t = this;
          !0 === t.options.arrows &&
            t.slideCount > t.options.slidesToShow &&
            (t.$prevArrow.show(), t.$nextArrow.show()),
            !0 === t.options.dots &&
              t.slideCount > t.options.slidesToShow &&
              t.$dots.show();
        }),
        (e.prototype.keyHandler = function (t) {
          var e = this;
          t.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
            (37 === t.keyCode && !0 === e.options.accessibility
              ? e.changeSlide({
                  data: { message: !0 === e.options.rtl ? "next" : "previous" },
                })
              : 39 === t.keyCode &&
                !0 === e.options.accessibility &&
                e.changeSlide({
                  data: { message: !0 === e.options.rtl ? "previous" : "next" },
                }));
        }),
        (e.prototype.lazyLoad = function () {
          function e(e) {
            t("img[data-lazy]", e).each(function () {
              var e = t(this),
                i = t(this).attr("data-lazy"),
                n = t(this).attr("data-srcset"),
                r = t(this).attr("data-sizes") || o.$slider.attr("data-sizes"),
                s = document.createElement("img");
              (s.onload = function () {
                e.animate({ opacity: 0 }, 100, function () {
                  n && (e.attr("srcset", n), r && e.attr("sizes", r)),
                    e.attr("src", i).animate({ opacity: 1 }, 200, function () {
                      e.removeAttr(
                        "data-lazy data-srcset data-sizes"
                      ).removeClass("slick-loading");
                    }),
                    o.$slider.trigger("lazyLoaded", [o, e, i]);
                });
              }),
                (s.onerror = function () {
                  e
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                    o.$slider.trigger("lazyLoadError", [o, e, i]);
                }),
                (s.src = i);
            });
          }
          var i,
            n,
            r,
            o = this;
          if (
            (!0 === o.options.centerMode
              ? !0 === o.options.infinite
                ? (r =
                    (n = o.currentSlide + (o.options.slidesToShow / 2 + 1)) +
                    o.options.slidesToShow +
                    2)
                : ((n = Math.max(
                    0,
                    o.currentSlide - (o.options.slidesToShow / 2 + 1)
                  )),
                  (r = o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide))
              : ((n = o.options.infinite
                  ? o.options.slidesToShow + o.currentSlide
                  : o.currentSlide),
                (r = Math.ceil(n + o.options.slidesToShow)),
                !0 === o.options.fade &&
                  (n > 0 && n--, r <= o.slideCount && r++)),
            (i = o.$slider.find(".slick-slide").slice(n, r)),
            "anticipated" === o.options.lazyLoad)
          )
            for (
              var s = n - 1, a = r, l = o.$slider.find(".slick-slide"), u = 0;
              u < o.options.slidesToScroll;
              u++
            )
              s < 0 && (s = o.slideCount - 1),
                (i = (i = i.add(l.eq(s))).add(l.eq(a))),
                s--,
                a++;
          e(i),
            o.slideCount <= o.options.slidesToShow
              ? e(o.$slider.find(".slick-slide"))
              : o.currentSlide >= o.slideCount - o.options.slidesToShow
              ? e(
                  o.$slider
                    .find(".slick-cloned")
                    .slice(0, o.options.slidesToShow)
                )
              : 0 === o.currentSlide &&
                e(
                  o.$slider
                    .find(".slick-cloned")
                    .slice(-1 * o.options.slidesToShow)
                );
        }),
        (e.prototype.loadSlider = function () {
          var t = this;
          t.setPosition(),
            t.$slideTrack.css({ opacity: 1 }),
            t.$slider.removeClass("slick-loading"),
            t.initUI(),
            "progressive" === t.options.lazyLoad && t.progressiveLazyLoad();
        }),
        (e.prototype.next = e.prototype.slickNext =
          function () {
            this.changeSlide({ data: { message: "next" } });
          }),
        (e.prototype.orientationChange = function () {
          this.checkResponsive(), this.setPosition();
        }),
        (e.prototype.pause = e.prototype.slickPause =
          function () {
            this.autoPlayClear(), (this.paused = !0);
          }),
        (e.prototype.play = e.prototype.slickPlay =
          function () {
            var t = this;
            t.autoPlay(),
              (t.options.autoplay = !0),
              (t.paused = !1),
              (t.focussed = !1),
              (t.interrupted = !1);
          }),
        (e.prototype.postSlide = function (e) {
          var i = this;
          i.unslicked ||
            (i.$slider.trigger("afterChange", [i, e]),
            (i.animating = !1),
            i.slideCount > i.options.slidesToShow && i.setPosition(),
            (i.swipeLeft = null),
            i.options.autoplay && i.autoPlay(),
            !0 === i.options.accessibility &&
              (i.initADA(),
              i.options.focusOnChange &&
                t(i.$slides.get(i.currentSlide)).attr("tabindex", 0).focus()));
        }),
        (e.prototype.prev = e.prototype.slickPrev =
          function () {
            this.changeSlide({ data: { message: "previous" } });
          }),
        (e.prototype.preventDefault = function (t) {
          t.preventDefault();
        }),
        (e.prototype.progressiveLazyLoad = function (e) {
          e = e || 1;
          var i,
            n,
            r,
            o,
            s,
            a = this,
            l = t("img[data-lazy]", a.$slider);
          l.length
            ? ((i = l.first()),
              (n = i.attr("data-lazy")),
              (r = i.attr("data-srcset")),
              (o = i.attr("data-sizes") || a.$slider.attr("data-sizes")),
              ((s = document.createElement("img")).onload = function () {
                r && (i.attr("srcset", r), o && i.attr("sizes", o)),
                  i
                    .attr("src", n)
                    .removeAttr("data-lazy data-srcset data-sizes")
                    .removeClass("slick-loading"),
                  !0 === a.options.adaptiveHeight && a.setPosition(),
                  a.$slider.trigger("lazyLoaded", [a, i, n]),
                  a.progressiveLazyLoad();
              }),
              (s.onerror = function () {
                e < 3
                  ? setTimeout(function () {
                      a.progressiveLazyLoad(e + 1);
                    }, 500)
                  : (i
                      .removeAttr("data-lazy")
                      .removeClass("slick-loading")
                      .addClass("slick-lazyload-error"),
                    a.$slider.trigger("lazyLoadError", [a, i, n]),
                    a.progressiveLazyLoad());
              }),
              (s.src = n))
            : a.$slider.trigger("allImagesLoaded", [a]);
        }),
        (e.prototype.refresh = function (e) {
          var i,
            n,
            r = this;
          (n = r.slideCount - r.options.slidesToShow),
            !r.options.infinite && r.currentSlide > n && (r.currentSlide = n),
            r.slideCount <= r.options.slidesToShow && (r.currentSlide = 0),
            (i = r.currentSlide),
            r.destroy(!0),
            t.extend(r, r.initials, { currentSlide: i }),
            r.init(),
            e || r.changeSlide({ data: { message: "index", index: i } }, !1);
        }),
        (e.prototype.registerBreakpoints = function () {
          var e,
            i,
            n,
            r = this,
            o = r.options.responsive || null;
          if ("array" === t.type(o) && o.length) {
            for (e in ((r.respondTo = r.options.respondTo || "window"), o))
              if (((n = r.breakpoints.length - 1), o.hasOwnProperty(e))) {
                for (i = o[e].breakpoint; n >= 0; )
                  r.breakpoints[n] &&
                    r.breakpoints[n] === i &&
                    r.breakpoints.splice(n, 1),
                    n--;
                r.breakpoints.push(i),
                  (r.breakpointSettings[i] = o[e].settings);
              }
            r.breakpoints.sort(function (t, e) {
              return r.options.mobileFirst ? t - e : e - t;
            });
          }
        }),
        (e.prototype.reinit = function () {
          var e = this;
          (e.$slides = e.$slideTrack
            .children(e.options.slide)
            .addClass("slick-slide")),
            (e.slideCount = e.$slides.length),
            e.currentSlide >= e.slideCount &&
              0 !== e.currentSlide &&
              (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
            e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
            e.registerBreakpoints(),
            e.setProps(),
            e.setupInfinite(),
            e.buildArrows(),
            e.updateArrows(),
            e.initArrowEvents(),
            e.buildDots(),
            e.updateDots(),
            e.initDotEvents(),
            e.cleanUpSlideEvents(),
            e.initSlideEvents(),
            e.checkResponsive(!1, !0),
            !0 === e.options.focusOnSelect &&
              t(e.$slideTrack).children().on("click.slick", e.selectHandler),
            e.setSlideClasses(
              "number" == typeof e.currentSlide ? e.currentSlide : 0
            ),
            e.setPosition(),
            e.focusHandler(),
            (e.paused = !e.options.autoplay),
            e.autoPlay(),
            e.$slider.trigger("reInit", [e]);
        }),
        (e.prototype.resize = function () {
          var e = this;
          t(window).width() !== e.windowWidth &&
            (clearTimeout(e.windowDelay),
            (e.windowDelay = window.setTimeout(function () {
              (e.windowWidth = t(window).width()),
                e.checkResponsive(),
                e.unslicked || e.setPosition();
            }, 50)));
        }),
        (e.prototype.removeSlide = e.prototype.slickRemove =
          function (t, e, i) {
            var n = this;
            if (
              ((t =
                "boolean" == typeof t
                  ? !0 === (e = t)
                    ? 0
                    : n.slideCount - 1
                  : !0 === e
                  ? --t
                  : t),
              n.slideCount < 1 || t < 0 || t > n.slideCount - 1)
            )
              return !1;
            n.unload(),
              !0 === i
                ? n.$slideTrack.children().remove()
                : n.$slideTrack.children(this.options.slide).eq(t).remove(),
              (n.$slides = n.$slideTrack.children(this.options.slide)),
              n.$slideTrack.children(this.options.slide).detach(),
              n.$slideTrack.append(n.$slides),
              (n.$slidesCache = n.$slides),
              n.reinit();
          }),
        (e.prototype.setCSS = function (t) {
          var e,
            i,
            n = this,
            r = {};
          !0 === n.options.rtl && (t = -t),
            (e = "left" == n.positionProp ? Math.ceil(t) + "px" : "0px"),
            (i = "top" == n.positionProp ? Math.ceil(t) + "px" : "0px"),
            (r[n.positionProp] = t),
            !1 === n.transformsEnabled
              ? n.$slideTrack.css(r)
              : ((r = {}),
                !1 === n.cssTransitions
                  ? ((r[n.animType] = "translate(" + e + ", " + i + ")"),
                    n.$slideTrack.css(r))
                  : ((r[n.animType] = "translate3d(" + e + ", " + i + ", 0px)"),
                    n.$slideTrack.css(r)));
        }),
        (e.prototype.setDimensions = function () {
          var t = this;
          !1 === t.options.vertical
            ? !0 === t.options.centerMode &&
              t.$list.css({ padding: "0px " + t.options.centerPadding })
            : (t.$list.height(
                t.$slides.first().outerHeight(!0) * t.options.slidesToShow
              ),
              !0 === t.options.centerMode &&
                t.$list.css({ padding: t.options.centerPadding + " 0px" })),
            (t.listWidth = t.$list.width()),
            (t.listHeight = t.$list.height()),
            !1 === t.options.vertical && !1 === t.options.variableWidth
              ? ((t.slideWidth = Math.ceil(
                  t.listWidth / t.options.slidesToShow
                )),
                t.$slideTrack.width(
                  Math.ceil(
                    t.slideWidth * t.$slideTrack.children(".slick-slide").length
                  )
                ))
              : !0 === t.options.variableWidth
              ? t.$slideTrack.width(5e3 * t.slideCount)
              : ((t.slideWidth = Math.ceil(t.listWidth)),
                t.$slideTrack.height(
                  Math.ceil(
                    t.$slides.first().outerHeight(!0) *
                      t.$slideTrack.children(".slick-slide").length
                  )
                ));
          var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
          !1 === t.options.variableWidth &&
            t.$slideTrack.children(".slick-slide").width(t.slideWidth - e);
        }),
        (e.prototype.setFade = function () {
          var e,
            i = this;
          i.$slides.each(function (n, r) {
            (e = i.slideWidth * n * -1),
              !0 === i.options.rtl
                ? t(r).css({
                    position: "relative",
                    right: e,
                    top: 0,
                    zIndex: i.options.zIndex - 2,
                    opacity: 0,
                  })
                : t(r).css({
                    position: "relative",
                    left: e,
                    top: 0,
                    zIndex: i.options.zIndex - 2,
                    opacity: 0,
                  });
          }),
            i.$slides
              .eq(i.currentSlide)
              .css({ zIndex: i.options.zIndex - 1, opacity: 1 });
        }),
        (e.prototype.setHeight = function () {
          var t = this;
          if (
            1 === t.options.slidesToShow &&
            !0 === t.options.adaptiveHeight &&
            !1 === t.options.vertical
          ) {
            var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
            t.$list.css("height", e);
          }
        }),
        (e.prototype.setOption = e.prototype.slickSetOption =
          function () {
            var e,
              i,
              n,
              r,
              o,
              s = this,
              a = !1;
            if (
              ("object" === t.type(arguments[0])
                ? ((n = arguments[0]), (a = arguments[1]), (o = "multiple"))
                : "string" === t.type(arguments[0]) &&
                  ((n = arguments[0]),
                  (r = arguments[1]),
                  (a = arguments[2]),
                  "responsive" === arguments[0] &&
                  "array" === t.type(arguments[1])
                    ? (o = "responsive")
                    : void 0 !== arguments[1] && (o = "single")),
              "single" === o)
            )
              s.options[n] = r;
            else if ("multiple" === o)
              t.each(n, function (t, e) {
                s.options[t] = e;
              });
            else if ("responsive" === o)
              for (i in r)
                if ("array" !== t.type(s.options.responsive))
                  s.options.responsive = [r[i]];
                else {
                  for (e = s.options.responsive.length - 1; e >= 0; )
                    s.options.responsive[e].breakpoint === r[i].breakpoint &&
                      s.options.responsive.splice(e, 1),
                      e--;
                  s.options.responsive.push(r[i]);
                }
            a && (s.unload(), s.reinit());
          }),
        (e.prototype.setPosition = function () {
          var t = this;
          t.setDimensions(),
            t.setHeight(),
            !1 === t.options.fade
              ? t.setCSS(t.getLeft(t.currentSlide))
              : t.setFade(),
            t.$slider.trigger("setPosition", [t]);
        }),
        (e.prototype.setProps = function () {
          var t = this,
            e = document.body.style;
          (t.positionProp = !0 === t.options.vertical ? "top" : "left"),
            "top" === t.positionProp
              ? t.$slider.addClass("slick-vertical")
              : t.$slider.removeClass("slick-vertical"),
            (void 0 === e.WebkitTransition &&
              void 0 === e.MozTransition &&
              void 0 === e.msTransition) ||
              (!0 === t.options.useCSS && (t.cssTransitions = !0)),
            t.options.fade &&
              ("number" == typeof t.options.zIndex
                ? t.options.zIndex < 3 && (t.options.zIndex = 3)
                : (t.options.zIndex = t.defaults.zIndex)),
            void 0 !== e.OTransform &&
              ((t.animType = "OTransform"),
              (t.transformType = "-o-transform"),
              (t.transitionType = "OTransition"),
              void 0 === e.perspectiveProperty &&
                void 0 === e.webkitPerspective &&
                (t.animType = !1)),
            void 0 !== e.MozTransform &&
              ((t.animType = "MozTransform"),
              (t.transformType = "-moz-transform"),
              (t.transitionType = "MozTransition"),
              void 0 === e.perspectiveProperty &&
                void 0 === e.MozPerspective &&
                (t.animType = !1)),
            void 0 !== e.webkitTransform &&
              ((t.animType = "webkitTransform"),
              (t.transformType = "-webkit-transform"),
              (t.transitionType = "webkitTransition"),
              void 0 === e.perspectiveProperty &&
                void 0 === e.webkitPerspective &&
                (t.animType = !1)),
            void 0 !== e.msTransform &&
              ((t.animType = "msTransform"),
              (t.transformType = "-ms-transform"),
              (t.transitionType = "msTransition"),
              void 0 === e.msTransform && (t.animType = !1)),
            void 0 !== e.transform &&
              !1 !== t.animType &&
              ((t.animType = "transform"),
              (t.transformType = "transform"),
              (t.transitionType = "transition")),
            (t.transformsEnabled =
              t.options.useTransform &&
              null !== t.animType &&
              !1 !== t.animType);
        }),
        (e.prototype.setSlideClasses = function (t) {
          var e,
            i,
            n,
            r,
            o = this;
          if (
            ((i = o.$slider
              .find(".slick-slide")
              .removeClass("slick-active slick-center slick-current")
              .attr("aria-hidden", "true")),
            o.$slides.eq(t).addClass("slick-current"),
            !0 === o.options.centerMode)
          ) {
            var s = o.options.slidesToShow % 2 == 0 ? 1 : 0;
            (e = Math.floor(o.options.slidesToShow / 2)),
              !0 === o.options.infinite &&
                (t >= e && t <= o.slideCount - 1 - e
                  ? o.$slides
                      .slice(t - e + s, t + e + 1)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : ((n = o.options.slidesToShow + t),
                    i
                      .slice(n - e + 1 + s, n + e + 2)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")),
                0 === t
                  ? i
                      .eq(i.length - 1 - o.options.slidesToShow)
                      .addClass("slick-center")
                  : t === o.slideCount - 1 &&
                    i.eq(o.options.slidesToShow).addClass("slick-center")),
              o.$slides.eq(t).addClass("slick-center");
          } else
            t >= 0 && t <= o.slideCount - o.options.slidesToShow
              ? o.$slides
                  .slice(t, t + o.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : i.length <= o.options.slidesToShow
              ? i.addClass("slick-active").attr("aria-hidden", "false")
              : ((r = o.slideCount % o.options.slidesToShow),
                (n =
                  !0 === o.options.infinite ? o.options.slidesToShow + t : t),
                o.options.slidesToShow == o.options.slidesToScroll &&
                o.slideCount - t < o.options.slidesToShow
                  ? i
                      .slice(n - (o.options.slidesToShow - r), n + r)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : i
                      .slice(n, n + o.options.slidesToShow)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false"));
          ("ondemand" !== o.options.lazyLoad &&
            "anticipated" !== o.options.lazyLoad) ||
            o.lazyLoad();
        }),
        (e.prototype.setupInfinite = function () {
          var e,
            i,
            n,
            r = this;
          if (
            (!0 === r.options.fade && (r.options.centerMode = !1),
            !0 === r.options.infinite &&
              !1 === r.options.fade &&
              ((i = null), r.slideCount > r.options.slidesToShow))
          ) {
            for (
              n =
                !0 === r.options.centerMode
                  ? r.options.slidesToShow + 1
                  : r.options.slidesToShow,
                e = r.slideCount;
              e > r.slideCount - n;
              e -= 1
            )
              (i = e - 1),
                t(r.$slides[i])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", i - r.slideCount)
                  .prependTo(r.$slideTrack)
                  .addClass("slick-cloned");
            for (e = 0; e < n + r.slideCount; e += 1)
              (i = e),
                t(r.$slides[i])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", i + r.slideCount)
                  .appendTo(r.$slideTrack)
                  .addClass("slick-cloned");
            r.$slideTrack
              .find(".slick-cloned")
              .find("[id]")
              .each(function () {
                t(this).attr("id", "");
              });
          }
        }),
        (e.prototype.interrupt = function (t) {
          t || this.autoPlay(), (this.interrupted = t);
        }),
        (e.prototype.selectHandler = function (e) {
          var i = this,
            n = t(e.target).is(".slick-slide")
              ? t(e.target)
              : t(e.target).parents(".slick-slide"),
            r = parseInt(n.attr("data-slick-index"));
          r || (r = 0),
            i.slideCount <= i.options.slidesToShow
              ? i.slideHandler(r, !1, !0)
              : i.slideHandler(r);
        }),
        (e.prototype.slideHandler = function (t, e, i) {
          var n,
            r,
            o,
            s,
            a,
            l = null,
            u = this;
          if (
            ((e = e || !1),
            !(
              (!0 === u.animating && !0 === u.options.waitForAnimate) ||
              (!0 === u.options.fade && u.currentSlide === t)
            ))
          )
            if (
              (!1 === e && u.asNavFor(t),
              (n = t),
              (l = u.getLeft(n)),
              (s = u.getLeft(u.currentSlide)),
              (u.currentLeft = null === u.swipeLeft ? s : u.swipeLeft),
              !1 === u.options.infinite &&
                !1 === u.options.centerMode &&
                (t < 0 || t > u.getDotCount() * u.options.slidesToScroll))
            )
              !1 === u.options.fade &&
                ((n = u.currentSlide),
                !0 !== i
                  ? u.animateSlide(s, function () {
                      u.postSlide(n);
                    })
                  : u.postSlide(n));
            else if (
              !1 === u.options.infinite &&
              !0 === u.options.centerMode &&
              (t < 0 || t > u.slideCount - u.options.slidesToScroll)
            )
              !1 === u.options.fade &&
                ((n = u.currentSlide),
                !0 !== i
                  ? u.animateSlide(s, function () {
                      u.postSlide(n);
                    })
                  : u.postSlide(n));
            else {
              if (
                (u.options.autoplay && clearInterval(u.autoPlayTimer),
                (r =
                  n < 0
                    ? u.slideCount % u.options.slidesToScroll != 0
                      ? u.slideCount - (u.slideCount % u.options.slidesToScroll)
                      : u.slideCount + n
                    : n >= u.slideCount
                    ? u.slideCount % u.options.slidesToScroll != 0
                      ? 0
                      : n - u.slideCount
                    : n),
                (u.animating = !0),
                u.$slider.trigger("beforeChange", [u, u.currentSlide, r]),
                (o = u.currentSlide),
                (u.currentSlide = r),
                u.setSlideClasses(u.currentSlide),
                u.options.asNavFor &&
                  (a = (a = u.getNavTarget()).slick("getSlick")).slideCount <=
                    a.options.slidesToShow &&
                  a.setSlideClasses(u.currentSlide),
                u.updateDots(),
                u.updateArrows(),
                !0 === u.options.fade)
              )
                return (
                  !0 !== i
                    ? (u.fadeSlideOut(o),
                      u.fadeSlide(r, function () {
                        u.postSlide(r);
                      }))
                    : u.postSlide(r),
                  void u.animateHeight()
                );
              !0 !== i
                ? u.animateSlide(l, function () {
                    u.postSlide(r);
                  })
                : u.postSlide(r);
            }
        }),
        (e.prototype.startLoad = function () {
          var t = this;
          !0 === t.options.arrows &&
            t.slideCount > t.options.slidesToShow &&
            (t.$prevArrow.hide(), t.$nextArrow.hide()),
            !0 === t.options.dots &&
              t.slideCount > t.options.slidesToShow &&
              t.$dots.hide(),
            t.$slider.addClass("slick-loading");
        }),
        (e.prototype.swipeDirection = function () {
          var t,
            e,
            i,
            n,
            r = this;
          return (
            (t = r.touchObject.startX - r.touchObject.curX),
            (e = r.touchObject.startY - r.touchObject.curY),
            (i = Math.atan2(e, t)),
            (n = Math.round((180 * i) / Math.PI)) < 0 &&
              (n = 360 - Math.abs(n)),
            n <= 45 && n >= 0
              ? !1 === r.options.rtl
                ? "left"
                : "right"
              : n <= 360 && n >= 315
              ? !1 === r.options.rtl
                ? "left"
                : "right"
              : n >= 135 && n <= 225
              ? !1 === r.options.rtl
                ? "right"
                : "left"
              : !0 === r.options.verticalSwiping
              ? n >= 35 && n <= 135
                ? "down"
                : "up"
              : "vertical"
          );
        }),
        (e.prototype.swipeEnd = function (t) {
          var e,
            i,
            n = this;
          if (((n.dragging = !1), (n.swiping = !1), n.scrolling))
            return (n.scrolling = !1), !1;
          if (
            ((n.interrupted = !1),
            (n.shouldClick = !(n.touchObject.swipeLength > 10)),
            void 0 === n.touchObject.curX)
          )
            return !1;
          if (
            (!0 === n.touchObject.edgeHit &&
              n.$slider.trigger("edge", [n, n.swipeDirection()]),
            n.touchObject.swipeLength >= n.touchObject.minSwipe)
          ) {
            switch ((i = n.swipeDirection())) {
              case "left":
              case "down":
                (e = n.options.swipeToSlide
                  ? n.checkNavigable(n.currentSlide + n.getSlideCount())
                  : n.currentSlide + n.getSlideCount()),
                  (n.currentDirection = 0);
                break;
              case "right":
              case "up":
                (e = n.options.swipeToSlide
                  ? n.checkNavigable(n.currentSlide - n.getSlideCount())
                  : n.currentSlide - n.getSlideCount()),
                  (n.currentDirection = 1);
            }
            "vertical" != i &&
              (n.slideHandler(e),
              (n.touchObject = {}),
              n.$slider.trigger("swipe", [n, i]));
          } else
            n.touchObject.startX !== n.touchObject.curX &&
              (n.slideHandler(n.currentSlide), (n.touchObject = {}));
        }),
        (e.prototype.swipeHandler = function (t) {
          var e = this;
          if (
            !(
              !1 === e.options.swipe ||
              ("ontouchend" in document && !1 === e.options.swipe) ||
              (!1 === e.options.draggable && -1 !== t.type.indexOf("mouse"))
            )
          )
            switch (
              ((e.touchObject.fingerCount =
                t.originalEvent && void 0 !== t.originalEvent.touches
                  ? t.originalEvent.touches.length
                  : 1),
              (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
              !0 === e.options.verticalSwiping &&
                (e.touchObject.minSwipe =
                  e.listHeight / e.options.touchThreshold),
              t.data.action)
            ) {
              case "start":
                e.swipeStart(t);
                break;
              case "move":
                e.swipeMove(t);
                break;
              case "end":
                e.swipeEnd(t);
            }
        }),
        (e.prototype.swipeMove = function (t) {
          var e,
            i,
            n,
            r,
            o,
            s,
            a = this;
          return (
            (o = void 0 !== t.originalEvent ? t.originalEvent.touches : null),
            !(!a.dragging || a.scrolling || (o && 1 !== o.length)) &&
              ((e = a.getLeft(a.currentSlide)),
              (a.touchObject.curX = void 0 !== o ? o[0].pageX : t.clientX),
              (a.touchObject.curY = void 0 !== o ? o[0].pageY : t.clientY),
              (a.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(a.touchObject.curX - a.touchObject.startX, 2)
                )
              )),
              (s = Math.round(
                Math.sqrt(
                  Math.pow(a.touchObject.curY - a.touchObject.startY, 2)
                )
              )),
              !a.options.verticalSwiping && !a.swiping && s > 4
                ? ((a.scrolling = !0), !1)
                : (!0 === a.options.verticalSwiping &&
                    (a.touchObject.swipeLength = s),
                  (i = a.swipeDirection()),
                  void 0 !== t.originalEvent &&
                    a.touchObject.swipeLength > 4 &&
                    ((a.swiping = !0), t.preventDefault()),
                  (r =
                    (!1 === a.options.rtl ? 1 : -1) *
                    (a.touchObject.curX > a.touchObject.startX ? 1 : -1)),
                  !0 === a.options.verticalSwiping &&
                    (r = a.touchObject.curY > a.touchObject.startY ? 1 : -1),
                  (n = a.touchObject.swipeLength),
                  (a.touchObject.edgeHit = !1),
                  !1 === a.options.infinite &&
                    ((0 === a.currentSlide && "right" === i) ||
                      (a.currentSlide >= a.getDotCount() && "left" === i)) &&
                    ((n = a.touchObject.swipeLength * a.options.edgeFriction),
                    (a.touchObject.edgeHit = !0)),
                  !1 === a.options.vertical
                    ? (a.swipeLeft = e + n * r)
                    : (a.swipeLeft =
                        e + n * (a.$list.height() / a.listWidth) * r),
                  !0 === a.options.verticalSwiping && (a.swipeLeft = e + n * r),
                  !0 !== a.options.fade &&
                    !1 !== a.options.touchMove &&
                    (!0 === a.animating
                      ? ((a.swipeLeft = null), !1)
                      : void a.setCSS(a.swipeLeft))))
          );
        }),
        (e.prototype.swipeStart = function (t) {
          var e,
            i = this;
          if (
            ((i.interrupted = !0),
            1 !== i.touchObject.fingerCount ||
              i.slideCount <= i.options.slidesToShow)
          )
            return (i.touchObject = {}), !1;
          void 0 !== t.originalEvent &&
            void 0 !== t.originalEvent.touches &&
            (e = t.originalEvent.touches[0]),
            (i.touchObject.startX = i.touchObject.curX =
              void 0 !== e ? e.pageX : t.clientX),
            (i.touchObject.startY = i.touchObject.curY =
              void 0 !== e ? e.pageY : t.clientY),
            (i.dragging = !0);
        }),
        (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
          function () {
            var t = this;
            null !== t.$slidesCache &&
              (t.unload(),
              t.$slideTrack.children(this.options.slide).detach(),
              t.$slidesCache.appendTo(t.$slideTrack),
              t.reinit());
          }),
        (e.prototype.unload = function () {
          var e = this;
          t(".slick-cloned", e.$slider).remove(),
            e.$dots && e.$dots.remove(),
            e.$prevArrow &&
              e.htmlExpr.test(e.options.prevArrow) &&
              e.$prevArrow.remove(),
            e.$nextArrow &&
              e.htmlExpr.test(e.options.nextArrow) &&
              e.$nextArrow.remove(),
            e.$slides
              .removeClass(
                "slick-slide slick-active slick-visible slick-current"
              )
              .attr("aria-hidden", "true")
              .css("width", "");
        }),
        (e.prototype.unslick = function (t) {
          var e = this;
          e.$slider.trigger("unslick", [e, t]), e.destroy();
        }),
        (e.prototype.updateArrows = function () {
          var t = this;
          Math.floor(t.options.slidesToShow / 2),
            !0 === t.options.arrows &&
              t.slideCount > t.options.slidesToShow &&
              !t.options.infinite &&
              (t.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"),
              t.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"),
              0 === t.currentSlide
                ? (t.$prevArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  t.$nextArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false"))
                : t.currentSlide >= t.slideCount - t.options.slidesToShow &&
                  !1 === t.options.centerMode
                ? (t.$nextArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  t.$prevArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false"))
                : t.currentSlide >= t.slideCount - 1 &&
                  !0 === t.options.centerMode &&
                  (t.$nextArrow
                    .addClass("slick-disabled")
                    .attr("aria-disabled", "true"),
                  t.$prevArrow
                    .removeClass("slick-disabled")
                    .attr("aria-disabled", "false")));
        }),
        (e.prototype.updateDots = function () {
          var t = this;
          null !== t.$dots &&
            (t.$dots.find("li").removeClass("slick-active").end(),
            t.$dots
              .find("li")
              .eq(Math.floor(t.currentSlide / t.options.slidesToScroll))
              .addClass("slick-active"));
        }),
        (e.prototype.visibility = function () {
          var t = this;
          t.options.autoplay &&
            (document[t.hidden] ? (t.interrupted = !0) : (t.interrupted = !1));
        }),
        (t.fn.slick = function () {
          var t,
            i,
            n = this,
            r = arguments[0],
            o = Array.prototype.slice.call(arguments, 1),
            s = n.length;
          for (t = 0; t < s; t++)
            if (
              ("object" == typeof r || void 0 === r
                ? (n[t].slick = new e(n[t], r))
                : (i = n[t].slick[r].apply(n[t].slick, o)),
              void 0 !== i)
            )
              return i;
          return n;
        });
    }),
    (function (t) {
      "function" == typeof define && define.amd
        ? define(["jquery"], t)
        : t(
            "object" == typeof exports
              ? require("jquery")
              : window.jQuery || window.Zepto
          );
    })(function (t) {
      var e,
        i,
        n,
        r,
        o,
        s,
        a = "Close",
        l = "BeforeClose",
        u = "MarkupParse",
        c = "Open",
        d = "Change",
        p = "mfp",
        f = "." + p,
        h = "mfp-ready",
        v = "mfp-removing",
        m = "mfp-prevent-close",
        g = function () {},
        y = !!window.jQuery,
        b = t(window),
        w = function (t, i) {
          e.ev.on(p + t + f, i);
        },
        k = function (e, i, n, r) {
          var o = document.createElement("div");
          return (
            (o.className = "mfp-" + e),
            n && (o.innerHTML = n),
            r ? i && i.appendChild(o) : ((o = t(o)), i && o.appendTo(i)),
            o
          );
        },
        C = function (i, n) {
          e.ev.triggerHandler(p + i, n),
            e.st.callbacks &&
              ((i = i.charAt(0).toLowerCase() + i.slice(1)),
              e.st.callbacks[i] &&
                e.st.callbacks[i].apply(e, t.isArray(n) ? n : [n]));
        },
        S = function (i) {
          return (
            (i === s && e.currTemplate.closeBtn) ||
              ((e.currTemplate.closeBtn = t(
                e.st.closeMarkup.replace("%title%", e.st.tClose)
              )),
              (s = i)),
            e.currTemplate.closeBtn
          );
        },
        T = function () {
          t.magnificPopup.instance ||
            ((e = new g()).init(), (t.magnificPopup.instance = e));
        };
      (g.prototype = {
        constructor: g,
        init: function () {
          var i = navigator.appVersion;
          (e.isLowIE = e.isIE8 = document.all && !document.addEventListener),
            (e.isAndroid = /android/gi.test(i)),
            (e.isIOS = /iphone|ipad|ipod/gi.test(i)),
            (e.supportsTransition = (function () {
              var t = document.createElement("p").style,
                e = ["ms", "O", "Moz", "Webkit"];
              if (void 0 !== t.transition) return !0;
              for (; e.length; ) if (e.pop() + "Transition" in t) return !0;
              return !1;
            })()),
            (e.probablyMobile =
              e.isAndroid ||
              e.isIOS ||
              /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
                navigator.userAgent
              )),
            (n = t(document)),
            (e.popupsCache = {});
        },
        open: function (i) {
          var r;
          if (!1 === i.isObj) {
            (e.items = i.items.toArray()), (e.index = 0);
            var s,
              a = i.items;
            for (r = 0; r < a.length; r++)
              if (((s = a[r]).parsed && (s = s.el[0]), s === i.el[0])) {
                e.index = r;
                break;
              }
          } else
            (e.items = t.isArray(i.items) ? i.items : [i.items]),
              (e.index = i.index || 0);
          if (!e.isOpen) {
            (e.types = []),
              (o = ""),
              i.mainEl && i.mainEl.length
                ? (e.ev = i.mainEl.eq(0))
                : (e.ev = n),
              i.key
                ? (e.popupsCache[i.key] || (e.popupsCache[i.key] = {}),
                  (e.currTemplate = e.popupsCache[i.key]))
                : (e.currTemplate = {}),
              (e.st = t.extend(!0, {}, t.magnificPopup.defaults, i)),
              (e.fixedContentPos =
                "auto" === e.st.fixedContentPos
                  ? !e.probablyMobile
                  : e.st.fixedContentPos),
              e.st.modal &&
                ((e.st.closeOnContentClick = !1),
                (e.st.closeOnBgClick = !1),
                (e.st.showCloseBtn = !1),
                (e.st.enableEscapeKey = !1)),
              e.bgOverlay ||
                ((e.bgOverlay = k("bg").on("click" + f, function () {
                  e.close();
                })),
                (e.wrap = k("wrap")
                  .attr("tabindex", -1)
                  .on("click" + f, function (t) {
                    e._checkIfClose(t.target) && e.close();
                  })),
                (e.container = k("container", e.wrap))),
              (e.contentContainer = k("content")),
              e.st.preloader &&
                (e.preloader = k("preloader", e.container, e.st.tLoading));
            var l = t.magnificPopup.modules;
            for (r = 0; r < l.length; r++) {
              var d = l[r];
              (d = d.charAt(0).toUpperCase() + d.slice(1)),
                e["init" + d].call(e);
            }
            C("BeforeOpen"),
              e.st.showCloseBtn &&
                (e.st.closeBtnInside
                  ? (w(u, function (t, e, i, n) {
                      i.close_replaceWith = S(n.type);
                    }),
                    (o += " mfp-close-btn-in"))
                  : e.wrap.append(S())),
              e.st.alignTop && (o += " mfp-align-top"),
              e.fixedContentPos
                ? e.wrap.css({
                    overflow: e.st.overflowY,
                    overflowX: "hidden",
                    overflowY: e.st.overflowY,
                  })
                : e.wrap.css({ top: b.scrollTop(), position: "absolute" }),
              (!1 === e.st.fixedBgPos ||
                ("auto" === e.st.fixedBgPos && !e.fixedContentPos)) &&
                e.bgOverlay.css({ height: n.height(), position: "absolute" }),
              e.st.enableEscapeKey &&
                n.on("keyup" + f, function (t) {
                  27 === t.keyCode && e.close();
                }),
              b.on("resize" + f, function () {
                e.updateSize();
              }),
              e.st.closeOnContentClick || (o += " mfp-auto-cursor"),
              o && e.wrap.addClass(o);
            var p = (e.wH = b.height()),
              v = {};
            if (e.fixedContentPos && e._hasScrollBar(p)) {
              var m = e._getScrollbarSize();
              m && (v.marginRight = m);
            }
            e.fixedContentPos &&
              (e.isIE7
                ? t("body, html").css("overflow", "hidden")
                : (v.overflow = "hidden"));
            var g = e.st.mainClass;
            return (
              e.isIE7 && (g += " mfp-ie7"),
              g && e._addClassToMFP(g),
              e.updateItemHTML(),
              C("BuildControls"),
              t("html").css(v),
              e.bgOverlay
                .add(e.wrap)
                .prependTo(e.st.prependTo || t(document.body)),
              (e._lastFocusedEl = document.activeElement),
              setTimeout(function () {
                e.content
                  ? (e._addClassToMFP(h), e._setFocus())
                  : e.bgOverlay.addClass(h),
                  n.on("focusin" + f, e._onFocusIn);
              }, 16),
              (e.isOpen = !0),
              e.updateSize(p),
              C(c),
              i
            );
          }
          e.updateItemHTML();
        },
        close: function () {
          e.isOpen &&
            (C(l),
            (e.isOpen = !1),
            e.st.removalDelay && !e.isLowIE && e.supportsTransition
              ? (e._addClassToMFP(v),
                setTimeout(function () {
                  e._close();
                }, e.st.removalDelay))
              : e._close());
        },
        _close: function () {
          C(a);
          var i = v + " " + h + " ";
          if (
            (e.bgOverlay.detach(),
            e.wrap.detach(),
            e.container.empty(),
            e.st.mainClass && (i += e.st.mainClass + " "),
            e._removeClassFromMFP(i),
            e.fixedContentPos)
          ) {
            var r = { marginRight: "" };
            e.isIE7 ? t("body, html").css("overflow", "") : (r.overflow = ""),
              t("html").css(r);
          }
          n.off("keyup.mfp focusin" + f),
            e.ev.off(f),
            e.wrap.attr("class", "mfp-wrap").removeAttr("style"),
            e.bgOverlay.attr("class", "mfp-bg"),
            e.container.attr("class", "mfp-container"),
            !e.st.showCloseBtn ||
              (e.st.closeBtnInside && !0 !== e.currTemplate[e.currItem.type]) ||
              (e.currTemplate.closeBtn && e.currTemplate.closeBtn.detach()),
            e.st.autoFocusLast &&
              e._lastFocusedEl &&
              t(e._lastFocusedEl).focus(),
            (e.currItem = null),
            (e.content = null),
            (e.currTemplate = null),
            (e.prevHeight = 0),
            C("AfterClose");
        },
        updateSize: function (t) {
          if (e.isIOS) {
            var i = document.documentElement.clientWidth / window.innerWidth,
              n = window.innerHeight * i;
            e.wrap.css("height", n), (e.wH = n);
          } else e.wH = t || b.height();
          e.fixedContentPos || e.wrap.css("height", e.wH), C("Resize");
        },
        updateItemHTML: function () {
          var i = e.items[e.index];
          e.contentContainer.detach(),
            e.content && e.content.detach(),
            i.parsed || (i = e.parseEl(e.index));
          var n = i.type;
          if (
            (C("BeforeChange", [e.currItem ? e.currItem.type : "", n]),
            (e.currItem = i),
            !e.currTemplate[n])
          ) {
            var o = !!e.st[n] && e.st[n].markup;
            C("FirstMarkupParse", o), (e.currTemplate[n] = !o || t(o));
          }
          r && r !== i.type && e.container.removeClass("mfp-" + r + "-holder");
          var s = e["get" + n.charAt(0).toUpperCase() + n.slice(1)](
            i,
            e.currTemplate[n]
          );
          e.appendContent(s, n),
            (i.preloaded = !0),
            C(d, i),
            (r = i.type),
            e.container.prepend(e.contentContainer),
            C("AfterChange");
        },
        appendContent: function (t, i) {
          (e.content = t),
            t
              ? e.st.showCloseBtn &&
                e.st.closeBtnInside &&
                !0 === e.currTemplate[i]
                ? e.content.find(".mfp-close").length || e.content.append(S())
                : (e.content = t)
              : (e.content = ""),
            C("BeforeAppend"),
            e.container.addClass("mfp-" + i + "-holder"),
            e.contentContainer.append(e.content);
        },
        parseEl: function (i) {
          var n,
            r = e.items[i];
          if (
            (r.tagName
              ? (r = { el: t(r) })
              : ((n = r.type), (r = { data: r, src: r.src })),
            r.el)
          ) {
            for (var o = e.types, s = 0; s < o.length; s++)
              if (r.el.hasClass("mfp-" + o[s])) {
                n = o[s];
                break;
              }
            (r.src = r.el.attr("data-mfp-src")),
              r.src || (r.src = r.el.attr("href"));
          }
          return (
            (r.type = n || e.st.type || "inline"),
            (r.index = i),
            (r.parsed = !0),
            (e.items[i] = r),
            C("ElementParse", r),
            e.items[i]
          );
        },
        addGroup: function (t, i) {
          var n = function (n) {
            (n.mfpEl = this), e._openClick(n, t, i);
          };
          i || (i = {});
          var r = "click.magnificPopup";
          (i.mainEl = t),
            i.items
              ? ((i.isObj = !0), t.off(r).on(r, n))
              : ((i.isObj = !1),
                i.delegate
                  ? t.off(r).on(r, i.delegate, n)
                  : ((i.items = t), t.off(r).on(r, n)));
        },
        _openClick: function (i, n, r) {
          if (
            (void 0 !== r.midClick
              ? r.midClick
              : t.magnificPopup.defaults.midClick) ||
            !(2 === i.which || i.ctrlKey || i.metaKey || i.altKey || i.shiftKey)
          ) {
            var o =
              void 0 !== r.disableOn
                ? r.disableOn
                : t.magnificPopup.defaults.disableOn;
            if (o)
              if (t.isFunction(o)) {
                if (!o.call(e)) return !0;
              } else if (b.width() < o) return !0;
            i.type && (i.preventDefault(), e.isOpen && i.stopPropagation()),
              (r.el = t(i.mfpEl)),
              r.delegate && (r.items = n.find(r.delegate)),
              e.open(r);
          }
        },
        updateStatus: function (t, n) {
          if (e.preloader) {
            i !== t && e.container.removeClass("mfp-s-" + i),
              n || "loading" !== t || (n = e.st.tLoading);
            var r = { status: t, text: n };
            C("UpdateStatus", r),
              (t = r.status),
              (n = r.text),
              e.preloader.html(n),
              e.preloader.find("a").on("click", function (t) {
                t.stopImmediatePropagation();
              }),
              e.container.addClass("mfp-s-" + t),
              (i = t);
          }
        },
        _checkIfClose: function (i) {
          if (!t(i).hasClass(m)) {
            var n = e.st.closeOnContentClick,
              r = e.st.closeOnBgClick;
            if (n && r) return !0;
            if (
              !e.content ||
              t(i).hasClass("mfp-close") ||
              (e.preloader && i === e.preloader[0])
            )
              return !0;
            if (i === e.content[0] || t.contains(e.content[0], i)) {
              if (n) return !0;
            } else if (r && t.contains(document, i)) return !0;
            return !1;
          }
        },
        _addClassToMFP: function (t) {
          e.bgOverlay.addClass(t), e.wrap.addClass(t);
        },
        _removeClassFromMFP: function (t) {
          this.bgOverlay.removeClass(t), e.wrap.removeClass(t);
        },
        _hasScrollBar: function (t) {
          return (
            (e.isIE7 ? n.height() : document.body.scrollHeight) >
            (t || b.height())
          );
        },
        _setFocus: function () {
          (e.st.focus ? e.content.find(e.st.focus).eq(0) : e.wrap).focus();
        },
        _onFocusIn: function (i) {
          return i.target === e.wrap[0] || t.contains(e.wrap[0], i.target)
            ? void 0
            : (e._setFocus(), !1);
        },
        _parseMarkup: function (e, i, n) {
          var r;
          n.data && (i = t.extend(n.data, i)),
            C(u, [e, i, n]),
            t.each(i, function (i, n) {
              if (void 0 === n || !1 === n) return !0;
              if ((r = i.split("_")).length > 1) {
                var o = e.find(f + "-" + r[0]);
                if (o.length > 0) {
                  var s = r[1];
                  "replaceWith" === s
                    ? o[0] !== n[0] && o.replaceWith(n)
                    : "img" === s
                    ? o.is("img")
                      ? o.attr("src", n)
                      : o.replaceWith(
                          t("<img>")
                            .attr("src", n)
                            .attr("class", o.attr("class"))
                        )
                    : o.attr(r[1], n);
                }
              } else e.find(f + "-" + i).html(n);
            });
        },
        _getScrollbarSize: function () {
          if (void 0 === e.scrollbarSize) {
            var t = document.createElement("div");
            (t.style.cssText =
              "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
              document.body.appendChild(t),
              (e.scrollbarSize = t.offsetWidth - t.clientWidth),
              document.body.removeChild(t);
          }
          return e.scrollbarSize;
        },
      }),
        (t.magnificPopup = {
          instance: null,
          proto: g.prototype,
          modules: [],
          open: function (e, i) {
            return (
              T(),
              ((e = e ? t.extend(!0, {}, e) : {}).isObj = !0),
              (e.index = i || 0),
              this.instance.open(e)
            );
          },
          close: function () {
            return t.magnificPopup.instance && t.magnificPopup.instance.close();
          },
          registerModule: function (e, i) {
            i.options && (t.magnificPopup.defaults[e] = i.options),
              t.extend(this.proto, i.proto),
              this.modules.push(e);
          },
          defaults: {
            disableOn: 0,
            key: null,
            midClick: !1,
            mainClass: "",
            preloader: !0,
            focus: "",
            closeOnContentClick: !1,
            closeOnBgClick: !0,
            closeBtnInside: !0,
            showCloseBtn: !0,
            enableEscapeKey: !0,
            modal: !1,
            alignTop: !1,
            removalDelay: 0,
            prependTo: null,
            fixedContentPos: "auto",
            fixedBgPos: "auto",
            overflowY: "auto",
            closeMarkup:
              '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
            tClose: "Close (Esc)",
            tLoading: "Loading...",
            autoFocusLast: !0,
          },
        }),
        (t.fn.magnificPopup = function (i) {
          T();
          var n = t(this);
          if ("string" == typeof i)
            if ("open" === i) {
              var r,
                o = y ? n.data("magnificPopup") : n[0].magnificPopup,
                s = parseInt(arguments[1], 10) || 0;
              o.items
                ? (r = o.items[s])
                : ((r = n),
                  o.delegate && (r = r.find(o.delegate)),
                  (r = r.eq(s))),
                e._openClick({ mfpEl: r }, n, o);
            } else
              e.isOpen &&
                e[i].apply(e, Array.prototype.slice.call(arguments, 1));
          else
            (i = t.extend(!0, {}, i)),
              y ? n.data("magnificPopup", i) : (n[0].magnificPopup = i),
              e.addGroup(n, i);
          return n;
        });
      var z,
        x,
        A,
        $ = "inline",
        _ = function () {
          A && (x.after(A.addClass(z)).detach(), (A = null));
        };
      t.magnificPopup.registerModule($, {
        options: {
          hiddenClass: "hide",
          markup: "",
          tNotFound: "Content not found",
        },
        proto: {
          initInline: function () {
            e.types.push($),
              w(a + "." + $, function () {
                _();
              });
          },
          getInline: function (i, n) {
            if ((_(), i.src)) {
              var r = e.st.inline,
                o = t(i.src);
              if (o.length) {
                var s = o[0].parentNode;
                s &&
                  s.tagName &&
                  (x || ((z = r.hiddenClass), (x = k(z)), (z = "mfp-" + z)),
                  (A = o.after(x).detach().removeClass(z))),
                  e.updateStatus("ready");
              } else e.updateStatus("error", r.tNotFound), (o = t("<div>"));
              return (i.inlineElement = o), o;
            }
            return e.updateStatus("ready"), e._parseMarkup(n, {}, i), n;
          },
        },
      });
      var E,
        I = "ajax",
        P = function () {
          E && t(document.body).removeClass(E);
        },
        j = function () {
          P(), e.req && e.req.abort();
        };
      t.magnificPopup.registerModule(I, {
        options: {
          settings: null,
          cursor: "mfp-ajax-cur",
          tError: '<a href="%url%">The content</a> could not be loaded.',
        },
        proto: {
          initAjax: function () {
            e.types.push(I),
              (E = e.st.ajax.cursor),
              w(a + "." + I, j),
              w("BeforeChange." + I, j);
          },
          getAjax: function (i) {
            E && t(document.body).addClass(E), e.updateStatus("loading");
            var n = t.extend(
              {
                url: i.src,
                success: function (n, r, o) {
                  var s = { data: n, xhr: o };
                  C("ParseAjax", s),
                    e.appendContent(t(s.data), I),
                    (i.finished = !0),
                    P(),
                    e._setFocus(),
                    setTimeout(function () {
                      e.wrap.addClass(h);
                    }, 16),
                    e.updateStatus("ready"),
                    C("AjaxContentAdded");
                },
                error: function () {
                  P(),
                    (i.finished = i.loadError = !0),
                    e.updateStatus(
                      "error",
                      e.st.ajax.tError.replace("%url%", i.src)
                    );
                },
              },
              e.st.ajax.settings
            );
            return (e.req = t.ajax(n)), "";
          },
        },
      });
      var O,
        M = function (i) {
          if (i.data && void 0 !== i.data.title) return i.data.title;
          var n = e.st.image.titleSrc;
          if (n) {
            if (t.isFunction(n)) return n.call(e, i);
            if (i.el) return i.el.attr(n) || "";
          }
          return "";
        };
      t.magnificPopup.registerModule("image", {
        options: {
          markup:
            '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
          cursor: "mfp-zoom-out-cur",
          titleSrc: "title",
          verticalFit: !0,
          tError: '<a href="%url%">The image</a> could not be loaded.',
        },
        proto: {
          initImage: function () {
            var i = e.st.image,
              n = ".image";
            e.types.push("image"),
              w(c + n, function () {
                "image" === e.currItem.type &&
                  i.cursor &&
                  t(document.body).addClass(i.cursor);
              }),
              w(a + n, function () {
                i.cursor && t(document.body).removeClass(i.cursor),
                  b.off("resize" + f);
              }),
              w("Resize" + n, e.resizeImage),
              e.isLowIE && w("AfterChange", e.resizeImage);
          },
          resizeImage: function () {
            var t = e.currItem;
            if (t && t.img && e.st.image.verticalFit) {
              var i = 0;
              e.isLowIE &&
                (i =
                  parseInt(t.img.css("padding-top"), 10) +
                  parseInt(t.img.css("padding-bottom"), 10)),
                t.img.css("max-height", e.wH - i);
            }
          },
          _onImageHasSize: function (t) {
            t.img &&
              ((t.hasSize = !0),
              O && clearInterval(O),
              (t.isCheckingImgSize = !1),
              C("ImageHasSize", t),
              t.imgHidden &&
                (e.content && e.content.removeClass("mfp-loading"),
                (t.imgHidden = !1)));
          },
          findImageSize: function (t) {
            var i = 0,
              n = t.img[0],
              r = function (o) {
                O && clearInterval(O),
                  (O = setInterval(function () {
                    return n.naturalWidth > 0
                      ? void e._onImageHasSize(t)
                      : (i > 200 && clearInterval(O),
                        void (3 === ++i
                          ? r(10)
                          : 40 === i
                          ? r(50)
                          : 100 === i && r(500)));
                  }, o));
              };
            r(1);
          },
          getImage: function (i, n) {
            var r = 0,
              o = function () {
                i &&
                  (i.img[0].complete
                    ? (i.img.off(".mfploader"),
                      i === e.currItem &&
                        (e._onImageHasSize(i), e.updateStatus("ready")),
                      (i.hasSize = !0),
                      (i.loaded = !0),
                      C("ImageLoadComplete"))
                    : 200 > ++r
                    ? setTimeout(o, 100)
                    : s());
              },
              s = function () {
                i &&
                  (i.img.off(".mfploader"),
                  i === e.currItem &&
                    (e._onImageHasSize(i),
                    e.updateStatus("error", a.tError.replace("%url%", i.src))),
                  (i.hasSize = !0),
                  (i.loaded = !0),
                  (i.loadError = !0));
              },
              a = e.st.image,
              l = n.find(".mfp-img");
            if (l.length) {
              var u = document.createElement("img");
              (u.className = "mfp-img"),
                i.el &&
                  i.el.find("img").length &&
                  (u.alt = i.el.find("img").attr("alt")),
                (i.img = t(u).on("load.mfploader", o).on("error.mfploader", s)),
                (u.src = i.src),
                l.is("img") && (i.img = i.img.clone()),
                (u = i.img[0]).naturalWidth > 0
                  ? (i.hasSize = !0)
                  : u.width || (i.hasSize = !1);
            }
            return (
              e._parseMarkup(n, { title: M(i), img_replaceWith: i.img }, i),
              e.resizeImage(),
              i.hasSize
                ? (O && clearInterval(O),
                  i.loadError
                    ? (n.addClass("mfp-loading"),
                      e.updateStatus("error", a.tError.replace("%url%", i.src)))
                    : (n.removeClass("mfp-loading"), e.updateStatus("ready")),
                  n)
                : (e.updateStatus("loading"),
                  (i.loading = !0),
                  i.hasSize ||
                    ((i.imgHidden = !0),
                    n.addClass("mfp-loading"),
                    e.findImageSize(i)),
                  n)
            );
          },
        },
      });
      var L;
      t.magnificPopup.registerModule("zoom", {
        options: {
          enabled: !1,
          easing: "ease-in-out",
          duration: 300,
          opener: function (t) {
            return t.is("img") ? t : t.find("img");
          },
        },
        proto: {
          initZoom: function () {
            var t,
              i = e.st.zoom,
              n = ".zoom";
            if (i.enabled && e.supportsTransition) {
              var r,
                o,
                s = i.duration,
                u = function (t) {
                  var e = t
                      .clone()
                      .removeAttr("style")
                      .removeAttr("class")
                      .addClass("mfp-animated-image"),
                    n = "all " + i.duration / 1e3 + "s " + i.easing,
                    r = {
                      position: "fixed",
                      zIndex: 9999,
                      left: 0,
                      top: 0,
                      "-webkit-backface-visibility": "hidden",
                    },
                    o = "transition";
                  return (
                    (r["-webkit-" + o] =
                      r["-moz-" + o] =
                      r["-o-" + o] =
                      r[o] =
                        n),
                    e.css(r),
                    e
                  );
                },
                c = function () {
                  e.content.css("visibility", "visible");
                };
              w("BuildControls" + n, function () {
                if (e._allowZoom()) {
                  if (
                    (clearTimeout(r),
                    e.content.css("visibility", "hidden"),
                    !(t = e._getItemToZoom()))
                  )
                    return void c();
                  (o = u(t)).css(e._getOffset()),
                    e.wrap.append(o),
                    (r = setTimeout(function () {
                      o.css(e._getOffset(!0)),
                        (r = setTimeout(function () {
                          c(),
                            setTimeout(function () {
                              o.remove(),
                                (t = o = null),
                                C("ZoomAnimationEnded");
                            }, 16);
                        }, s));
                    }, 16));
                }
              }),
                w(l + n, function () {
                  if (e._allowZoom()) {
                    if ((clearTimeout(r), (e.st.removalDelay = s), !t)) {
                      if (!(t = e._getItemToZoom())) return;
                      o = u(t);
                    }
                    o.css(e._getOffset(!0)),
                      e.wrap.append(o),
                      e.content.css("visibility", "hidden"),
                      setTimeout(function () {
                        o.css(e._getOffset());
                      }, 16);
                  }
                }),
                w(a + n, function () {
                  e._allowZoom() && (c(), o && o.remove(), (t = null));
                });
            }
          },
          _allowZoom: function () {
            return "image" === e.currItem.type;
          },
          _getItemToZoom: function () {
            return !!e.currItem.hasSize && e.currItem.img;
          },
          _getOffset: function (i) {
            var n,
              r = (n = i
                ? e.currItem.img
                : e.st.zoom.opener(e.currItem.el || e.currItem)).offset(),
              o = parseInt(n.css("padding-top"), 10),
              s = parseInt(n.css("padding-bottom"), 10);
            r.top -= t(window).scrollTop() - o;
            var a = {
              width: n.width(),
              height: (y ? n.innerHeight() : n[0].offsetHeight) - s - o,
            };
            return (
              void 0 === L &&
                (L = void 0 !== document.createElement("p").style.MozTransform),
              L
                ? (a["-moz-transform"] = a.transform =
                    "translate(" + r.left + "px," + r.top + "px)")
                : ((a.left = r.left), (a.top = r.top)),
              a
            );
          },
        },
      });
      var N = "iframe",
        H = function (t) {
          if (e.currTemplate[N]) {
            var i = e.currTemplate[N].find("iframe");
            i.length &&
              (t || (i[0].src = "//about:blank"),
              e.isIE8 && i.css("display", t ? "block" : "none"));
          }
        };
      t.magnificPopup.registerModule(N, {
        options: {
          markup:
            '<div class="mfp-iframe-scaler mfp-with-anim"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
          srcAction: "iframe_src",
          patterns: {
            youtube: {
              index: "youtube.com",
              id: "v=",
              src: "//www.youtube.com/embed/%id%?autoplay=1",
            },
            vimeo: {
              index: "vimeo.com/",
              id: "/",
              src: "//player.vimeo.com/video/%id%?autoplay=1",
            },
            gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
          },
        },
        proto: {
          initIframe: function () {
            e.types.push(N),
              w("BeforeChange", function (t, e, i) {
                e !== i && (e === N ? H() : i === N && H(!0));
              }),
              w(a + "." + N, function () {
                H();
              });
          },
          getIframe: function (i, n) {
            var r = i.src,
              o = e.st.iframe;
            t.each(o.patterns, function () {
              return r.indexOf(this.index) > -1
                ? (this.id &&
                    (r =
                      "string" == typeof this.id
                        ? r.substr(
                            r.lastIndexOf(this.id) + this.id.length,
                            r.length
                          )
                        : this.id.call(this, r)),
                  (r = this.src.replace("%id%", r)),
                  !1)
                : void 0;
            });
            var s = {};
            return (
              o.srcAction && (s[o.srcAction] = r),
              e._parseMarkup(n, s, i),
              e.updateStatus("ready"),
              n
            );
          },
        },
      });
      var B = function (t) {
          var i = e.items.length;
          return t > i - 1 ? t - i : 0 > t ? i + t : t;
        },
        F = function (t, e, i) {
          return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i);
        };
      t.magnificPopup.registerModule("gallery", {
        options: {
          enabled: !1,
          arrowMarkup:
            '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
          preload: [0, 2],
          navigateByImgClick: !0,
          arrows: !0,
          tPrev: "Previous (Left arrow key)",
          tNext: "Next (Right arrow key)",
          tCounter: "%curr% of %total%",
        },
        proto: {
          initGallery: function () {
            var i = e.st.gallery,
              r = ".mfp-gallery";
            return (
              (e.direction = !0),
              !(!i || !i.enabled) &&
                ((o += " mfp-gallery"),
                w(c + r, function () {
                  i.navigateByImgClick &&
                    e.wrap.on("click" + r, ".mfp-img", function () {
                      return e.items.length > 1 ? (e.next(), !1) : void 0;
                    }),
                    n.on("keydown" + r, function (t) {
                      37 === t.keyCode
                        ? e.prev()
                        : 39 === t.keyCode && e.next();
                    });
                }),
                w("UpdateStatus" + r, function (t, i) {
                  i.text &&
                    (i.text = F(i.text, e.currItem.index, e.items.length));
                }),
                w(u + r, function (t, n, r, o) {
                  var s = e.items.length;
                  r.counter = s > 1 ? F(i.tCounter, o.index, s) : "";
                }),
                w("BuildControls" + r, function () {
                  if (e.items.length > 1 && i.arrows && !e.arrowLeft) {
                    var n = i.arrowMarkup,
                      r = (e.arrowLeft = t(
                        n
                          .replace(/%title%/gi, i.tPrev)
                          .replace(/%dir%/gi, "left")
                      ).addClass(m)),
                      o = (e.arrowRight = t(
                        n
                          .replace(/%title%/gi, i.tNext)
                          .replace(/%dir%/gi, "right")
                      ).addClass(m));
                    r.click(function () {
                      e.prev();
                    }),
                      o.click(function () {
                        e.next();
                      }),
                      e.container.append(r.add(o));
                  }
                }),
                w(d + r, function () {
                  e._preloadTimeout && clearTimeout(e._preloadTimeout),
                    (e._preloadTimeout = setTimeout(function () {
                      e.preloadNearbyImages(), (e._preloadTimeout = null);
                    }, 16));
                }),
                void w(a + r, function () {
                  n.off(r),
                    e.wrap.off("click" + r),
                    (e.arrowRight = e.arrowLeft = null);
                }))
            );
          },
          next: function () {
            (e.direction = !0), (e.index = B(e.index + 1)), e.updateItemHTML();
          },
          prev: function () {
            (e.direction = !1), (e.index = B(e.index - 1)), e.updateItemHTML();
          },
          goTo: function (t) {
            (e.direction = t >= e.index), (e.index = t), e.updateItemHTML();
          },
          preloadNearbyImages: function () {
            var t,
              i = e.st.gallery.preload,
              n = Math.min(i[0], e.items.length),
              r = Math.min(i[1], e.items.length);
            for (t = 1; t <= (e.direction ? r : n); t++)
              e._preloadItem(e.index + t);
            for (t = 1; t <= (e.direction ? n : r); t++)
              e._preloadItem(e.index - t);
          },
          _preloadItem: function (i) {
            if (((i = B(i)), !e.items[i].preloaded)) {
              var n = e.items[i];
              n.parsed || (n = e.parseEl(i)),
                C("LazyLoad", n),
                "image" === n.type &&
                  (n.img = t('<img class="mfp-img" />')
                    .on("load.mfploader", function () {
                      n.hasSize = !0;
                    })
                    .on("error.mfploader", function () {
                      (n.hasSize = !0),
                        (n.loadError = !0),
                        C("LazyLoadError", n);
                    })
                    .attr("src", n.src)),
                (n.preloaded = !0);
            }
          },
        },
      });
      var D = "retina";
      t.magnificPopup.registerModule(D, {
        options: {
          replaceSrc: function (t) {
            return t.src.replace(/\.\w+$/, function (t) {
              return "@2x" + t;
            });
          },
          ratio: 1,
        },
        proto: {
          initRetina: function () {
            if (window.devicePixelRatio > 1) {
              var t = e.st.retina,
                i = t.ratio;
              (i = isNaN(i) ? i() : i) > 1 &&
                (w("ImageHasSize." + D, function (t, e) {
                  e.img.css({
                    "max-width": e.img[0].naturalWidth / i,
                    width: "100%",
                  });
                }),
                w("ElementParse." + D, function (e, n) {
                  n.src = t.replaceSrc(n, i);
                }));
            }
          },
        },
      }),
        T();
    }),
    function () {
      function t(t, i, n, r) {
        return new e(t, i, n, r);
      }
      function e(t, e, n, r) {
        (this.options = r || {}),
          (this.options.adapters = this.options.adapters || {}),
          (this.obj = t),
          (this.keypath = e),
          (this.callback = n),
          (this.objectPath = []),
          (this.update = this.update.bind(this)),
          this.parse(),
          i((this.target = this.realize())) &&
            this.set(!0, this.key, this.target, this.callback);
      }
      function i(t) {
        return "object" == typeof t && null !== t;
      }
      function n(t) {
        throw new Error("[sightglass] " + t);
      }
      (t.adapters = {}),
        (e.tokenize = function (t, e, i) {
          var n,
            r,
            o = [],
            s = { i: i, path: "" };
          for (n = 0; n < t.length; n++)
            (r = t.charAt(n)),
              ~e.indexOf(r)
                ? (o.push(s), (s = { i: r, path: "" }))
                : (s.path += r);
          return o.push(s), o;
        }),
        (e.prototype.parse = function () {
          var i,
            r,
            o = this.interfaces();
          o.length || n("Must define at least one adapter interface."),
            ~o.indexOf(this.keypath[0])
              ? ((i = this.keypath[0]), (r = this.keypath.substr(1)))
              : (void 0 === (i = this.options.root || t.root) &&
                  n("Must define a default root adapter."),
                (r = this.keypath)),
            (this.tokens = e.tokenize(r, o, i)),
            (this.key = this.tokens.pop());
        }),
        (e.prototype.realize = function () {
          var t,
            e = this.obj,
            n = !1;
          return (
            this.tokens.forEach(function (r, o) {
              i(e)
                ? (void 0 !== this.objectPath[o]
                    ? e !== (t = this.objectPath[o]) &&
                      (this.set(!1, r, t, this.update),
                      this.set(!0, r, e, this.update),
                      (this.objectPath[o] = e))
                    : (this.set(!0, r, e, this.update),
                      (this.objectPath[o] = e)),
                  (e = this.get(r, e)))
                : (!1 === n && (n = o),
                  (t = this.objectPath[o]) && this.set(!1, r, t, this.update));
            }, this),
            !1 !== n && this.objectPath.splice(n),
            e
          );
        }),
        (e.prototype.update = function () {
          var t, e;
          (t = this.realize()) !== this.target &&
            (i(this.target) &&
              this.set(!1, this.key, this.target, this.callback),
            i(t) && this.set(!0, this.key, t, this.callback),
            (e = this.value()),
            (this.target = t),
            (this.value() instanceof Function || this.value() !== e) &&
              this.callback());
        }),
        (e.prototype.value = function () {
          return i(this.target) ? this.get(this.key, this.target) : void 0;
        }),
        (e.prototype.setValue = function (t) {
          i(this.target) &&
            this.adapter(this.key).set(this.target, this.key.path, t);
        }),
        (e.prototype.get = function (t, e) {
          return this.adapter(t).get(e, t.path);
        }),
        (e.prototype.set = function (t, e, i, n) {
          var r = t ? "observe" : "unobserve";
          this.adapter(e)[r](i, e.path, n);
        }),
        (e.prototype.interfaces = function () {
          var e = Object.keys(this.options.adapters);
          return (
            Object.keys(t.adapters).forEach(function (t) {
              ~e.indexOf(t) || e.push(t);
            }),
            e
          );
        }),
        (e.prototype.adapter = function (e) {
          return this.options.adapters[e.i] || t.adapters[e.i];
        }),
        (e.prototype.unobserve = function () {
          var t;
          this.tokens.forEach(function (e, i) {
            (t = this.objectPath[i]) && this.set(!1, e, t, this.update);
          }, this),
            i(this.target) &&
              this.set(!1, this.key, this.target, this.callback);
        }),
        "undefined" != typeof module && module.exports
          ? (module.exports = t)
          : "function" == typeof define && define.amd
          ? define([], function () {
              return (this.sightglass = t);
            })
          : (this.sightglass = t);
    }.call(this),
    function () {
      var t,
        e,
        i,
        n,
        r = function (t, e) {
          return function () {
            return t.apply(e, arguments);
          };
        },
        o = [].slice,
        s = {}.hasOwnProperty,
        a = function (t, e) {
          function i() {
            this.constructor = t;
          }
          for (var n in e) s.call(e, n) && (t[n] = e[n]);
          return (
            (i.prototype = e.prototype),
            (t.prototype = new i()),
            (t.__super__ = e.prototype),
            t
          );
        },
        l =
          [].indexOf ||
          function (t) {
            for (var e = 0, i = this.length; i > e; e++)
              if (e in this && this[e] === t) return e;
            return -1;
          };
      (t = {
        options: [
          "prefix",
          "templateDelimiters",
          "rootInterface",
          "preloadData",
          "handler",
        ],
        extensions: ["binders", "formatters", "components", "adapters"],
        public: {
          binders: {},
          components: {},
          formatters: {},
          adapters: {},
          prefix: "rv",
          templateDelimiters: ["{", "}"],
          rootInterface: ".",
          preloadData: !0,
          handler: function (t, e, i) {
            return this.call(t, e, i.view.models);
          },
          configure: function (e) {
            var i, n, r, o;
            for (r in (null == e && (e = {}), e))
              if (
                ((o = e[r]),
                "binders" === r ||
                  "components" === r ||
                  "formatters" === r ||
                  "adapters" === r)
              )
                for (n in o) (i = o[n]), (t[r][n] = i);
              else t.public[r] = o;
          },
          bind: function (e, i, n) {
            var r;
            return (
              null == i && (i = {}),
              null == n && (n = {}),
              (r = new t.View(e, i, n)).bind(),
              r
            );
          },
          init: function (e, i, n) {
            var r, o;
            return (
              null == n && (n = {}),
              null == i && (i = document.createElement("div")),
              (e = t.public.components[e]),
              (i.innerHTML = e.template.call(this, i)),
              (r = e.initialize.call(this, i, n)),
              (o = new t.View(i, r)).bind(),
              o
            );
          },
        },
      }),
        window.jQuery || window.$
          ? ((n =
              "on" in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"]),
            (e = n[0]),
            (i = n[1]),
            (t.Util = {
              bindEvent: function (t, i, n) {
                return jQuery(t)[e](i, n);
              },
              unbindEvent: function (t, e, n) {
                return jQuery(t)[i](e, n);
              },
              getInputValue: function (t) {
                var e;
                return "checkbox" === (e = jQuery(t)).attr("type")
                  ? e.is(":checked")
                  : e.val();
              },
            }))
          : (t.Util = {
              bindEvent:
                "addEventListener" in window
                  ? function (t, e, i) {
                      return t.addEventListener(e, i, !1);
                    }
                  : function (t, e, i) {
                      return t.attachEvent("on" + e, i);
                    },
              unbindEvent:
                "removeEventListener" in window
                  ? function (t, e, i) {
                      return t.removeEventListener(e, i, !1);
                    }
                  : function (t, e, i) {
                      return t.detachEvent("on" + e, i);
                    },
              getInputValue: function (t) {
                var e, i, n, r;
                if ("checkbox" === t.type) return t.checked;
                if ("select-multiple" === t.type) {
                  for (r = [], i = 0, n = t.length; n > i; i++)
                    (e = t[i]).selected && r.push(e.value);
                  return r;
                }
                return t.value;
              },
            }),
        (t.TypeParser = (function () {
          function t() {}
          return (
            (t.types = { primitive: 0, keypath: 1 }),
            (t.parse = function (t) {
              return /^'.*'$|^".*"$/.test(t)
                ? { type: this.types.primitive, value: t.slice(1, -1) }
                : "true" === t
                ? { type: this.types.primitive, value: !0 }
                : "false" === t
                ? { type: this.types.primitive, value: !1 }
                : "null" === t
                ? { type: this.types.primitive, value: null }
                : "undefined" === t
                ? { type: this.types.primitive, value: void 0 }
                : !1 === isNaN(Number(t))
                ? { type: this.types.primitive, value: Number(t) }
                : { type: this.types.keypath, value: t };
            }),
            t
          );
        })()),
        (t.TextTemplateParser = (function () {
          function t() {}
          return (
            (t.types = { text: 0, binding: 1 }),
            (t.parse = function (t, e) {
              var i, n, r, o, s, a, l;
              for (a = [], o = t.length, i = 0, n = 0; o > n; ) {
                if (0 > (i = t.indexOf(e[0], n))) {
                  a.push({ type: this.types.text, value: t.slice(n) });
                  break;
                }
                if (
                  (i > 0 &&
                    i > n &&
                    a.push({ type: this.types.text, value: t.slice(n, i) }),
                  (n = i + e[0].length),
                  0 > (i = t.indexOf(e[1], n)))
                ) {
                  (s = t.slice(n - e[1].length)),
                    (null != (r = a[a.length - 1]) ? r.type : void 0) ===
                    this.types.text
                      ? (r.value += s)
                      : a.push({ type: this.types.text, value: s });
                  break;
                }
                (l = t.slice(n, i).trim()),
                  a.push({ type: this.types.binding, value: l }),
                  (n = i + e[1].length);
              }
              return a;
            }),
            t
          );
        })()),
        (t.View = (function () {
          function e(e, i, n) {
            var o, s, a, l, u, c, d, p, f, h, v, m, g;
            for (
              this.els = e,
                this.models = i,
                null == n && (n = {}),
                this.update = r(this.update, this),
                this.publish = r(this.publish, this),
                this.sync = r(this.sync, this),
                this.unbind = r(this.unbind, this),
                this.bind = r(this.bind, this),
                this.select = r(this.select, this),
                this.traverse = r(this.traverse, this),
                this.build = r(this.build, this),
                this.buildBinding = r(this.buildBinding, this),
                this.bindingRegExp = r(this.bindingRegExp, this),
                this.options = r(this.options, this),
                this.els.jquery ||
                  this.els instanceof Array ||
                  (this.els = [this.els]),
                u = 0,
                d = (f = t.extensions).length;
              d > u;
              u++
            ) {
              if (((this[(s = f[u])] = {}), n[s]))
                for (o in (h = n[s])) (a = h[o]), (this[s][o] = a);
              for (o in (v = t.public[s]))
                (a = v[o]), null == (l = this[s])[o] && (l[o] = a);
            }
            for (c = 0, p = (m = t.options).length; p > c; c++)
              this[(s = m[c])] = null != (g = n[s]) ? g : t.public[s];
            this.build();
          }
          return (
            (e.prototype.options = function () {
              var e, i, n, r, o;
              for (
                i = {}, n = 0, r = (o = t.extensions.concat(t.options)).length;
                r > n;
                n++
              )
                i[(e = o[n])] = this[e];
              return i;
            }),
            (e.prototype.bindingRegExp = function () {
              return new RegExp("^" + this.prefix + "-");
            }),
            (e.prototype.buildBinding = function (e, i, n, r) {
              var o, s, a, l, u, c, d;
              return (
                (u = {}),
                (d = (function () {
                  var t, e, i, n;
                  for (n = [], t = 0, e = (i = r.split("|")).length; e > t; t++)
                    (c = i[t]), n.push(c.trim());
                  return n;
                })()),
                (l = (o = (function () {
                  var t, e, i, n;
                  for (
                    n = [], t = 0, e = (i = d.shift().split("<")).length;
                    e > t;
                    t++
                  )
                    (s = i[t]), n.push(s.trim());
                  return n;
                })()).shift()),
                (u.formatters = d),
                (a = o.shift()) && (u.dependencies = a.split(/\s+/)),
                this.bindings.push(new t[e](this, i, n, l, u))
              );
            }),
            (e.prototype.build = function () {
              var e, i, n, r, o;
              for (
                this.bindings = [],
                  i = (function (e) {
                    return function (n) {
                      var r, o, s, a, l, u, c, d, p, f, h, v, m, g;
                      if (3 === n.nodeType) {
                        if (
                          ((l = t.TextTemplateParser),
                          (s = e.templateDelimiters) &&
                            (d = l.parse(n.data, s)).length &&
                            (1 !== d.length || d[0].type !== l.types.text))
                        ) {
                          for (p = 0, h = d.length; h > p; p++)
                            (c = d[p]),
                              (u = document.createTextNode(c.value)),
                              n.parentNode.insertBefore(u, n),
                              1 === c.type &&
                                e.buildBinding("TextBinding", u, null, c.value);
                          n.parentNode.removeChild(n);
                        }
                      } else 1 === n.nodeType && (r = e.traverse(n));
                      if (!r) {
                        for (
                          g = [],
                            f = 0,
                            v = (m = (function () {
                              var t, e, i, r;
                              for (
                                r = [], t = 0, e = (i = n.childNodes).length;
                                e > t;
                                t++
                              )
                                (a = i[t]), r.push(a);
                              return r;
                            })()).length;
                          v > f;
                          f++
                        )
                          (o = m[f]), g.push(i(o));
                        return g;
                      }
                    };
                  })(this),
                  n = 0,
                  r = (o = this.els).length;
                r > n;
                n++
              )
                (e = o[n]), i(e);
              this.bindings.sort(function (t, e) {
                var i, n;
                return (
                  ((null != (i = e.binder) ? i.priority : void 0) || 0) -
                  ((null != (n = t.binder) ? n.priority : void 0) || 0)
                );
              });
            }),
            (e.prototype.traverse = function (e) {
              var i, n, r, o, s, a, l, u, c, d, p, f, h, v, m;
              for (
                o = this.bindingRegExp(),
                  s = "SCRIPT" === e.nodeName || "STYLE" === e.nodeName,
                  c = 0,
                  p = (h = e.attributes).length;
                p > c;
                c++
              )
                if (((i = h[c]), o.test(i.name))) {
                  if (((l = i.name.replace(o, "")), !(r = this.binders[l])))
                    for (a in (v = this.binders))
                      (u = v[a]),
                        "*" !== a &&
                          -1 !== a.indexOf("*") &&
                          new RegExp("^" + a.replace(/\*/g, ".+") + "$").test(
                            l
                          ) &&
                          (r = u);
                  r || (r = this.binders["*"]),
                    r.block && ((s = !0), (n = [i]));
                }
              for (d = 0, f = (m = n || e.attributes).length; f > d; d++)
                (i = m[d]),
                  o.test(i.name) &&
                    ((l = i.name.replace(o, "")),
                    this.buildBinding("Binding", e, l, i.value));
              return (
                s ||
                  ((l = e.nodeName.toLowerCase()),
                  this.components[l] &&
                    !e._bound &&
                    (this.bindings.push(new t.ComponentBinding(this, e, l)),
                    (s = !0))),
                s
              );
            }),
            (e.prototype.select = function (t) {
              var e, i, n, r, o;
              for (o = [], i = 0, n = (r = this.bindings).length; n > i; i++)
                t((e = r[i])) && o.push(e);
              return o;
            }),
            (e.prototype.bind = function () {
              var t, e, i, n, r;
              for (r = [], e = 0, i = (n = this.bindings).length; i > e; e++)
                (t = n[e]), r.push(t.bind());
              return r;
            }),
            (e.prototype.unbind = function () {
              var t, e, i, n, r;
              for (r = [], e = 0, i = (n = this.bindings).length; i > e; e++)
                (t = n[e]), r.push(t.unbind());
              return r;
            }),
            (e.prototype.sync = function () {
              var t, e, i, n, r;
              for (r = [], e = 0, i = (n = this.bindings).length; i > e; e++)
                (t = n[e]),
                  r.push("function" == typeof t.sync ? t.sync() : void 0);
              return r;
            }),
            (e.prototype.publish = function () {
              var t, e, i, n, r;
              for (
                n = this.select(function (t) {
                  var e;
                  return null != (e = t.binder) ? e.publishes : void 0;
                }),
                  r = [],
                  e = 0,
                  i = n.length;
                i > e;
                e++
              )
                (t = n[e]), r.push(t.publish());
              return r;
            }),
            (e.prototype.update = function (t) {
              var e, i, n, r, o, s, a;
              for (i in (null == t && (t = {}), t))
                (n = t[i]), (this.models[i] = n);
              for (a = [], r = 0, o = (s = this.bindings).length; o > r; r++)
                (e = s[r]),
                  a.push("function" == typeof e.update ? e.update(t) : void 0);
              return a;
            }),
            e
          );
        })()),
        (t.Binding = (function () {
          function e(t, e, i, n, o) {
            (this.view = t),
              (this.el = e),
              (this.type = i),
              (this.keypath = n),
              (this.options = null != o ? o : {}),
              (this.getValue = r(this.getValue, this)),
              (this.update = r(this.update, this)),
              (this.unbind = r(this.unbind, this)),
              (this.bind = r(this.bind, this)),
              (this.publish = r(this.publish, this)),
              (this.sync = r(this.sync, this)),
              (this.set = r(this.set, this)),
              (this.eventHandler = r(this.eventHandler, this)),
              (this.formattedValue = r(this.formattedValue, this)),
              (this.parseTarget = r(this.parseTarget, this)),
              (this.observe = r(this.observe, this)),
              (this.setBinder = r(this.setBinder, this)),
              (this.formatters = this.options.formatters || []),
              (this.dependencies = []),
              (this.formatterObservers = {}),
              (this.model = void 0),
              this.setBinder();
          }
          return (
            (e.prototype.setBinder = function () {
              var t, e, i;
              if (!(this.binder = this.view.binders[this.type]))
                for (t in (i = this.view.binders))
                  (e = i[t]),
                    "*" !== t &&
                      -1 !== t.indexOf("*") &&
                      new RegExp("^" + t.replace(/\*/g, ".+") + "$").test(
                        this.type
                      ) &&
                      ((this.binder = e),
                      (this.args = new RegExp(
                        "^" + t.replace(/\*/g, "(.+)") + "$"
                      ).exec(this.type)),
                      this.args.shift());
              return (
                this.binder || (this.binder = this.view.binders["*"]),
                this.binder instanceof Function
                  ? (this.binder = { routine: this.binder })
                  : void 0
              );
            }),
            (e.prototype.observe = function (e, i, n) {
              return t.sightglass(e, i, n, {
                root: this.view.rootInterface,
                adapters: this.view.adapters,
              });
            }),
            (e.prototype.parseTarget = function () {
              var e;
              return 0 === (e = t.TypeParser.parse(this.keypath)).type
                ? (this.value = e.value)
                : ((this.observer = this.observe(
                    this.view.models,
                    this.keypath,
                    this.sync
                  )),
                  (this.model = this.observer.target));
            }),
            (e.prototype.formattedValue = function (e) {
              var i, n, r, s, a, l, u, c, d, p, f, h, v, m;
              for (
                s = p = 0, h = (m = this.formatters).length;
                h > p;
                s = ++p
              ) {
                for (
                  a = m[s],
                    l = (r = a.match(
                      /[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g
                    )).shift(),
                    a = this.view.formatters[l],
                    r = (function () {
                      var e, i, o;
                      for (o = [], e = 0, i = r.length; i > e; e++)
                        (n = r[e]), o.push(t.TypeParser.parse(n));
                      return o;
                    })(),
                    c = [],
                    i = f = 0,
                    v = r.length;
                  v > f;
                  i = ++f
                )
                  (n = r[i]),
                    c.push(
                      0 === n.type
                        ? n.value
                        : ((d = this.formatterObservers)[s] || (d[s] = {}),
                          (u = this.formatterObservers[s][i]) ||
                            ((u = this.observe(
                              this.view.models,
                              n.value,
                              this.sync
                            )),
                            (this.formatterObservers[s][i] = u)),
                          u.value())
                    );
                (null != a ? a.read : void 0) instanceof Function
                  ? (e = a.read.apply(a, [e].concat(o.call(c))))
                  : a instanceof Function &&
                    (e = a.apply(null, [e].concat(o.call(c))));
              }
              return e;
            }),
            (e.prototype.eventHandler = function (t) {
              var e, i;
              return (
                (i = (e = this).view.handler),
                function (n) {
                  return i.call(t, this, n, e);
                }
              );
            }),
            (e.prototype.set = function (t) {
              var e;
              return (
                (t = this.formattedValue(
                  t instanceof Function && !this.binder.function
                    ? t.call(this.model)
                    : t
                )),
                null != (e = this.binder.routine)
                  ? e.call(this, this.el, t)
                  : void 0
              );
            }),
            (e.prototype.sync = function () {
              var t, e;
              return this.set(
                function () {
                  var i, n, r, o, s, a, l;
                  if (this.observer) {
                    if (this.model !== this.observer.target) {
                      for (
                        i = 0, r = (s = this.dependencies).length;
                        r > i;
                        i++
                      )
                        (e = s[i]).unobserve();
                      if (
                        ((this.dependencies = []),
                        null != (this.model = this.observer.target) &&
                          (null != (a = this.options.dependencies)
                            ? a.length
                            : void 0))
                      )
                        for (
                          n = 0, o = (l = this.options.dependencies).length;
                          o > n;
                          n++
                        )
                          (t = l[n]),
                            (e = this.observe(this.model, t, this.sync)),
                            this.dependencies.push(e);
                    }
                    return this.observer.value();
                  }
                  return this.value;
                }.call(this)
              );
            }),
            (e.prototype.publish = function () {
              var t, e, i, n, r, s, a, l;
              if (this.observer) {
                for (
                  i = this.getValue(this.el),
                    n = 0,
                    r = (s = this.formatters.slice(0).reverse()).length;
                  r > n;
                  n++
                )
                  (e = (t = s[n].split(/\s+/)).shift()),
                    (null != (a = this.view.formatters[e])
                      ? a.publish
                      : void 0) &&
                      (i = (l = this.view.formatters[e]).publish.apply(
                        l,
                        [i].concat(o.call(t))
                      ));
                return this.observer.setValue(i);
              }
            }),
            (e.prototype.bind = function () {
              var t, e, i, n, r, o, s;
              if (
                (this.parseTarget(),
                null != (r = this.binder.bind) && r.call(this, this.el),
                null != this.model &&
                  (null != (o = this.options.dependencies) ? o.length : void 0))
              )
                for (
                  i = 0, n = (s = this.options.dependencies).length;
                  n > i;
                  i++
                )
                  (t = s[i]),
                    (e = this.observe(this.model, t, this.sync)),
                    this.dependencies.push(e);
              return this.view.preloadData ? this.sync() : void 0;
            }),
            (e.prototype.unbind = function () {
              var t, e, i, n, r, o, s, a, l;
              for (
                null != (o = this.binder.unbind) && o.call(this, this.el),
                  null != (s = this.observer) && s.unobserve(),
                  n = 0,
                  r = (a = this.dependencies).length;
                r > n;
                n++
              )
                a[n].unobserve();
              for (i in ((this.dependencies = []),
              (l = this.formatterObservers)))
                for (t in (e = l[i])) e[t].unobserve();
              return (this.formatterObservers = {});
            }),
            (e.prototype.update = function (t) {
              var e, i;
              return (
                null == t && (t = {}),
                (this.model = null != (e = this.observer) ? e.target : void 0),
                null != (i = this.binder.update) ? i.call(this, t) : void 0
              );
            }),
            (e.prototype.getValue = function (e) {
              return this.binder && null != this.binder.getValue
                ? this.binder.getValue.call(this, e)
                : t.Util.getInputValue(e);
            }),
            e
          );
        })()),
        (t.ComponentBinding = (function (e) {
          function i(t, e, i) {
            var n, o, s, a, u, c, d;
            for (
              this.view = t,
                this.el = e,
                this.type = i,
                this.unbind = r(this.unbind, this),
                this.bind = r(this.bind, this),
                this.locals = r(this.locals, this),
                this.component = this.view.components[this.type],
                this.static = {},
                this.observers = {},
                this.upstreamObservers = {},
                o = t.bindingRegExp(),
                a = 0,
                u = (c = this.el.attributes || []).length;
              u > a;
              a++
            )
              (n = c[a]),
                o.test(n.name) ||
                  ((s = this.camelCase(n.name)),
                  l.call(null != (d = this.component.static) ? d : [], s) >= 0
                    ? (this.static[s] = n.value)
                    : (this.observers[s] = n.value));
          }
          return (
            a(i, e),
            (i.prototype.sync = function () {}),
            (i.prototype.update = function () {}),
            (i.prototype.publish = function () {}),
            (i.prototype.locals = function () {
              var t, e, i, n, r, o;
              for (t in ((i = {}), (r = this.static))) (n = r[t]), (i[t] = n);
              for (t in (o = this.observers)) (e = o[t]), (i[t] = e.value());
              return i;
            }),
            (i.prototype.camelCase = function (t) {
              return t.replace(/-([a-z])/g, function (t) {
                return t[1].toUpperCase();
              });
            }),
            (i.prototype.bind = function () {
              var e, i, n, r, o, s, a, l, u, c, d, p, f, h, v, m, g, y, b, w, k;
              if (!this.bound) {
                for (i in (h = this.observers))
                  (n = h[i]),
                    (this.observers[i] = this.observe(
                      this.view.models,
                      n,
                      (function (t) {
                        return function (e) {
                          return function () {
                            return (t.componentView.models[e] =
                              t.observers[e].value());
                          };
                        };
                      })(this).call(this, i)
                    ));
                this.bound = !0;
              }
              if (null != this.componentView) return this.componentView.bind();
              for (
                this.el.innerHTML = this.component.template.call(this),
                  a = this.component.initialize.call(
                    this,
                    this.el,
                    this.locals()
                  ),
                  this.el._bound = !0,
                  s = {},
                  c = 0,
                  p = (v = t.extensions).length;
                p > c;
                c++
              ) {
                if (((s[(o = v[c])] = {}), this.component[o]))
                  for (e in (m = this.component[o])) (l = m[e]), (s[o][e] = l);
                for (e in (g = this.view[o]))
                  (l = g[e]), null == (u = s[o])[e] && (u[e] = l);
              }
              for (d = 0, f = (y = t.options).length; f > d; d++)
                s[(o = y[d])] =
                  null != (b = this.component[o]) ? b : this.view[o];
              for (i in ((this.componentView = new t.View(this.el, a, s)),
              this.componentView.bind(),
              (k = []),
              (w = this.observers)))
                (r = w[i]),
                  k.push(
                    (this.upstreamObservers[i] = this.observe(
                      this.componentView.models,
                      i,
                      (function (t) {
                        return function (e, i) {
                          return function () {
                            return i.setValue(t.componentView.models[e]);
                          };
                        };
                      })(this).call(this, i, r)
                    ))
                  );
              return k;
            }),
            (i.prototype.unbind = function () {
              var t, e, i, n;
              for (t in (e = this.upstreamObservers)) e[t].unobserve();
              for (t in (i = this.observers)) i[t].unobserve();
              return null != (n = this.componentView)
                ? n.unbind.call(this)
                : void 0;
            }),
            i
          );
        })(t.Binding)),
        (t.TextBinding = (function (t) {
          function e(t, e, i, n, o) {
            (this.view = t),
              (this.el = e),
              (this.type = i),
              (this.keypath = n),
              (this.options = null != o ? o : {}),
              (this.sync = r(this.sync, this)),
              (this.formatters = this.options.formatters || []),
              (this.dependencies = []),
              (this.formatterObservers = {});
          }
          return (
            a(e, t),
            (e.prototype.binder = {
              routine: function (t, e) {
                return (t.data = null != e ? e : "");
              },
            }),
            (e.prototype.sync = function () {
              return e.__super__.sync.apply(this, arguments);
            }),
            e
          );
        })(t.Binding)),
        (t.public.binders.text = function (t, e) {
          return null != t.textContent
            ? (t.textContent = null != e ? e : "")
            : (t.innerText = null != e ? e : "");
        }),
        (t.public.binders.html = function (t, e) {
          return (t.innerHTML = null != e ? e : "");
        }),
        (t.public.binders.show = function (t, e) {
          return (t.style.display = e ? "" : "none");
        }),
        (t.public.binders.hide = function (t, e) {
          return (t.style.display = e ? "none" : "");
        }),
        (t.public.binders.enabled = function (t, e) {
          return (t.disabled = !e);
        }),
        (t.public.binders.disabled = function (t, e) {
          return (t.disabled = !!e);
        }),
        (t.public.binders.checked = {
          publishes: !0,
          priority: 2e3,
          bind: function (e) {
            return t.Util.bindEvent(e, "change", this.publish);
          },
          unbind: function (e) {
            return t.Util.unbindEvent(e, "change", this.publish);
          },
          routine: function (t, e) {
            var i;
            return (t.checked =
              "radio" === t.type
                ? (null != (i = t.value) ? i.toString() : void 0) ===
                  (null != e ? e.toString() : void 0)
                : !!e);
          },
        }),
        (t.public.binders.unchecked = {
          publishes: !0,
          priority: 2e3,
          bind: function (e) {
            return t.Util.bindEvent(e, "change", this.publish);
          },
          unbind: function (e) {
            return t.Util.unbindEvent(e, "change", this.publish);
          },
          routine: function (t, e) {
            var i;
            return (t.checked =
              "radio" === t.type
                ? (null != (i = t.value) ? i.toString() : void 0) !==
                  (null != e ? e.toString() : void 0)
                : !e);
          },
        }),
        (t.public.binders.value = {
          publishes: !0,
          priority: 3e3,
          bind: function (e) {
            return "INPUT" !== e.tagName || "radio" !== e.type
              ? ((this.event = "SELECT" === e.tagName ? "change" : "input"),
                t.Util.bindEvent(e, this.event, this.publish))
              : void 0;
          },
          unbind: function (e) {
            return "INPUT" !== e.tagName || "radio" !== e.type
              ? t.Util.unbindEvent(e, this.event, this.publish)
              : void 0;
          },
          routine: function (t, e) {
            var i, n, r, o, s, a, u;
            if ("INPUT" === t.tagName && "radio" === t.type)
              return t.setAttribute("value", e);
            if (null != window.jQuery) {
              if (
                ((t = jQuery(t)),
                (null != e ? e.toString() : void 0) !==
                  (null != (o = t.val()) ? o.toString() : void 0))
              )
                return t.val(null != e ? e : "");
            } else if ("select-multiple" === t.type) {
              if (null != e) {
                for (u = [], n = 0, r = t.length; r > n; n++)
                  (i = t[n]),
                    u.push((i.selected = ((s = i.value), l.call(e, s) >= 0)));
                return u;
              }
            } else if (
              (null != e ? e.toString() : void 0) !==
              (null != (a = t.value) ? a.toString() : void 0)
            )
              return (t.value = null != e ? e : "");
          },
        }),
        (t.public.binders.if = {
          block: !0,
          priority: 4e3,
          bind: function (t) {
            var e, i;
            return null == this.marker
              ? ((e = [this.view.prefix, this.type]
                  .join("-")
                  .replace("--", "-")),
                (i = t.getAttribute(e)),
                (this.marker = document.createComment(
                  " rivets: " + this.type + " " + i + " "
                )),
                (this.bound = !1),
                t.removeAttribute(e),
                t.parentNode.insertBefore(this.marker, t),
                t.parentNode.removeChild(t))
              : void 0;
          },
          unbind: function () {
            var t;
            return null != (t = this.nested) ? t.unbind() : void 0;
          },
          routine: function (e, i) {
            var n, r, o, s;
            if (!!i == !this.bound) {
              if (i) {
                for (n in ((o = {}), (s = this.view.models)))
                  (r = s[n]), (o[n] = r);
                return (
                  (
                    this.nested ||
                    (this.nested = new t.View(e, o, this.view.options()))
                  ).bind(),
                  this.marker.parentNode.insertBefore(
                    e,
                    this.marker.nextSibling
                  ),
                  (this.bound = !0)
                );
              }
              return (
                e.parentNode.removeChild(e),
                this.nested.unbind(),
                (this.bound = !1)
              );
            }
          },
          update: function (t) {
            var e;
            return null != (e = this.nested) ? e.update(t) : void 0;
          },
        }),
        (t.public.binders.unless = {
          block: !0,
          priority: 4e3,
          bind: function (e) {
            return t.public.binders.if.bind.call(this, e);
          },
          unbind: function () {
            return t.public.binders.if.unbind.call(this);
          },
          routine: function (e, i) {
            return t.public.binders.if.routine.call(this, e, !i);
          },
          update: function (e) {
            return t.public.binders.if.update.call(this, e);
          },
        }),
        (t.public.binders["on-*"] = {
          function: !0,
          priority: 1e3,
          unbind: function (e) {
            return this.handler
              ? t.Util.unbindEvent(e, this.args[0], this.handler)
              : void 0;
          },
          routine: function (e, i) {
            return (
              this.handler && t.Util.unbindEvent(e, this.args[0], this.handler),
              t.Util.bindEvent(
                e,
                this.args[0],
                (this.handler = this.eventHandler(i))
              )
            );
          },
        }),
        (t.public.binders["each-*"] = {
          block: !0,
          priority: 4e3,
          bind: function (t) {
            var e, i, n, r;
            if (null == this.marker)
              (e = [this.view.prefix, this.type].join("-").replace("--", "-")),
                (this.marker = document.createComment(
                  " rivets: " + this.type + " "
                )),
                (this.iterated = []),
                t.removeAttribute(e),
                t.parentNode.insertBefore(this.marker, t),
                t.parentNode.removeChild(t);
            else
              for (i = 0, n = (r = this.iterated).length; n > i; i++)
                r[i].bind();
          },
          unbind: function () {
            var t, e, i, n, r;
            if (null != this.iterated) {
              for (r = [], e = 0, i = (n = this.iterated).length; i > e; e++)
                (t = n[e]), r.push(t.unbind());
              return r;
            }
          },
          routine: function (e, i) {
            var n, r, o, s, a, l, u, c, d, p, f, h, v, m, g, y, b, w, k, C;
            if (
              ((l = this.args[0]),
              (i = i || []),
              this.iterated.length > i.length)
            )
              for (
                f = 0, m = (b = Array(this.iterated.length - i.length)).length;
                m > f;
                f++
              )
                b[f],
                  (p = this.iterated.pop()).unbind(),
                  this.marker.parentNode.removeChild(p.els[0]);
            for (o = h = 0, g = i.length; g > h; o = ++h)
              if (
                ((a = i[o]),
                ((r = { index: o })[l] = a),
                null == this.iterated[o])
              ) {
                for (s in (w = this.view.models))
                  (a = w[s]), null == r[s] && (r[s] = a);
                (c = this.iterated.length
                  ? this.iterated[this.iterated.length - 1].els[0]
                  : this.marker),
                  ((u = this.view.options()).preloadData = !0),
                  (d = e.cloneNode(!0)),
                  (p = new t.View(d, r, u)).bind(),
                  this.iterated.push(p),
                  this.marker.parentNode.insertBefore(d, c.nextSibling);
              } else
                this.iterated[o].models[l] !== a && this.iterated[o].update(r);
            if ("OPTION" === e.nodeName) {
              for (
                C = [], v = 0, y = (k = this.view.bindings).length;
                y > v;
                v++
              )
                (n = k[v]),
                  C.push(
                    n.el === this.marker.parentNode && "value" === n.type
                      ? n.sync()
                      : void 0
                  );
              return C;
            }
          },
          update: function (t) {
            var e, i, n, r, o, s, a, l;
            for (i in ((e = {}), t))
              (n = t[i]), i !== this.args[0] && (e[i] = n);
            for (l = [], o = 0, s = (a = this.iterated).length; s > o; o++)
              (r = a[o]), l.push(r.update(e));
            return l;
          },
        }),
        (t.public.binders["class-*"] = function (t, e) {
          var i;
          return !e ==
            (-1 !==
              (i = " " + t.className + " ").indexOf(" " + this.args[0] + " "))
            ? (t.className = e
                ? t.className + " " + this.args[0]
                : i.replace(" " + this.args[0] + " ", " ").trim())
            : void 0;
        }),
        (t.public.binders["*"] = function (t, e) {
          return null != e
            ? t.setAttribute(this.type, e)
            : t.removeAttribute(this.type);
        }),
        (t.public.adapters["."] = {
          id: "_rv",
          counter: 0,
          weakmap: {},
          weakReference: function (t) {
            var e, i, n;
            return (
              t.hasOwnProperty(this.id) ||
                ((e = this.counter++),
                Object.defineProperty(t, this.id, { value: e })),
              (i = this.weakmap)[(n = t[this.id])] || (i[n] = { callbacks: {} })
            );
          },
          cleanupWeakReference: function (t, e) {
            return Object.keys(t.callbacks).length ||
              (t.pointers && Object.keys(t.pointers).length)
              ? void 0
              : delete this.weakmap[e];
          },
          stubFunction: function (t, e) {
            var i, n, r;
            return (
              (n = t[e]),
              (i = this.weakReference(t)),
              (r = this.weakmap),
              (t[e] = function () {
                var e, o, s, a, l, u, c, d, p;
                for (o in ((s = n.apply(t, arguments)), (u = i.pointers)))
                  for (
                    e = u[o],
                      a = 0,
                      l = (p =
                        null !=
                        (c = null != (d = r[o]) ? d.callbacks[e] : void 0)
                          ? c
                          : []).length;
                    l > a;
                    a++
                  )
                    (0, p[a])();
                return s;
              })
            );
          },
          observeMutations: function (t, e, i) {
            var n, r, o, s, a, u;
            if (Array.isArray(t)) {
              if (null == (o = this.weakReference(t)).pointers)
                for (
                  o.pointers = {},
                    a = 0,
                    u = (r = [
                      "push",
                      "pop",
                      "shift",
                      "unshift",
                      "sort",
                      "reverse",
                      "splice",
                    ]).length;
                  u > a;
                  a++
                )
                  (n = r[a]), this.stubFunction(t, n);
              if (
                (null == (s = o.pointers)[e] && (s[e] = []),
                l.call(o.pointers[e], i) < 0)
              )
                return o.pointers[e].push(i);
            }
          },
          unobserveMutations: function (t, e, i) {
            var n, r, o;
            return Array.isArray(t) &&
              null != t[this.id] &&
              (r = this.weakmap[t[this.id]]) &&
              (o = r.pointers[e])
              ? ((n = o.indexOf(i)) >= 0 && o.splice(n, 1),
                o.length || delete r.pointers[e],
                this.cleanupWeakReference(r, t[this.id]))
              : void 0;
          },
          observe: function (t, e, i) {
            var n, r, o;
            return (
              null == (n = this.weakReference(t).callbacks)[e] &&
                ((n[e] = []),
                (null != (r = Object.getOwnPropertyDescriptor(t, e))
                  ? r.get
                  : void 0) ||
                  (null != r ? r.set : void 0) ||
                  ((o = t[e]),
                  Object.defineProperty(t, e, {
                    enumerable: !0,
                    get: function () {
                      return o;
                    },
                    set: (function (r) {
                      return function (s) {
                        var a, u, c, d;
                        if (
                          s !== o &&
                          (r.unobserveMutations(o, t[r.id], e),
                          (o = s),
                          (a = r.weakmap[t[r.id]]))
                        ) {
                          if ((n = a.callbacks)[e])
                            for (
                              u = 0, c = (d = n[e].slice()).length;
                              c > u;
                              u++
                            )
                              (i = d[u]), l.call(n[e], i) >= 0 && i();
                          return r.observeMutations(s, t[r.id], e);
                        }
                      };
                    })(this),
                  }))),
              l.call(n[e], i) < 0 && n[e].push(i),
              this.observeMutations(t[e], t[this.id], e)
            );
          },
          unobserve: function (t, e, i) {
            var n, r, o;
            return (o = this.weakmap[t[this.id]]) && (n = o.callbacks[e])
              ? ((r = n.indexOf(i)) >= 0 &&
                  (n.splice(r, 1), n.length || delete o.callbacks[e]),
                this.unobserveMutations(t[e], t[this.id], e),
                this.cleanupWeakReference(o, t[this.id]))
              : void 0;
          },
          get: function (t, e) {
            return t[e];
          },
          set: function (t, e, i) {
            return (t[e] = i);
          },
        }),
        (t.factory = function (e) {
          return (t.sightglass = e), (t.public._ = t), t.public;
        }),
        "object" ==
        typeof ("undefined" != typeof module && null !== module
          ? module.exports
          : void 0)
          ? (module.exports = t.factory(require("sightglass")))
          : "function" == typeof define && define.amd
          ? define(["sightglass"], function (e) {
              return (this.rivets = t.factory(e));
            })
          : (this.rivets = t.factory(sightglass));
    }.call(this),
    function () {
      var t,
        e,
        i,
        n,
        r,
        o,
        s = function (t, e) {
          return function () {
            return t.apply(e, arguments);
          };
        },
        a =
          [].indexOf ||
          function (t) {
            for (var e = 0, i = this.length; i > e; e++)
              if (e in this && this[e] === t) return e;
            return -1;
          };
      (e = (function () {
        function t() {
          this.update = s(this.update, this);
        }
        return (
          (t.prototype.update = function (t) {
            var e, i, r;
            for (i in t) (r = t[i]), "items" !== i && (this[i] = r);
            return (this.items = (function () {
              var i, r, o, s;
              for (s = [], i = 0, r = (o = t.items).length; r > i; i++)
                (e = o[i]), s.push(new n(e));
              return s;
            })());
          }),
          t
        );
      })()),
        (n = (function () {
          function t(t) {
            (this.propertyArray = s(this.propertyArray, this)),
              (this.update = s(this.update, this)),
              this.update(t);
          }
          return (
            (t.prototype.update = function (t) {
              var e, n;
              for (e in t) (n = t[e]), "properties" !== e && (this[e] = n);
              return (this.properties = i.Utils.extend({}, t.properties));
            }),
            (t.prototype.propertyArray = function () {
              var t, e, i, n;
              for (t in ((n = []), (i = this.properties)))
                (e = i[t]), n.push({ name: t, value: e });
              return n;
            }),
            t
          );
        })()),
        ((i = {
          settings: {
            debug: !1,
            dataAPI: !0,
            requestBodyClass: null,
            rivetsModels: {},
            currency: null,
            moneyFormat: null,
            moneyWithCurrencyFormat: null,
            weightUnit: "g",
            weightPrecision: 0,
          },
          cart: new e(),
        }).init = function (t, e) {
          return (
            null == e && (e = {}),
            i.configure(e),
            i.Utils.log("Initialising CartJS."),
            i.cart.update(t),
            i.settings.dataAPI &&
              (i.Utils.log('"dataAPI" setting is true, initialising Data API.'),
              i.Data.init()),
            i.settings.requestBodyClass &&
              (i.Utils.log('"requestBodyClass" set, adding event listeners.'),
              jQuery(document).on("cart.requestStarted", function () {
                return jQuery("body").addClass(i.settings.requestBodyClass);
              }),
              jQuery(document).on("cart.requestComplete", function () {
                return jQuery("body").removeClass(i.settings.requestBodyClass);
              })),
            i.Rivets.init(),
            jQuery(document).trigger("cart.ready", [i.cart])
          );
        }),
        (i.configure = function (t) {
          return null == t && (t = {}), i.Utils.extend(i.settings, t);
        }),
        null == window.console &&
          ((window.console = {}), (window.console.log = function () {})),
        (i.Utils = {
          log: function () {
            return i.Utils.console(console.log, arguments);
          },
          warn: function () {
            return i.Utils.console(console.warn, arguments);
          },
          error: function () {
            return i.Utils.console(console.error, arguments);
          },
          console: function (t, e) {
            return i.settings.debug &&
              "undefined" != typeof console &&
              null !== console
              ? ((e = Array.prototype.slice.call(e)).unshift("[CartJS]:"),
                t.apply(console, e))
              : void 0;
          },
          wrapKeys: function (t, e, i, n) {
            var r, o, s;
            for (r in (null == e && (e = "properties"),
            null == n && (n = []),
            (s = {}),
            t))
              (o = t[r]),
                (s[a.call(n, r) >= 0 ? r : e + "[" + r + "]"] =
                  null != i ? i : o);
            return s;
          },
          unwrapKeys: function (t, e, i) {
            var n, r, o;
            for (n in (null == e && (e = "properties"), (r = {}), t))
              (o = t[n]),
                (r[n.replace(e + "[", "").replace("]", "")] =
                  null != i ? i : o);
            return r;
          },
          extend: function (t, e) {
            var i, n;
            for (i in e) (n = e[i]), (t[i] = n);
            return t;
          },
          clone: function (t) {
            var e, i;
            if (null == t || "object" != typeof t) return t;
            for (e in ((i = new t.constructor()), t)) i[e] = clone(t[e]);
            return i;
          },
          delete: function (t, e) {
            var i;
            return (i = t[e]), delete t[e], i;
          },
          isArray:
            Array.isArray ||
            function (t) {
              return "[object Array]" === {}.toString.call(t);
            },
          ensureArray: function (t) {
            return i.Utils.isArray(t) ? t : null != t ? [t] : [];
          },
          formatMoney: function (t, e, n, r) {
            var o, s;
            return (
              null == r && (r = ""),
              r || (r = i.settings.currency),
              null != window.Currency &&
                r !== i.settings.currency &&
                ((t = Currency.convert(t, i.settings.currency, r)),
                null !=
                  (null != (o = window.Currency) ? o.moneyFormats : void 0) &&
                  r in window.Currency.moneyFormats &&
                  (e = window.Currency.moneyFormats[r][n])),
              null != (null != (s = window.Shopify) ? s.formatMoney : void 0)
                ? Shopify.formatMoney(t, e)
                : (i.Utils.warn(
                    'A money formatting filter was used, but Shopify.formatMoney is not available. See the note "Dependency when formatting monetary values" on this page: https://cartjs.org/pages/guide#getting-started-setup.'
                  ),
                  t)
            );
          },
          getSizedImageUrl: function (t, e) {
            var i, n;
            return null !=
              (null != (i = window.Shopify) && null != (n = i.Image)
                ? n.getSizedImageUrl
                : void 0)
              ? t
                ? Shopify.Image.getSizedImageUrl(t, e)
                : Shopify.Image.getSizedImageUrl(
                    "https://cdn.shopify.com/s/images/admin/no-image-.gif",
                    e
                  ).replace("-_", "-")
              : t ||
                  "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
          },
        }),
        (o = []),
        (r = !1),
        (i.Queue = {
          add: function (t, e, n) {
            var s;
            return (
              null == n && (n = {}),
              (s = {
                url: t,
                data: e,
                type: n.type || "POST",
                dataType: n.dataType || "json",
                cache: !!n.cache,
                success: i.Utils.ensureArray(n.success),
                error: i.Utils.ensureArray(n.error),
                complete: i.Utils.ensureArray(n.complete),
              }),
              n.updateCart && s.success.push(i.cart.update),
              o.push(s),
              r
                ? void 0
                : (jQuery(document).trigger("cart.requestStarted", [i.cart]),
                  i.Queue.process())
            );
          },
          process: function () {
            var t;
            return o.length
              ? ((r = !0),
                ((t = o.shift()).complete = i.Queue.process),
                jQuery.ajax(t))
              : ((r = !1),
                void jQuery(document).trigger("cart.requestComplete", [
                  i.cart,
                ]));
          },
        }),
        (i.Core = {
          getCart: function (t) {
            return (
              null == t && (t = {}),
              (t.type = "GET"),
              (t.updateCart = !0),
              i.Queue.add("/cart.js", { v: new Date().getTime() }, t)
            );
          },
          addItem: function (t, e, n, r) {
            var o;
            return (
              null == e && (e = 1),
              null == n && (n = {}),
              null == r && (r = {}),
              ((o = i.Utils.wrapKeys(n, null, null, ["selling_plan"])).id = t),
              (o.quantity = e),
              i.Queue.add("/cart/add.js", o, r),
              i.Core.getCart()
            );
          },
          addItems: function (t, e) {
            var n;
            return (
              null == e && (e = {}),
              (n = { items: t }),
              i.Queue.add("/cart/add.js", n, e),
              i.Core.getCart()
            );
          },
          updateItem: function (t, e, n, r) {
            var o;
            return (
              null == n && (n = {}),
              null == r && (r = {}),
              ((o = i.Utils.wrapKeys(n, null, null, ["selling_plan"])).line =
                t),
              null != e && (o.quantity = e),
              (r.updateCart = !0),
              i.Queue.add("/cart/change.js", o, r)
            );
          },
          removeItem: function (t, e) {
            return null == e && (e = {}), i.Core.updateItem(t, 0, {}, e);
          },
          updateItemById: function (t, e, n, r) {
            var o;
            return (
              null == n && (n = {}),
              null == r && (r = {}),
              ((o = i.Utils.wrapKeys(n, null, null, ["selling_plan"])).id = t),
              null != e && (o.quantity = e),
              (r.updateCart = !0),
              i.Queue.add("/cart/change.js", o, r)
            );
          },
          updateItemQuantitiesById: function (t, e) {
            return (
              null == t && (t = {}),
              null == e && (e = {}),
              (e.updateCart = !0),
              i.Queue.add("/cart/update.js", { updates: t }, e)
            );
          },
          removeItemById: function (t, e) {
            var n;
            return (
              null == e && (e = {}),
              (n = { id: t, quantity: 0 }),
              (e.updateCart = !0),
              i.Queue.add("/cart/change.js", n, e)
            );
          },
          clear: function (t) {
            return (
              null == t && (t = {}),
              (t.updateCart = !0),
              i.Queue.add("/cart/clear.js", {}, t)
            );
          },
          getAttribute: function (t, e) {
            return t in i.cart.attributes ? i.cart.attributes[t] : e;
          },
          setAttribute: function (t, e, n) {
            var r;
            return (
              null == n && (n = {}),
              ((r = {})[t] = e),
              i.Core.setAttributes(r, n)
            );
          },
          getAttributes: function () {
            return i.cart.attributes;
          },
          setAttributes: function (t, e) {
            return (
              null == t && (t = {}),
              null == e && (e = {}),
              (e.updateCart = !0),
              i.Queue.add(
                "/cart/update.js",
                i.Utils.wrapKeys(t, "attributes"),
                e
              )
            );
          },
          clearAttributes: function (t) {
            return (
              null == t && (t = {}),
              (t.updateCart = !0),
              i.Queue.add(
                "/cart/update.js",
                i.Utils.wrapKeys(i.Core.getAttributes(), "attributes", ""),
                t
              )
            );
          },
          getNote: function () {
            return i.cart.note;
          },
          setNote: function (t, e) {
            return (
              null == e && (e = {}),
              (e.updateCart = !0),
              i.Queue.add("/cart/update.js", { note: t }, e)
            );
          },
        }),
        (t = null),
        (i.Data = {
          init: function () {
            return (
              (t = jQuery(document)),
              i.Data.setEventListeners("on"),
              i.Data.render(null, i.cart)
            );
          },
          destroy: function () {
            return i.Data.setEventListeners("off");
          },
          setEventListeners: function (e) {
            return (
              t[e]("click", "[data-cart-add]", i.Data.add),
              t[e]("click", "[data-cart-remove]", i.Data.remove),
              t[e]("click", "[data-cart-remove-id]", i.Data.removeById),
              t[e]("click", "[data-cart-update]", i.Data.update),
              t[e]("click", "[data-cart-update-id]", i.Data.updateById),
              t[e]("click", "[data-cart-clear]", i.Data.clear),
              t[e]("change", "[data-cart-toggle]", i.Data.toggle),
              t[e](
                "change",
                "[data-cart-toggle-attribute]",
                i.Data.toggleAttribute
              ),
              t[e]("submit", "[data-cart-submit]", i.Data.submit),
              t[e]("cart.requestComplete", i.Data.render)
            );
          },
          add: function (t) {
            var e, n;
            return (
              t.preventDefault(),
              (e = jQuery(this)),
              ((n = {}).selling_plan = e.attr("data-cart-selling-plan")),
              i.Core.addItem(
                e.attr("data-cart-add"),
                e.attr("data-cart-quantity"),
                n
              )
            );
          },
          remove: function (t) {
            var e;
            return (
              t.preventDefault(),
              (e = jQuery(this)),
              i.Core.removeItem(e.attr("data-cart-remove"))
            );
          },
          removeById: function (t) {
            var e;
            return (
              t.preventDefault(),
              (e = jQuery(this)),
              i.Core.removeItemById(e.attr("data-cart-remove-id"))
            );
          },
          update: function (t) {
            var e, n;
            return (
              t.preventDefault(),
              (e = jQuery(this)),
              ((n = {}).selling_plan = e.attr("data-cart-selling-plan")),
              i.Core.updateItem(
                e.attr("data-cart-update"),
                e.attr("data-cart-quantity"),
                n
              )
            );
          },
          updateById: function (t) {
            var e, n;
            return (
              t.preventDefault(),
              (e = jQuery(this)),
              ((n = {}).selling_plan = e.attr("data-cart-selling-plan")),
              i.Core.updateItemById(
                e.attr("data-cart-update-id"),
                e.attr("data-cart-quantity"),
                n
              )
            );
          },
          clear: function (t) {
            return t.preventDefault(), i.Core.clear();
          },
          toggle: function () {
            var t, e;
            return (
              (e = (t = jQuery(this)).attr("data-cart-toggle")),
              t.is(":checked") ? i.Core.addItem(e) : i.Core.removeItemById(e)
            );
          },
          toggleAttribute: function () {
            var t, e;
            return (
              (e = (t = jQuery(this)).attr("data-cart-toggle-attribute")),
              i.Core.setAttribute(e, t.is(":checked") ? "Yes" : "")
            );
          },
          submit: function (t) {
            var e, n, r, o;
            return (
              t.preventDefault(),
              (e = jQuery(this).serializeArray()),
              (n = void 0),
              (o = void 0),
              (r = {}),
              jQuery.each(e, function (t, e) {
                return "id" === e.name
                  ? (n = e.value)
                  : "quantity" === e.name
                  ? (o = e.value)
                  : "selling_plan" === e.name
                  ? (r.selling_plan = e.value)
                  : e.name.match(/^properties\[[\w-_ ]*\]$/)
                  ? (r[e.name] = e.value)
                  : void 0;
              }),
              i.Core.addItem(n, o, i.Utils.unwrapKeys(r))
            );
          },
          render: function (t, e) {
            var n;
            return (
              (n = {
                item_count: e.item_count,
                total_price: e.total_price,
                total_price_money: i.Utils.formatMoney(
                  e.total_price,
                  i.settings.moneyFormat,
                  "money_format",
                  null !=
                    ("undefined" != typeof Currency && null !== Currency
                      ? Currency.currentCurrency
                      : void 0)
                    ? Currency.currentCurrency
                    : void 0
                ),
                total_price_money_with_currency: i.Utils.formatMoney(
                  e.total_price,
                  i.settings.moneyWithCurrencyFormat,
                  "money_with_currency_format",
                  null !=
                    ("undefined" != typeof Currency && null !== Currency
                      ? Currency.currentCurrency
                      : void 0)
                    ? Currency.currentCurrency
                    : void 0
                ),
              }),
              jQuery("[data-cart-render]").each(function () {
                var t;
                return (t = jQuery(this)).html(n[t.attr("data-cart-render")]);
              })
            );
          },
        }),
        "undefined" != typeof rivets && null !== rivets
          ? ((i.Rivets = {
              model: null,
              boundViews: [],
              init: function () {
                return i.Rivets.bindViews();
              },
              destroy: function () {
                return i.Rivets.unbindViews();
              },
              bindViews: function () {
                return (
                  i.Utils.log("Rivets.js is present, binding views."),
                  i.Rivets.unbindViews(),
                  (i.Rivets.model = i.Utils.extend(
                    { cart: i.cart },
                    i.settings.rivetsModels
                  )),
                  null != window.Currency &&
                    (i.Rivets.model.Currency = window.Currency),
                  jQuery("[data-cart-view]").each(function () {
                    var t;
                    return (
                      (t = rivets.bind(jQuery(this), i.Rivets.model)),
                      i.Rivets.boundViews.push(t)
                    );
                  })
                );
              },
              unbindViews: function () {
                var t, e, n;
                for (t = 0, e = (n = i.Rivets.boundViews).length; e > t; t++)
                  n[t].unbind();
                return (i.Rivets.boundViews = []);
              },
            }),
            (rivets.formatters.eq = function (t, e) {
              return t === e;
            }),
            (rivets.formatters.includes = function (t, e) {
              return t.indexOf(e) >= 0;
            }),
            (rivets.formatters.match = function (t, e, i) {
              return t.match(new RegExp(e, i));
            }),
            (rivets.formatters.lt = function (t, e) {
              return e > t;
            }),
            (rivets.formatters.gt = function (t, e) {
              return t > e;
            }),
            (rivets.formatters.not = function (t) {
              return !t;
            }),
            (rivets.formatters.empty = function (t) {
              return !t.length;
            }),
            (rivets.formatters.plus = function (t, e) {
              return parseInt(t) + parseInt(e);
            }),
            (rivets.formatters.minus = function (t, e) {
              return parseInt(t) - parseInt(e);
            }),
            (rivets.formatters.times = function (t, e) {
              return t * e;
            }),
            (rivets.formatters.divided_by = function (t, e) {
              return t / e;
            }),
            (rivets.formatters.modulo = function (t, e) {
              return t % e;
            }),
            (rivets.formatters.prepend = function (t, e) {
              return e + t;
            }),
            (rivets.formatters.append = function (t, e) {
              return t + e;
            }),
            (rivets.formatters.slice = function (t, e, i) {
              return t.slice(e, i);
            }),
            (rivets.formatters.pluralize = function (t, e, n) {
              return (
                null == n && (n = e + "s"),
                i.Utils.isArray(t) && (t = t.length),
                1 === t ? e : n
              );
            }),
            (rivets.formatters.array_element = function (t, e) {
              return t[e];
            }),
            (rivets.formatters.array_first = function (t) {
              return t[0];
            }),
            (rivets.formatters.array_last = function (t) {
              return t[t.length - 1];
            }),
            (rivets.formatters.money = function (t, e) {
              return i.Utils.formatMoney(
                t,
                i.settings.moneyFormat,
                "money_format",
                e
              );
            }),
            (rivets.formatters.money_with_currency = function (t, e) {
              return i.Utils.formatMoney(
                t,
                i.settings.moneyWithCurrencyFormat,
                "money_with_currency_format",
                e
              );
            }),
            (rivets.formatters.weight = function (t) {
              switch (i.settings.weightUnit) {
                case "kg":
                  return (t / 1e3).toFixed(i.settings.weightPrecision);
                case "oz":
                  return (0.035274 * t).toFixed(i.settings.weightPrecision);
                case "lb":
                  return (0.00220462 * t).toFixed(i.settings.weightPrecision);
                default:
                  return t.toFixed(i.settings.weightPrecision);
              }
            }),
            (rivets.formatters.weight_with_unit = function (t) {
              return rivets.formatters.weight(t) + i.settings.weightUnit;
            }),
            (rivets.formatters.product_image_size = function (t, e) {
              return i.Utils.getSizedImageUrl(t, e);
            }),
            (rivets.formatters.moneyWithCurrency =
              rivets.formatters.money_with_currency),
            (rivets.formatters.weightWithUnit =
              rivets.formatters.weight_with_unit),
            (rivets.formatters.productImageSize =
              rivets.formatters.product_image_size))
          : (i.Rivets = { init: function () {}, destroy: function () {} }),
        (i.factory = function (t) {
          return (
            (t.init = i.init),
            (t.configure = i.configure),
            (t.cart = i.cart),
            (t.settings = i.settings),
            (t.getCart = i.Core.getCart),
            (t.addItem = i.Core.addItem),
            (t.addItems = i.Core.addItems),
            (t.updateItem = i.Core.updateItem),
            (t.updateItemById = i.Core.updateItemById),
            (t.updateItemQuantitiesById = i.Core.updateItemQuantitiesById),
            (t.removeItem = i.Core.removeItem),
            (t.removeItemById = i.Core.removeItemById),
            (t.clear = i.Core.clear),
            (t.getAttribute = i.Core.getAttribute),
            (t.setAttribute = i.Core.setAttribute),
            (t.getAttributes = i.Core.getAttributes),
            (t.setAttributes = i.Core.setAttributes),
            (t.clearAttributes = i.Core.clearAttributes),
            (t.getNote = i.Core.getNote),
            (t.setNote = i.Core.setNote),
            (t.render = i.Data.render)
          );
        }),
        "object" == typeof exports
          ? i.factory(exports)
          : "function" == typeof define && define.amd
          ? define(["exports"], function (t) {
              return i.factory((this.CartJS = t)), t;
            })
          : i.factory((this.CartJS = {}));
    }.call(this),
    (jQuery.cookie = function (t, e, i) {
      if (void 0 === e) {
        var n = null;
        if (document.cookie && "" != document.cookie)
          for (var r = document.cookie.split(";"), o = 0; o < r.length; o++) {
            var s = jQuery.trim(r[o]);
            if (s.substring(0, t.length + 1) == t + "=") {
              n = decodeURIComponent(s.substring(t.length + 1));
              break;
            }
          }
        return n;
      }
      (i = i || {}), null === e && ((e = ""), (i.expires = -1));
      var a,
        l = "";
      i.expires &&
        ("number" == typeof i.expires || i.expires.toUTCString) &&
        ("number" == typeof i.expires
          ? (a = new Date()).setTime(
              a.getTime() + 24 * i.expires * 60 * 60 * 1e3
            )
          : (a = i.expires),
        (l = "; expires=" + a.toUTCString()));
      var u = i.path ? "; path=" + i.path : "",
        c = i.domain ? "; domain=" + i.domain : "",
        d = i.secure ? "; secure" : "";
      document.cookie = [t, "=", encodeURIComponent(e), l, u, c, d].join("");
    });
}
